<template>
    <div class="chart-form-approval-container" style="justify-content: space-between; margin-top: 1em; height: 100%;">
        <!-- BEGINNING OF CHART -->
        <div class="chart-approval-only" :style="!displayDropDown ? { marginLeft: '-3px' } : {}"
            style="display: flex; flex-wrap: wrap; margin-bottom: 10px">
            <div :ref="'height-measurer' + parentIndex" :id="'height-measurer' + parentIndex"
                style="margin-right: 12px;">
                <div class="chart-form-container">
                    <div class="chart-form" :style="!displayDropDown ? { backgroundColor: 'transparent' } : {}">
                        <!-- displayDropDown is a conditional on whether to display the chart drop down, it is being used as defacto patient summary modal view conditional -->
                        <div class="zero-chart-row chart-row" v-if="displayDropDown || !activeSelectedChart">
                            <div class="first-chart-row-item chart-row-item"
                                style="display: grid !important; align-content: start; min-height: 40px;">
                                <p v-if="displayDropDown || !activeSelectedChart" style="text-align: left; margin-left: 20px; font-size: 1em;">
                                    Select Chart Type</p>
                                    
                                <Dropdown v-if="!viewOnly" v-model="selectedChart" :options="charts" 
                                    optionLabel="name" placeholder="Select Chart Type"
                                    style="margin-left: 9px; text-align: left;" id="selectchart"
                                    :style="selectedChart.color ? { backgroundColor: selectedChart.color } : ''"
                                    :class="selectedChart.color ? 'active-selected-chart' : ''" 
                                    @change="clearForm(), checkIfPRNOrInsulin(), assignFrequencyList()"
                                    />
                                <h3 v-else :style="selectedChart.color ? { backgroundColor: selectedChart.color } : ''"
                                    :class="selectedChart.color ? 'active-selected-chart' : ''"
                                    style="margin: 0; padding: 5px; border-radius: 8px; margin-left: 13px; text-align: left; color: white;">
                                    {{ selectedChart.name }}</h3>
                                <p style="color: red; font-weight: bold; text-align: left; font-size: 1em; margin-left: 20px;">Note: For nutritional supplements, please use the Nutritional Supplement chart.</p>
                                <!-- <div class="text-search-container search-container" style="display: flex; align-items: center">
                                    <input v-model="searchPatient" placeholder="Search Patient" style="position: relative; width: fit-content; margin-bottom: 5px" /> 
                                    <div style="cursor: pointer;" @click="searchForPatient(searchPatient)"><i class="pi pi-search" style="font-weight: bold"></i></div>
                                    <span v-if="prescription.patient">{{prescription.patient.first_name}}</span>
                                </div> -->
                                <!-- <div class="patient-search-results-container" v-if="patientSearchResults">
                                    <div class="individual-patient-container" v-for="(item, index) in patientSearchResults" :key="index" @click="selectPatient(item)">
                                        <div class="patient-result-image" style="width: 100px; height: 100px; background-color: salmon">
                                        </div>
                                        <div class="patient-result-info">
                                                <p v-if="item.personal_information"><b>Name:</b> {{item.personal_information.first_name}} {{item.personal_information.last_name}}</p>
                                                <p v-if="item.regulatory_information && item.regulatory_information.length"><b>Medicare Number:</b>  {{ item.regulatory_information[0].data.slice(0,4)}} {{item.regulatory_information[0].data.slice(4, 9)}} {{item.regulatory_information[0].data.slice(9)}}</p>
                                                <p><b>DOB:</b> {{item.personal_information && item.personal_information.dob ? item.personal_information.dob : ''}}</p>
                                                <p><b>Location:</b> {{item.physical_location && item.physical_location.location ? item.physical_location.location.name : ''}}</p>
                                        </div>
                                    </div>
                                    <div v-if="!patientSearchResults.length">
                                        <h4>No results found.</h4>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                        <div ref="first-chart-row" v-if="selectedChart" class="first-chart-row chart-row" style="width: 707px;">
                            <div class="first-chart-row-item chart-row-item"
                                :style="displayDropDown ? { minHeight: '60px' } : { minHeight: '43px' }"
                                style="display: flex !important; gap: 5px;">
                                <div style="padding-left: 10px; width: max-content;" v-if="displayDropDown">
                                    <SelectButton style="display: flex; height: 38px;" v-model="drugSearchFilter"
                                        :options="searchTypes" optionLabel="name" optionValue="value" @click="clearCustomMedForm()" />
                                </div>
                                <!-- MED SELECT OPTION -->
                                <div style="flex: 1; height: 100%; display: flex; align-items: center">
                                    
                                    
                                    <Dropdown
                                        id="prescription-med-search"
                                        v-if="displayDropDown"
                                        v-model="searchedDrugName"
                                        ref="med"
                                        @input="algoliaDrugSearch(searchedDrugName)"
                                        @change="drugSelect(searchedDrugName)"
                                        :loading="loadingDrugs"
                                        :options="formattedDrugList"
                                        optionLabel="full_name"
                                        :disabled="drugSearchFilter == 3"
                                        :editable="true"
                                        style="width: 100%; margin-right: 10px;"
                                    >
                                        <template #option="slotProps">
                                            <div>
                                                <b v-if="slotProps.option.generic_name">({{ slotProps.option.generic_name }})</b>
                                                <span v-if="slotProps.option.name !== slotProps.option.generic_name">
                                                    <span v-if="slotProps.option.generic_name"> &ndash; </span>
                                                    <i>{{ slotProps.option.name }}</i>
                                                </span>
                                            </div>
                                        </template>
                                    </Dropdown>
                                    
                                    <div v-else style="display: grid; grid-template-columns: 3fr 1fr 1fr; grid-gap: 20px; align-items: center; height: 100%; width: 100%; margin-bottom: 5px;">
                                        <div style="margin-top:-25px">
                                            <p  :style="dashboardRenew ? { marginLeft: '10px !important'}:{ marginLeft: '20px'}"
                                                style="text-align: left; margin-bottom: 5px; font-size: 1em; font-weight: 500"
                                                >
                                                Medication
                                            </p>
                                            <inputText id="medication-name-field"
                                                :value="!loadingDrugs ? selectedDrug.full_name ? selectedDrug.full_name : draftDrug ? draftDrug.name : 'Updating...' : ''"
                                                style="background-color: white; padding:5px 10px; border-radius: 6px; border: 1px solid #f3f4f4; display: flex; margin-left: 10px; width: 24em; font-weight: 600; color: #1e1e1e; opacity: 1;" disabled />
                                        </div>
                                        
                                        
                                        <!-- <MimsImage
                                            v-if="mimsApiKey"
                                            id="mims_image"
                                            :alias_id="draftDrug ? draftDrug.alias_id : ''"
                                            off_market="true"
                                            width="120px"
                                            height="100px"
                                            style="justify-self: center;"
                                            @mimsImageChanged="mimsImageChanged">
                                        </MimsImage>
                                        <button
                                            v-if="mimsApiKey"
                                            class="black-button"
                                            @click="displayCMIPIModal = true">
                                            View CMI/PI
                                        </button> -->
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            
                        </div>
                        <div class="chart-row prescription-chart" v-if="selectedChart && selectedDrug && (selectedDrug.drug_uuid || selectedDrug.alias_id)" style="margin-top: -18px; width: 707px;">
                            <div style="display: flex; flex-direction: column; gap: 5px; width: 100%;">
                                <div v-if="isInfusion" style="display: flex; align-items: center; background-color: #FEF3C7; color: #92400e; padding: 5px 10px; border-radius: 6px; margin: 0 10px 5px 10px; font-weight: 500;">
                                    <i class="pi-exclamation-triangle pi" style="margin-right: 8px;"></i>
                                    Infusion Detected: Additional Instructions template has been added to the notes.
                                </div>
                                <!-- Gated by WEIGHT_DOSING_HARD_BLOCK_ENABLED (see script) via
                                     weightDependentDrugBlockMessage - currently disabled since the backing drug
                                     list is a placeholder, not an authoritative clinical reference. -->
                                <div v-if="weightDependentDrugBlockMessage" style="display: flex; align-items: center; background-color: #fdecea; color: #E04F39; padding: 5px 10px; border-radius: 6px; margin: 0 10px 5px 10px; font-weight: 500;">
                                    <i class="pi pi-exclamation-triangle" style="margin-right: 8px;"></i>
                                    {{ weightDependentDrugBlockMessage }}
                                </div>
                                <p v-if="selectedCTPP" style="text-align: left; padding-left: 12px; font-size: 1em; margin-top: 0; font-weight: normal; color: #666;">Drug Pack: {{ selectedCTPP.name }}</p>
                                <div style="display: flex; align-items: center; gap: 10px; width: 100%; padding-left: 10px; padding-right: 10px; box-sizing: border-box;">
                                    <!-- CTTP (Pack) Selection -->
                                    <div style="display: flex; align-items: center; gap: 10px; width: 100%;">
                                        <Dropdown v-model="selectedCTPP" ref="ctppDropdown" @change="selectCTPP(selectedCTPP)" 
                                            @click="getAMTMeds()"
                                            @filter="onPackFilter"
                                            :options="ctppList" optionLabel="name"
                                            :loading="loadingDrugs" filter :resetFilterOnHide="false"
                                            class="ctpp-dropdown"
                                            style="flex: 1; width: 100%;" 
                                            placeholder="Select Pack" 
                                            id="ctpp-list" />
                                        
                                        <!-- Variant Selection (if multiple) -->
                                        <Dropdown v-if="selectedCTPP && selectedCTPP.drugs && selectedCTPP.drugs.length > 1" 
                                            class="ctpp-dropdown"
                                            style="flex: 1; width: 100%;"
                                            id="variant-list" placeholder="Select Variant" v-model="stock"
                                            :options="selectedCTPP.drugs" optionLabel="name" />
                                    </div>
                                        
                                    <!-- Single Variant Display -->
                                    <!-- <p v-if="selectedCTPP && selectedCTPP.drugs && selectedCTPP.drugs.length == 1" style="font-size: 1em; white-space: nowrap; margin: 0;">
                                        <b>Dispensing:</b> {{ stock ? stock.name : '' }}
                                    </p> -->
                                </div>
                            </div>
                        </div>
                        <!-- CUSTOM MED CREATION -->
                        <h3 v-if="drugSearchFilter == 3" style="margin: 0; text-align: left; padding-left: 20px;">Create Custom Medication</h3>
                        <div  v-if="drugSearchFilter == 3" class="chart-row prescription-chart" style="grid-column-start: 1; grid-column-end: 4; width: 707px;; display: grid;">
                            
                            <div class="chart-row-item"
                                style="width: fit-content; display: grid; grid-template-columns: 1fr 1fr 1fr 1fr; margin: 0 10px; padding: 5px 0; border-radius: 5px; background-color: #f3f4f4">
                                <div v-tooltip="'Medication Name'" style="grid-column-start:1; grid-column-end: 3">
                                    <p style="text-align: left; margin-left: 10px;">
                                        Full Name
                                    </p>
                                    <InputText style="min-width: 450px; width: 450px;"
                                        v-model="customMedication.concat_name"
                                        placeholder="e.g. Salicylic acid 5% in Aqueous Cream"
                                    />
                                </div>
                                <div v-tooltip="'Medication Name'" style="grid-column-start:4; grid-column-end: 5; margin-left: -40px;">
                                    <p style="text-align: left; margin-left: 10px;">
                                         Active Ingredient
                                    </p>
                                    <InputText style="min-width: 200px; width: 200px;"
                                        v-model="customMedication.name"
                                        placeholder="e.g. Salicylic acid"
                                    />
                                </div>
                                <div v-tooltip="'S8'">
                                    <p style="text-align: left; margin-left: 10px;">
                                        S8
                                    </p>
                                    <Dropdown
                                        id="s8-type"
                                        style="width: 150px"
                                        placeholder="Yes or No"
                                        :options="yes_or_no"
                                        optionValue="value"
                                        optionLabel="label"
                                        :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription')"
                                        v-model="custom_s8"
                                    />
                                </div>
                                <div v-tooltip="'Strength'">
                                    <p style="text-align: left; margin-left: 10px;">
                                        Strength
                                    </p>
                                    <InputText type="number" style="min-width: 150px; width: 150px;"
                                        v-model="customMedication.strength"
                                        placeholder="e.g. 9600"
                                    />
                                </div>
                                <div v-tooltip="'Form'">
                                    <p style="text-align: left; margin-left: 10px;">
                                        Form
                                    </p>
                                    <InputText style="min-width: 150px; width: 150px;"
                                        placeholder="e.g. cream"
                                        v-model="customMedication.form"
                                    />
                                </div>
                                <div v-tooltip="'Quantity'">
                                    <p style="text-align: left; margin-left: 10px;">
                                        Quantity
                                    </p>
                                    <InputText style="min-width: 150px; width: 150px;"
                                        v-model="customMedication.quantity"
                                        placeholder="e.g. 100g"
                                    />
                                </div>
                                <div v-tooltip="'Measurement Unit'">
                                    <p style="text-align: left; margin-left: 10px;">
                                        Measurement Unit
                                    </p>
                                    <div style="display: flex; align-items: flex-end">
                                        <InputText style="min-width: 150px !important; width: 150px !important;"
                                            v-model="customMedication.measurement_unit_1"
                                            placeholder="e.g. mg or mg/mL"
                                        />
                                    </div>
                                    
                                </div>
                            </div>
                            <div style="width: 98%; display: flex; align-items: center; justify-content: flex-end; margin-top: 10px;">
                                <div v-if="medicationSaveStatus" style="margin-right: 10px;">
                                    <Button class="outline-button p-button-outlined" :loading="medicationSaveStatus.includes('Saving')" :class="medicationSaveStatus == 'Medication saved!' ? 'p-button-success': medicationSaveStatus ? 'p-button-warning':''" v-if="medicationSaveStatus" :label="medicationSaveStatus" />
                                </div>
                                <button class="blue-button" @click="saveCustomMedication()" v-if="medicationSaveStatus != 'Medication saved!'">Save Medication</button>
                                <button class="grey-button" style="margin-left: 10px;" @click="drugSearchFilter = 0" v-if="medicationSaveStatus != 'Medication saved!'">Cancel</button>
                            </div>
                            <div style="width: 95%; height: 2px; background-color: #cdcdcd; margin: 0 auto; margin-top: 10px; margin-bottom: 20px;"></div>
                            
                        </div>
                        <!-- expansionFormat -->
                        <div v-if="selectedChart" class="chart-row prescription-chart"
                            :class="displayDropDown ? '' : ''" style="flex-wrap: wrap; width: 707px">
                            <!-- v-for="(item, index) in selectedChart.inputs" :key="index" -->
                            <div id="reason-input-container"
                                style="grid-column-start: 1; grid-column-end: 4; width: 707px;"
                                v-if="!displayDropDown && !dashboardRenew && selectedChart">
                                <div style="display: flex;">
                                    <p style="text-align: left; font-size: 1em; font-weight: 500; margin: 0; margin-left: 20px;">
                                        Prescription Type
                                    </p>
                                    <p style="text-align: left; font-size: 1em; font-weight: 500; margin: 0; margin-left: 80px;">
                                        Indication
                                    </p>
                                </div>
                                <div class="col-11 md:col-4">
                                    <div class="p-inputgroup" style="display: flex;">
                                        <Button @click="prescriptionType = 'private', pbsFilter = '', changePBSOption()" style="margin-left: 10px;
                                                border-top-right-radius: 0px !important;
                                                border-bottom-right-radius: 0px !important;
                                                height: 35px;"
                                            label='Private'
                                            :class="prescriptionType == 'private' ? 'blue-button':'p-button-secondary p-button-outlined'"
                                            :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                        />
                                        
                                        <Button
                                            @click="displayStreamlineCodeModal = true, prescriptionType = 'pbs/rpbs', pbsFilter = 'pbs', changePBSOption()"
                                            style="border-right: none;
                                                border-left: none;
                                                border-top-right-radius: 0px !important;
                                                border-bottom-right-radius: 0px !important;
                                                border-top-left-radius: 0px !important;
                                                border-bottom-left-radius: 0px !important;
                                                height: 35px;"
                                            :disabled="!(pbs_codes && pbs_codes.length) || !$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                            :label="loading_pbs ? 'Loading...': 'PBS/RPBS'" :class="prescriptionType == 'pbs/rpbs' ? 'blue-button':'p-button-secondary p-button-outlined'"
                                        />
                                        <inputText
                                            v-tooltip="'Indication'"
                                            placeholder="Select from PBS/RPBS list or type indication for private medication"
                                            style="min-width: 50%; width: 553px;  border: 1px solid #c3d4c3"
                                            :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                            v-model="form.prescription_payload.indication"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="valid-prescription-notes" v-if="!displayDropDown && !dashboardRenew && selectedChart"
                                style="margin-top: 0; padding-bottom: 0; background-color: transparent">
                                <div class="prescriber-options-container"
                                    :style="selected_pbs_code.restriction_flag == 'A' || form.prescription_payload.authority_prescription_number ? {} : { justifyContent: 'flex-start' }"
                                    style="align-items: self-end; margin-left: 0px; margin-top: 0; height: 53px;">
                                    <div :style="selected_pbs_code.restriction_flag == 'A' ? {} : {}" style="width: 25%">
                                        <p style="margin: 0; text-align: left; margin-left: 10px; font-size: 1em; font-weight: 500; "
                                            :style="selected_pbs_code.restriction_flag == 'A' || dashboardRenew ? { marginLeft: '10px' } : {}">
                                            PBS Code 
                                        </p>
                                        <InputText
                                            disabled
                                            style="width: 100%; border: 1px solid #ced4da;"
                                            :style="displayDropDown ? {backgroundColor: '#F3F4F4'}: dashboardRenew ? {marginLeft: '10px'}:{}"
                                            v-model="form.prescription_payload.pbs_code"
                                        />
                                        
                                    </div>
                                    
                                    <div v-if="form.prescription_payload.pbs_type && form.prescription_payload.pbs_type != ''" style="margin-left: 20px;width: 25%">
                                        <p style="margin: 0; text-align: left; margin-left: 10px; font-size: 1em; font-weight: 500; "
                                            :style="selected_pbs_code.restriction_flag == 'A' || dashboardRenew ? { marginLeft: '10px' } : {}">
                                            PBS Type 
                                        </p>
                                        
                                        <InputText
                                            disabled
                                            style="width: 100%; border: 1px solid #ced4da;"
                                            :style="displayDropDown ? {backgroundColor: '#F3F4F4'}: dashboardRenew ? {marginLeft: '10px'}:{}"
                                            :value="translatePbsType(form.prescription_payload.pbs_type)"
                                        />
                                    </div>
                                    <div
                                        v-if="(pbsFilter == 'pbs' || pbsFilter == 'rpbs') && (selected_pbs_code.restriction_flag == 'A' || form.prescription_payload.authority_prescription_number)" style="margin-left: 20px;width: 25%">
                                        <p style="margin: 0; text-align: left; margin-left: 15px; font-size: 1em; font-weight: 500; ">
                                            Authority Prescription Number
                                        </p>
                                        <InputText disabled style="width: 100%; border: 1px solid #ced4da"
                                            placeholder="Create Number"
                                            :style="displayDropDown ? { backgroundColor: '#F3F4F4' } : {}"
                                            v-model="form.prescription_payload.authority_prescription_number"
                                            @click="form.prescription_payload.authority_prescription_number ? '' : updatePBSPrescription()" />
                                    </div>
                                    <div
                                        :style="selected_pbs_code.restriction_flag == 'A' ? {} : { marginLeft: '20px' }" style="width: 25%">
                                        <div>
                                            <p style="margin: 0; text-align: left; margin-left: 10px; font-size: 1em; font-weight: 500; ">
                                                Approval Code <span v-if="form.prescription_payload.authority_prescription_number" style="color: red; font-size: 1em">*</span>
                                            </p>
                                        </div>
                                        <span class="p-input-icon-right">
                                            <!-- disableAll only locks this field once the script is signed. PatientMedicationTable
                                                 sets disableAll true for a prescriber on any authority script (pbs_type 'A'),
                                                 which is what locks the rest of the chart - but the approval code is obtained
                                                 after the script exists, by phoning PBS, and the chart cannot be signed without
                                                 it ("Authority scripts require an approval code in order to sign" below). While
                                                 the script is still a draft there was no way to enter or correct it. A signed
                                                 authority script stays locked, which is the intended behaviour. The permission
                                                 check applies either way. -->
                                            <InputText
                                                :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || (disableAll && !isDraft)"
                                                :style="displayDropDown ? {backgroundColor: '#F3F4F4'}:{}"
                                                style="width: 100%; border: 1px solid #ced4da;"
                                                type="text"
                                                v-model="form.prescription_payload.pbs_authority_code"
                                            />
                                        </span>
                                    </div>
                                    
                                </div>
                                <p style="font-size: 1em; color: red" v-if="form.prescription_payload.authority_prescription_number && !form.prescription_payload.pbs_authority_code">Authority scripts require an approval code in order to sign.</p>
                            </div>
                            
                            
                            
                            <div class="chart-row-item"
                                style="width: fit-content; display: grid; grid-template-columns: 1fr 1fr 1fr 1fr; min-width: 717px; margin-top: 7px;">
                                <div style="display: grid; " v-tooltip="'Start Date'" :style="dashboardRenew ? {backgroundColor: '#FED182', borderRadius: '4px', margin:'0 5px', paddingBottom: '5px'}:{}">
                                    <p
                                        style="text-align: left; margin-left: 20px; margin-bottom:5px;"
                                        :style="!selectedChart.inputs.includes('start_date') && !selectedChart.inputs.includes('datetime') ? { color: '#C8C8C8' } : ''"
                                    >
                                        Start Date
                                    </p>
                                    <Calendar
                                        id="startdateformat"
                                        @date-select="formatDate('start')"
                                        :disabled="((!selectedChart.inputs.includes('start_date') && !selectedChart.inputs.includes('datetime')) || !$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll) && !dashboardRenew"
                                        v-model="start_date"
                                        dateFormat="dd/mm/yy"
                                        placeholder="Start Date" />
                                </div>

                                <div style="display: grid;" v-tooltip="'Stop Date'"
                                    v-if="selectedChart.inputs.includes('stop_date') && selectedChart.chart_name != 'regular'"
                                    :style="dashboardRenew ? {backgroundColor: '#FED182', borderRadius: '4px', margin:'0 5px', paddingBottom: '5px'}:{}">
                                    <p style="text-align: left; margin-left: 20px; margin-bottom:5px;"
                                        :style="!selectedChart.inputs.includes('stop_date') ? { color: '#C8C8C8' } : ''">
                                        Stop Date
                                    </p>
                                    <Calendar
                                        id="stopdateformat"
                                        @date-select="formatDate('end')"
                                        v-model="stop_date"
                                        dateFormat="dd/mm/yy"
                                        placeholder="Stop Date"
                                        :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                    />
                                </div>

                                <div style="display: grid; " v-tooltip="'Prescription Date'">
                                    <p style="text-align: left; margin-left: 20px; margin-bottom:5px;">
                                        Created Date
                                    </p>
                                    <Calendar
                                        id="prescriptiondateformat"
                                        disabled
                                        v-model="date_added"
                                        dateFormat="dd/mm/yy"
                                        placeholder="Prescription Date"
                                    />
                                </div>
                                <!-- END DATE -->
                                <div v-tooltip="'Dose Unit'">
                                    <p style="text-align: left; margin-left: 20px; margin-bottom:5px;">
                                        Dose Unit
                                    </p>
                                    <Dropdown
                                        v-if="selectedChart.chart_name != 'insulin'"
                                        id="dose_unit-type"
                                        @input="algoliaDoseUnitSearch()"    
                                        placeholder="Select Dose Unit"
                                        :options="formattedDoseUnits"
                                        :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                        v-model="form.prescription_payload.dose_unit"
                                        @change="selectedChart.chart_name != 'stat' ? updateInstructions() : updateStatInstructions()"
                                        :editable="true"
                                        style="border: none !important; width: 160px; background-color: transparent"
                                    />
                                    <Dropdown v-if="selectedChart.chart_name == 'insulin'" :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll" id="dose_unit-type" placeholder="Select Dose Unit" :options="doseTypeInsulin"
                                        v-model="form.prescription_payload.dose_unit" @change="updateInstructions()" />
                                </div>


                                <div v-tooltip="'Route'">
                                    <p style="text-align: left; margin-left: 20px; margin-bottom:5px;">
                                        Route
                                    </p>
                                    <Dropdown v-if="selectedChart.chart_name != 'insulin'" id="route-type" placeholder="Select Route" :options="administrationTypes" :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                        v-model="form.prescription_payload.route" @change="selectedChart.chart_name != 'stat' ? updateInstructions() : updateStatInstructions()" />
                                    <Dropdown v-else id="route-type" placeholder="Select Route" :options="administrationInsulinTypes" :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                        v-model="form.prescription_payload.route" @change="updateInstructions()" />
                                </div>
                                <div v-tooltip="'Max Dose per Administration'"
                                    v-if="selectedChart.inputs.includes('max_admin')">
                                    <p style="text-align: left; margin-left: 10px;"
                                        :style="!selectedChart.inputs.includes('max_admin') ? { color: '#C8C8C8' } : ''">
                                        Max Per Admin Qty({{ form.prescription_payload.dose_unit }})
                                    </p>
                                    <input type="number" min="0" :disabled="!selectedChart.inputs.includes('max_admin') || !$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll" 
                                        v-model="form.prescription_payload.max_admin_dose" @change="updateInstructions()"/>
                                </div>

                                <div v-tooltip="'Max Dose in 24hrs'" v-if="selectedChart.inputs.includes('max_admin')">
                                    <p style="text-align: left; margin-left: 10px;"
                                        :style="!selectedChart.inputs.includes('max_24_dose') ? { color: '#C8C8C8' } : ''">
                                        24hr Max Dose
                                    </p>
                                    <InputText 
                                        :disabled="!selectedChart.inputs.includes('max_24_dose') || !$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                        v-model="form.prescription_payload.max_dose" />
                                </div>
                                <div v-tooltip="'Max X per day'" v-if="selectedChart.inputs.includes('max_admin')">
                                    <p style="text-align: left; margin-left: 10px;">
                                        Max times per day
                                    </p>
                                    <InputText 
                                        v-model="form.prescription_payload.max_times_per_day"
                                        :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                    />
                                </div>
                                <div v-tooltip="'Prescription Quantity'">
                                    <p style="text-align: left; margin-left: 20px;">
                                        Prescription Quantity
                                    </p>
                                    <input
                                        type="number"
                                        mode="decimal"
                                        min="0"
                                        :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                        v-model="form.prescription_payload.prescribed_quantity"
                                        @change="checkPrescribedQty()"
                                    />
                                </div>
                                <div v-tooltip="'Repeats'" v-if="(selectedChart && (selectedChart.name == 'Short Term Medicine' || selectedChart.chart_name == 'short_term')) || selected_pbs_code.restriction_flag == 'A' || (selectedDrug && selectedDrug.tags ? selectedDrug.tags.includes('s8') || (selectedDrug && selectedDrug.tags ? selectedDrug.tags.includes('S4NSW') : false )|| selectedDrug.tags.includes('S8') : false ) || (draftDrug && draftDrug.tags ? (draftDrug.tags.includes('S8') || draftDrug.tags.includes('s8')) : false) || form.prescription_payload.authority_prescription_number || custom_s8">
                                    <p style="text-align: left; margin-left: 20px;">
                                        Repeats
                                    </p>
                                    <input min="0" type="number" :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                            v-model="form.prescription_payload.num_repeats_authorised" @change="checkPrescribedQty()"/>
                                    <p style="font-size: 1em; color: red; margin-left: 20px; max-width: 300px; text-align: left;" v-if="s8RepeatsWarning">
                                        {{ s8RepeatsWarning }}
                                    </p>
                                </div>

                                <div v-tooltip="'Repeat Interval'" v-if="(selectedChart && (selectedChart.name == 'Short Term Medicine' || selectedChart.chart_name == 'short_term')) || selected_pbs_code.restriction_flag == 'A' || (selectedDrug && selectedDrug.tags ? selectedDrug.tags.includes('s8') || (selectedDrug && selectedDrug.tags ? selectedDrug.tags.includes('S4NSW') : false ) || selectedDrug.tags.includes('S8') : false ) || (draftDrug && draftDrug.tags ? (draftDrug.tags.includes('S8') || draftDrug.tags.includes('s8')) : false) || form.prescription_payload.authority_prescription_number || custom_s8">
                                    <p style="text-align: left; margin-left: 20px;">
                                        Repeat Interval (Days)
                                    </p>
                                    <!-- <InputNumber 
                                        :min="0"
                                        v-model="form.prescription_payload.repeat_interval"
                                        :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription')"
                                    /> -->
                                    <input min="0" type="number" :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                    v-model="form.prescription_payload.repeat_interval"/>
                                    
                                </div>
                                <!-- END OF INTERVAL -->
                            </div>
                            <div style="width: 100%; overflow: auto" v-if="error_message">
                                <p style="margin: 0 auto; font-size: 1em; color: red;">
                                    {{ displayMessage }}
                                    {{ displayMessage }}
                                </p>
                            </div>
                            <div style="width: fit-content;
                                    min-width: 697px;
                                    display: grid;
                                    flex-wrap: nowrap;
                                    grid-template-columns: 1fr 2fr 1fr;
                                    padding: 0px;
                                    background-color: #f3f4f4;
                                    border-radius: 4px;" class="chart-row-item"
                                :style="displayDropDown ? { margin: '10px 10px' } : dashboardRenew ? {marginLeft: '15px'} : {}">
                                <!-- DOSE -->
                                <!-- DOSE -->
                                <!-- DOSE -->
                                <div v-tooltip="'Dose'" v-if="selectedChart.chart_name != 'stat'">
                                    <p style="text-align: left; margin-left: 20px;"
                                    :style="selectedChart.chart_name == 'stat' ? { color: '#C8C8C8' } : ''">
                                        Quantity ({{ form.prescription_payload.dose_unit }})
                                    </p>
                                    <input
                                        type="number"
                                        min="0"
                                        v-model="form.prescription_payload.dose"
                                        @change="applyDoseToSchedule()"
                                        :disabled="this.form.prescription_payload.frequency.period == 'variable' || !$store.state.user.role.permissions.includes('can_sign_prescription') || selectedChart.chart_name == 'stat' || disableAll"
                                    />
                                </div>
                                <!--   FREQUENCY -->
                                <!--   FREQUENCY -->
                                <!--   FREQUENCY -->
                                <div id="frequency-type"
                                    style="display: grid; background-color: transparent !important; width: 47%;"
                                    class="chart-form-select" v-tooltip="'Frequency'" v-if="selectedChart.chart_name != 'stat'">
                                    <p style="text-align: left; margin-left: 10px;"
                                        :style="!selectedChart.inputs.includes('frequency') ? { color: '#C8C8C8' } : ''">
                                        Frequency
                                    </p>
                                    <Dropdown
                                        @change="updateDoseSchedule(true)"
                                        :disabled="!selectedChart.inputs.includes('frequency') || !$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll || isVariableMode"
                                        id="route-type"
                                        :placeholder="displayDropDown ? 'Select Frequency' : 'Change Frequency'"
                                        :options="selectedChart.chart_name == 'stat' ? statFrequency : frequencies" optionLabel="display_name"
                                        v-model="form.prescription_payload.frequency"
                                        style="text-align: left; margin-left: 0px; width: 100%;">
                                        <template #value="slotProps">
                                            <div v-if="slotProps.value && (slotProps.value.display_name || slotProps.value.frequency_name)">
                                                {{ slotProps.value.display_name || slotProps.value.frequency_name }}
                                            </div>
                                            <span v-else>
                                                {{ displayDropDown ? 'Select Frequency' : 'Change Frequency' }}
                                            </span>
                                        </template>
                                        <template #option="slotProps">
                                            <div>
                                                {{ slotProps.option.display_name || slotProps.option.frequency_name }}
                                            </div>
                                        </template>
                                    </Dropdown>
                                </div>

                                <!-- INTERVAL (Periodicity) -->
                                <div v-tooltip.bottom="`Interval - e.g. frequency set to 'Daily' at interval of 2 means every 2 days.`" v-if="selectedChart.chart_name != 'stat'">
                                    <p style="text-align: left; margin-left: 20px;"
                                        :style="!form.prescription_payload.frequency ? true : form.prescription_payload.days_of_week && form.prescription_payload.days_of_week.length ? true : false ? { color: '#C8C8C8' } : ''">
                                        Periodicity
                                    </p>
                                    <div style="display: flex; align-items: center; padding-left: 10px;">
                                        <p>Every</p>
                                        <InputNumber
                                            :min="0"
                                            class="dynamic-number-input"
                                            style="width: 65px"
                                            :disabled="(form.prescription_payload.days_of_week && form.prescription_payload.days_of_week.length ? true : false) || !$store.state.user.role.permissions.includes('can_sign_prescription') || selectedChart.chart_name == 'stat' || disableAll || isVariableMode"
                                            placeholder="Interval" v-model="form.prescription_payload.interval" />
                                        <p v-if="form.prescription_payload.frequency">
                                            {{ (form.prescription_payload.frequency.period || form.prescription_payload.frequency) == 'Daily' ||
                                            (form.prescription_payload.frequency.period || form.prescription_payload.frequency) == 'variable' || (form.prescription_payload.frequency.period || form.prescription_payload.frequency) == 'stat' ? 'day' :
                                            (form.prescription_payload.frequency.period || form.prescription_payload.frequency).slice(0, -2)
                                            }}/s
                                        </p>
                                    </div>
                                </div>

                                <!-- CONSOLIDATED CUSTOMIZATION & CALENDAR ROW -->
                                <div style="grid-column: 1 / span 3; padding: 5px 20px; text-align: left; display: flex; align-items: center; min-height: 50px;" 
                                     v-if="form.prescription_payload.frequency && selectedChart.chart_name != 'stat'">
                                    
                                    <!-- Customize Button (Visible when NOT in variable mode) -->
                                    <!-- The calendar lives in the DOSE SCHEDULE block below, which only renders for a
                                         chart type that declares a 'schedule' input. PRN is the one type that doesn't,
                                         so offering the button there switched the row to "Calendar Builder / Reset to
                                         Template" with nothing underneath it - no grid, and no way to enter one - while
                                         still flipping the chart into variable mode for submission. The Reset control
                                         below stays ungated so a chart already in variable mode can always get out. -->
                                    <Button v-if="!isVariableMode && selectedChart.inputs.includes('schedule')"
                                            label="Customize / Variable Dose"
                                            class="p-button-sm"
                                            @click="convertToVariableDose()"
                                            style="height: 32px; font-size: 0.9em; background-color: #0870DC; border: none; color: white; box-shadow: none; border-radius: 8px;" />

                                    <!-- Calendar Builder Controls (Visible when IN variable mode) -->
                                    <div v-if="isVariableMode" style="display: flex; align-items: center;">
                                        <p style="font-size: 1.1em; margin: 0; margin-right: 15px; font-weight: bold; color: #0870DC;">
                                            Calendar Builder
                                        </p>
                                        <Button icon="pi pi-plus" class="p-button-info p-button-sm" 
                                                @click="addWeek()" 
                                                v-tooltip="'Add Week'"
                                                style="width: 2.2rem; height: 2.2rem; margin-right: 10px; background-color: #0870DC; border: none; box-shadow: none;" />
                                        <Button icon="pi pi-minus" class="p-button-danger p-button-sm" 
                                                @click="removeWeek()" 
                                                v-tooltip="'Remove Last Week'"
                                                v-if="numWeeks > 1"
                                                style="width: 2.2rem; height: 2.2rem; margin-right: 15px; background-color: #E04E39; border: none; box-shadow: none;" />
                                        
                                        <Button label="Reset to Template"
                                                class="p-button-sm p-button-danger"
                                                @click="resetToTemplate()"
                                                style="height: 32px; font-size: 0.9em; background-color: #E04E39; border: none; box-shadow: none; border-radius: 8px;" />
                                    </div>
                                </div>
                                
                                <!-- DOSE SCHEDULE -->
                                <!-- DOSE SCHEDULE -->
                                <!-- && displayDropDown -->
                                <div style="grid-column-start: 1; grid-column-end: 4; border-radius: 4px; width: 97%; margin-left: 10px; margin-top: 10px;"
                                    v-if="selectedChart.inputs.includes('schedule') && (form.prescription_payload.frequency || (activePresChart && activePresChart.prescription_payload.frequency))">
                                    <p style="text-align: left; font-weight: 500; font-size: 1em; padding: 0; padding-left: 10px; padding-right: 10px;"
                                        v-if="form.prescription_payload.frequency && form.prescription_payload.frequency.period && form.prescription_payload.frequency.period.toLowerCase() == 'daily' && !(form.prescription_payload.frequency.frequency_name && form.prescription_payload.frequency.frequency_name.includes('Hourly'))
                                        && !(form.prescription_payload.frequency.frequency_name && form.prescription_payload.frequency.frequency_name.includes('2 Hourly')) && !(form.prescription_payload.frequency.frequency_name && form.prescription_payload.frequency.frequency_name.includes('3 Hourly')) && selectedChart.chart_name != 'stat'">
                                        Daily Time & Dose Quantity
                                    </p>
                                    <table class="schedule-table" style=" border: none; width: fit-content"
                                        v-if="form.prescription_payload.frequency && form.prescription_payload.frequency.period && (form.prescription_payload.frequency.period.toLowerCase() == 'daily' || form.prescription_payload.frequency.period == 'Monthly')&& form.prescription_payload.frequency != 'Weekly' && !(form.prescription_payload.frequency.frequency_name && form.prescription_payload.frequency.frequency_name.includes('1 Hourly'))
                                        && !(form.prescription_payload.frequency.frequency_name && form.prescription_payload.frequency.frequency_name.includes('2 Hourly')) && !(form.prescription_payload.frequency.frequency_name && form.prescription_payload.frequency.frequency_name.includes('3 Hourly')) && selectedChart.chart_name != 'stat'">
                                        <tbody>
                                            <tr>
                                                <th v-for="(item,index) in displayTimes" :key="index">
                                                    <input
                                                        :value="item.time"
                                                        @focus="captureTimeBeforeEdit(item)"
                                                        @change="commitTime(item, $event)"
                                                        :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                                        style="padding: 0; text-align: center;"
                                                        minlength="4"
                                                        maxlength="4"
                                                    />
                                                </th>
                                            </tr>
                                            <tr>
                                                <td v-for="(item,index) in displayTimes" :key="index">
                                                    <input
                                                        :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                                        style="padding: 0; padding-left: 5px" :class="item.qty ? 'blue-input': ''"
                                                        v-model="item.qty"
                                                        @change="updateInstructions()"
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <!-- STAT SCHEDULE -->
                                    <div v-if="selectedChart.chart_name == 'stat'" style="display: flex;">
                                        <div v-tooltip="'Date'">
                                            <p style="text-align: left; margin-left: 5px;">
                                                Commence Admin Date
                                            </p>
                                            <Calendar
                                                id="startdateformat"
                                                style="margin-left: -20px;"
                                                @date-select="formatDate('start')"
                                                :disabled="(!selectedChart.inputs.includes('start_date') && !selectedChart.inputs.includes('datetime')) ||
                                                 !$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                                v-model="statDoseTime[0].times[0].date"
                                                dateFormat="dd/mm/yy"
                                                placeholder="Commence Date" />
                                        </div>
                                        <div v-tooltip="'Time'">
                                            <p style="text-align: left; margin-left: 20px;">
                                                Admin Time
                                            </p>
                                            <input
                                                style="padding-left: 10px;"
                                                :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                                v-model="statDoseTime[0].times[0].time"
                                                @change="updateStatInstructions()"
                                            />
                                        </div>
                                        <div v-tooltip="'Quantity'">
                                            <p style="text-align: left; margin-left: 20px;">
                                                Quantity
                                            </p>
                                            <input
                                                style="padding: 10px; width: 4.5em !important;" 
                                                :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                                class="schedule-input"
                                                v-model="statDoseTime[0].times[0].qty"
                                                @change="updateStatInstructions()"
                                            />
                                        </div>
                                        
                                    </div>

                                    <!-- VERTICAL MULTI-WEEK SCHEDULE -->
                                    <div v-for="w in numWeeks" :key="w-1" style="margin-bottom: 30px;">
                                        <p style="text-align: left; font-weight: bold; margin-bottom: 10px; padding-left: 10px; color: #555; background: #e9ecef; padding: 5px 10px; border-radius: 4px; width: fit-content;"
                                           v-if="isVariableMode || (form.prescription_payload.frequency && form.prescription_payload.frequency.period == 'variable')">
                                            Week {{ w }}: {{ getWeekDates(w-1)[0].date }} - {{ getWeekDates(w-1)[6].date }}
                                        </p>
                                        <table
                                            v-if="readyToDisplaySchedule && form.prescription_payload.frequency && form.prescription_payload.frequency != '' && (isVariableMode || (form.prescription_payload.frequency.period && (form.prescription_payload.frequency.period.toLowerCase() != 'daily' || (activePresChart && activePresChart.prescription_payload.frequency == 'weekly')) 
                                            && selectedChart.chart_name != 'stat' && form.prescription_payload.frequency.period != 'Monthly'))"
                                            class="schedule-table" style=" border: none; margin-left: -6px;">
                                            <tbody>
                                                <tr>
                                                    <th style="width: 50px;">
                                                        <p
                                                            style="font-size: 1em; font-weight: 500; margin: 0; padding: 0; text-align: left; padding-left: 15px;">
                                                            Dose <br> Times
                                                        </p>
                                                    </th>
                                                    <th
                                                        v-for="(item, index) in weekly_schedule"
                                                        :key="index" style="width: 30px;" 
                                                        :style="((isVariableMode || (form.prescription_payload.frequency && form.prescription_payload.frequency.period == 'variable')) && !getWeekDates(w-1)[index].edit) ? {color: 'grey'} :{} "
                                                    >
                                                        {{item.day}} <br/>{{ (isVariableMode || (form.prescription_payload.frequency && form.prescription_payload.frequency.period == 'variable')) ? getWeekDates(w-1)[index].date.slice(0,5) : ''}} 
                                                    </th>
                                                </tr>
                                                <tr v-for="(p, i) in displayTimes" :key="i">
                                                    <th>
                                                        <input
                                                            style="padding: 0; padding-left: 5px;"
                                                            :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                                            :value="p.time"
                                                            minlength="4"
                                                            maxlength="4"
                                                            @focus="captureTimeBeforeEdit(p)"
                                                            @change="commitTime(p, $event, true)"
                                                        />
                                                    </th>
                                                    <td v-for="(item,index) in weekly_schedule" :key="index" >
                                                        <input
                                                            :disabled="((isVariableMode || (form.prescription_payload.frequency && form.prescription_payload.frequency.period == 'variable')) && !getWeekDates(w-1)[index].edit) || 
                                                            !$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                                            style="padding: 0; width: 4.5em !important;" 
                                                            class="schedule-input"
                                                            :id="`vcell-${w-1}-${item.day}-${p.time}`"
                                                            @input="customInputSchedule(`vcell-${w-1}-${item.day}-${p.time}`)"
                                                            
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <p v-if="timeValidationError" style="text-align: left; margin: 5px 0 0 10px; color: #E04F39; font-weight: bold; font-size: 0.9em;">
                                        <i class="pi pi-times-circle" style="margin-right: 5px;"></i>{{ timeValidationError }}
                                    </p>
                                </div>
                                <!-- DOSE SCHEDULE -->
                                <!-- DOSE SCHEDULE -->
                                
                            </div>
                             <!-- PRN SLIDING SCALE OPTION -->
                            <div v-if="displayPRNSliding" style="grid-column: 1 / span 3; padding-left: 20px; padding-right: 20px; display: flex; align-items: flex-start; flex-direction: column; margin-bottom: 15px; width: 100%; box-sizing: border-box;">
                                <div style="display: flex; align-items: center; width: 100%;">
                                    <Checkbox v-model="sliding" :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll" name="sliding" :binary="true" @change="sliding && (!form.prescription_payload.sliding_scale || !form.prescription_payload.sliding_scale.length) ? addSlidingTable() : ''" />
                                    <label for="sliding" style="margin-left:10px; font-weight: bold; margin-right: 15px;" :style="$store.state.user.role.permissions.includes('can_sign_prescription') ? {}:{color: '#cdcdcd'}">{{ isWarfarinOrINR ? 'Calculate dosages' : 'Include sliding scale' }}</label>
                                    
                                    <div v-if="sliding" style="display: flex; align-items: center; background: #e9ecef; border-radius: 4px; padding: 2px 8px;">
                                        <label style="margin-right: 10px; font-size: 0.9em;">Reading Type:</label>
                                        <Dropdown 
                                            :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                            v-model="slidingScaleType" 
                                            :options="slidingScaleTypes" 
                                            optionLabel="label" 
                                            @change="updateSlidingScaleType"
                                            style="height: 32px; display: flex; align-items: center; border: 1px solid #ccc;"
                                        />
                                    </div>
                                </div>
                                    <div v-if="isWarfarinOrINR && sliding" style="display: flex; flex-direction: column; width: 100%; margin-top: 10px; padding: 15px; background-color: #fffbdf; border: 1px solid #ffeeba; border-radius: 4px; box-sizing: border-box;">
                                        <div v-if="acknowledgedReading" style="display: flex; flex-direction: column; margin-bottom: 10px;">
                                            <span style="font-weight: bold; margin-bottom: 5px;">Acknowledged Reading: {{ acknowledgedReading.value }} {{ acknowledgedReading.unit }} (Date: {{ acknowledgedReadingDate }})</span>
                                        </div>
                                        <div v-if="!patient.latest_inr_reading" style="color: #856404; font-weight: bold; margin-bottom: 15px;">
                                            <p style="margin: 0;">
                                                <i class="pi pi-exclamation-triangle" style="margin-right: 5px;"></i>
                                                Warning: No INR reading found. Please obtain one before prescribing.
                                            </p>
                                        </div>
                                        <div v-else style="display: flex; flex-direction: column; margin-bottom: 10px;">
                                            <span style="font-weight: bold; margin-bottom: 5px;">Latest INR Reading: {{ patient.latest_inr_reading.value }} (Taken on: {{ patient.latest_inr_reading.created_at }}<template v-if="latestInrTakenForHumans">, {{ latestInrTakenForHumans }}</template>)</span>
                                            <div style="display: flex; align-items: center;">
                                                <Checkbox v-model="acknowledgeINR" :binary="true" inputId="ackINR" />
                                                <label for="ackINR" style="margin-left: 8px;">Acknowledge most recent INR reading</label>
                                            </div>
                                        </div>
                                        
                                        <!-- WARFARIN DOSING CALCULATOR -->
                                        <div style="margin-top: 5px; border-top: 1px solid #ffeeba; padding-top: 15px; width: 100%;">
                                            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
                                                <h5 style="margin: 0; font-size: 1.1em; color: #0870DC;">Warfarin Dosing Calculator</h5>
                                                <button class="action-button-main" @click="showRobertsModal = true" style="padding: 5px 15px; font-size: 0.9em;">
                                                    <i class="pi pi-table" style="margin-right: 5px;"></i> Roberts Initiation Protocol
                                                </button>
                                            </div>
                                            
                                            <!-- INPUTS ROW -->
                                            <div style="display: flex; flex-wrap: wrap; gap: 15px; margin-bottom: 15px; align-items: flex-end; width: 100%;">
                                                <div style="flex: 1; min-width: 90px; display: flex; flex-direction: column;">
                                                    <label style="font-size: 0.9em; font-weight: bold; margin-bottom: 5px; white-space: nowrap;">Weight (kg)</label>
                                                    <InputNumber v-model="dosingWeight" :minFractionDigits="0" :maxFractionDigits="2" style="width: 100%" inputStyle="width: 100%; box-sizing: border-box;" />
                                                </div>
                                                <div style="flex: 1; min-width: 90px; display: flex; flex-direction: column;">
                                                    <label style="font-size: 0.9em; font-weight: bold; margin-bottom: 5px; white-space: nowrap;">Age (years)</label>
                                                    <InputNumber v-model="dosingAge" style="width: 100%" inputStyle="width: 100%; box-sizing: border-box;" />
                                                </div>
                                                <div style="flex: 1; min-width: 90px; display: flex; flex-direction: column;">
                                                    <label style="font-size: 0.9em; font-weight: bold; margin-bottom: 5px; white-space: nowrap;">Height (cm)</label>
                                                    <InputNumber v-model="dosingHeight" :minFractionDigits="0" :maxFractionDigits="1" style="width: 100%" inputStyle="width: 100%; box-sizing: border-box;" />
                                                </div>
                                                <div style="flex: 1; min-width: 130px; display: flex; flex-direction: column;">
                                                    <label style="font-size: 0.9em; font-weight: bold; margin-bottom: 5px; white-space: nowrap;">Creatinine (µmol/L)</label>
                                                    <InputNumber v-model="dosingCreatinine" :minFractionDigits="0" :maxFractionDigits="2" style="width: 100%" inputStyle="width: 100%; box-sizing: border-box;" />
                                                </div>
                                                <div style="flex: 1.5; min-width: 180px; display: flex; flex-direction: column;">
                                                    <label style="font-size: 0.9em; font-weight: bold; margin-bottom: 5px; white-space: nowrap;">Target INR</label>
                                                    <div style="display: flex; align-items: center; gap: 5px; width: 100%;">
                                                        <InputNumber v-model="targetInrMin" :minFractionDigits="1" :maxFractionDigits="1" style="flex: 1; width: 100%;" inputStyle="width: 100%; min-width: 0; box-sizing: border-box;" placeholder="Min" />
                                                        <span style="font-weight: bold;">-</span>
                                                        <InputNumber v-model="targetInrMax" :minFractionDigits="1" :maxFractionDigits="1" style="flex: 1; width: 100%;" inputStyle="width: 100%; min-width: 0; box-sizing: border-box;" placeholder="Max" />
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <!-- CLINICAL CHECKBOXES ROW -->
                                            <div style="display: flex; flex-wrap: wrap; gap: 20px; margin-bottom: 20px; padding-left: 2px; align-items: center;">
                                                <div style="display: flex; flex-direction: column;">
                                                    <Dropdown v-model="dosingRace" :options="raceOptions" optionLabel="label" optionValue="value" placeholder="Select Biological Race" style="min-width: 250px; height: 35px; align-items: center; border-radius: 8px;" />
                                                </div>
                                                <div style="display: flex; align-items: center;">
                                                    <Checkbox v-model="hasMechanicalValve" :binary="true" inputId="mechValve" />
                                                    <label for="mechValve" style="margin-left: 8px; font-size: 0.9em; cursor: pointer;">Mechanical Valve</label>
                                                </div>
                                                <div style="display: flex; align-items: center;">
                                                    <Checkbox v-model="hasEnzymeInducer" :binary="true" inputId="enzymeInducer" />
                                                    <label for="enzymeInducer" style="margin-left: 8px; font-size: 0.9em; cursor: pointer;">Enzyme Inducer</label>
                                                </div>
                                                <div style="display: flex; align-items: center;">
                                                    <Checkbox v-model="hasAmiodarone" :binary="true" inputId="amiodarone" />
                                                    <label for="amiodarone" style="margin-left: 8px; font-size: 0.9em; cursor: pointer;">Amiodarone</label>
                                                </div>
                                            </div>

                                        <div style="display: flex; gap: 15px;">
                                            <div style="flex: 1; background: white; padding: 10px; border-radius: 4px; border: 1px solid #ccc;">
                                                <strong style="color: #0870DC; display: flex; align-items: center;">
                                                    2025 East Asian Ujjin Algorithm:
                                                    <a href="https://pmc.ncbi.nlm.nih.gov/articles/PMC12512375/" target="_blank" v-tooltip.top="'A simple formula for East Asian patients predicting the warfarin dose in atrial fibrillation: development, external validation, and model comparison (Thrombosis Journal, 2025). This is the primary study that derived and validated the formula utilizing age, weight, and serum creatinine to predict maintenance dosing and prevent empirical overdosing.'" style="color: inherit; text-decoration: none; --v-tooltip-width: 350px; font-weight: normal; line-height: 1.5; text-transform: none;">
                                                        <i class="pi pi-info-circle" style="margin-left: 5px; cursor: pointer;"></i>
                                                    </a>
                                                </strong>
                                                <div v-if="ujjinDose && isNaN(ujjinDose)" style="color: red; font-size: 0.9em; margin-top: 5px;">
                                                    <i class="pi pi-exclamation-circle" style="margin-right: 5px;"></i>{{ ujjinDose }}
                                                </div>
                                                <div v-else-if="ujjinDose !== null && !isNaN(ujjinDose)" style="font-size: 1.2em; font-weight: bold; margin-top: 5px;">
                                                    {{ ujjinDose }} mg/day
                                                </div>
                                                <div v-else style="color: grey; font-size: 0.9em; margin-top: 5px;">Pending valid inputs...</div>
                                            </div>
                                            
                                            <div style="flex: 1; background: white; padding: 10px; border-radius: 4px; border: 1px solid #ccc;">
                                                <strong style="color: #0870DC; display: flex; align-items: center;">
                                                    IWPC Western Clinical Algorithm:
                                                    <a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2813331/" target="_blank" v-tooltip.top="'Estimation of the Warfarin Dose with Clinical and Pharmacogenetic Data (New England Journal of Medicine, 2009). The International Warfarin Pharmacogenetics Consortium (IWPC) developed this linear regression model to safely predict maintenance dosing using age, height, weight, race, and concurrent interacting medications (amiodarone and enzyme inducers) when genotyping is unavailable.'" style="color: inherit; text-decoration: none; --v-tooltip-width: 350px; font-weight: normal; line-height: 1.5; text-transform: none;">
                                                        <i class="pi pi-info-circle" style="margin-left: 5px; cursor: pointer;"></i>
                                                    </a>
                                                </strong>
                                                <div v-if="iwpcDose !== null && !isNaN(iwpcDose)" style="font-size: 1.2em; font-weight: bold; margin-top: 5px;">
                                                    {{ iwpcDose }} mg/day
                                                </div>
                                                <div v-else style="color: grey; font-size: 0.9em; margin-top: 5px;">Pending valid inputs...</div>
                                            </div>
                                        </div>
                                        <div style="font-size: 0.85em; color: #666; font-style: italic; margin-top: 15px; text-align: center;">
                                            Note: The computed algorithms are provided as indicators only and are not intended as final clinical recommendations. The clinician must make their own judgment on what dosage is appropriate for the patient based on their complete clinical presentation.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- QP TEXT INTERACTIONS -->
                            <!-- <QPTextInteractions
                                style="margin: 10px; min-width: 697px;"
                                :patient-id="patientId"
                                :drug-uuid="selectedDrug.drug_uuid"
                                :drug-reference="draftDrug ? draftDrug.reference : ''"
                                :drug-company-id="this.draftDrug && this.draftDrug.company_id && !this.selectedDrug.company_id"
                            /> -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- 697px -->
            <div class="approval-container"
                style="margin-left: 10px; justify-content: space-between; height: fit-content; width: 707px; min-width: 400px"
                v-if="selectedChart">
                <div>
                    <p style="text-align: left; font-size: 1em; margin: 0; margin-top: 10px; margin-left: 10px; margin-bottom: 10px;">
                        Notes/Directions 
                        <Dropdown
                            id="dose_unit-type"
                            placeholder="Select Treatment Use"
                            :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                            :options="useOptions"
                            v-model="selectedUse"
                            @change="updateInstructions()"
                        />
                    </p>
                    <Textarea
                        v-tooltip="'Notes/Directions'"
                        :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription')"
                        style="min-width: 400px; width: 100%; min-height: 190px; height: 190px; border-bottom-left-radius: 8px; border-bottom-right-radius: 8px;"
                        placeholder="Notes/Directions"
                        :autoResize="true"
                        v-model="form.prescription_payload.notes"
                    />
                    <p style="text-align: left; margin: 0;margin-top: 10px; margin-left: 10px; font-size: 0.9em; font-weight: 500; margin-bottom: 5px">
                        Prescription Options
                    </p>
                    <div v-if="selectedChart"
                        style="display: flex; align-items: center; margin-bottom: 10px; flex-wrap: wrap;">
                        <div style="display: flex; align-items: center; ">
                            <ToggleButton
                                :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                v-model="form.prescription_payload.is_paper"
                                onLabel="Paper prescription"
                                offLabel="Paper prescription"
                                style="margin: 0; margin-bottom: 10px"
                            />
                        </div>
                        <div v-if="form.prescription_payload.is_paper" style="display: flex; align-items: center; padding-left: 1em; margin-bottom: 10px" >
                            <input
                                placeholder="Enter Prescription #"
                                :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                v-model="form.prescription_payload.paper_prescription_number"
                                :style="!displayDropDown ? {backgroundColor: 'white'}:{} "
                            />
                        </div>
                        <div style="display: flex; align-items: center; padding-left: 10px; margin-right: 10px; margin-bottom: 10px">
                            <ToggleButton
                                v-model="form.prescription_payload.substitution_not_permitted"
                                :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                onLabel="No brand substitution"
                                offLabel="No brand substitution"
                            />
                        </div>
                        <div style="margin-bottom: 10px">
                            <InputText
                                style="height: 37px; width:12em; border: 1px solid #ced4da;"
                                :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                :placeholder="authorisationReferenceNumberLabel"
                                type="text"
                                v-model="form.prescription_payload.permit_number"
                            />
                        </div>
                    </div>
                    <!-- ADMINISTRATION OPTIONS -->

                    <div>
                        <p
                            style="text-align: left; margin: 0; margin-left: 10px; font-size: 0.9em; font-weight: 500; margin-bottom: 5px">
                            Administration Options
                        </p>
                        <div style="display:grid; grid-template-columns: auto auto;">
                            <SelectButton
                                class="administration-select-buttons"
                                :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                v-model="selected_administration_options"
                                :options="administration_options"
                                optionLabel="label"
                                multiple
                            />
                            <Dropdown 
                            :disabled="disableAll"
                            v-model="selected_packing" 
                            :options="packing_options" 
                            optionLabel="label" 
                            placeholder="Pack type"  
                            style="margin-left: 6px;width:140px ;"
                            />

                        </div>
                    </div>
                    <!-- PRIVACY POLICY AND ASLR CONSENT -->
                    <div style="margin-top: 1em; display: grid; justify-content: flex-start; text-align: left; grid-gap: 10px; grid-template-columns: 1fr;">
                        <div class="field-checkbox">
                            <Checkbox
                                inputId="binary"
                                :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                v-model="form.prescription_payload.privacy_statement"
                                :binary="true"
                            />
                            <label for="binary" style="padding-left: 10px;">Privacy agreement (policy <a href="https://strongroom.ai/privacy-policy/" target="_blank">here</a>.)</label>
                        </div>

                        <div class="field-checkbox">
                            <Checkbox
                                inputId="binary"
                                :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                v-model="form.prescription_payload.aslr_consent"
                                :binary="true"
                            />
                            <label for="binary" style="padding-left: 10px;">Patient has exercised their choice to keep the information away from their ASL.</label>
                        </div>

                        <div class="field-checkbox">
                            <Checkbox
                                inputId="ctg"
                                :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                v-model="form.prescription_payload.ctg"
                                :binary="true"
                            />
                            <label for="ctg" style="padding-left: 10px;">CTG</label>
                        </div>

                        <div class="field-checkbox">
                            <Checkbox
                                inputId="is_extemp"
                                :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                v-model="form.prescription_payload.is_extemp"
                                :binary="true"
                            />
                            <label for="is_extemp" style="padding-left: 10px;">Is Extemporaneous</label>
                        </div>
                        <div class="field-checkbox" style="display: flex; align-items: flex-start; margin-top: 5px; flex-direction: column;">
                            <div style="display: flex; align-items: center; width: 100%;">
                                <div style="flex: 1; display: flex; align-items: center;">
                                    <Dropdown 
                                        v-model="form.prescription_payload.consent" 
                                        :options="availableConsents" 
                                        optionLabel="label" 
                                        optionValue="value"
                                        placeholder="Select Informed Consent"
                                        style="width: 250px"
                                        @update:modelValue="handleConsentSelection"
                                    />
                                    <div v-if="form.prescription_payload.consent && form.prescription_payload.consent !== 'new'" style="margin-left: 10px; display: flex; align-items: center; white-space: nowrap;">
                                        <i v-if="form.prescription_payload.consent.has_consented" class="pi pi-check-circle" style="color: green; margin-right: 5px;"></i>
                                        <i v-else class="pi pi-times-circle" style="color: red; margin-right: 5px;"></i>
                                        <span v-if="form.prescription_payload.consent.given_by || form.prescription_payload.consent.given_date || form.prescription_payload.consent.consent_type" style="font-weight: 500;">
                                            <span v-if="form.prescription_payload.consent.given_by">{{ form.prescription_payload.consent.given_by }}</span>
                                            <span v-if="form.prescription_payload.consent.given_date" style="margin: 0 5px;">| {{ form.prescription_payload.consent.given_date }}</span>
                                            <span v-if="form.prescription_payload.consent.consent_type" style="text-transform: capitalize; margin: 0 5px;">| {{ form.prescription_payload.consent.consent_type }} Consent</span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- NEW INLINED CONSENT FIELDS -->
                            <div v-if="form.prescription_payload.consent === 'new'" style="width: 100%; margin-top: 15px; padding: 15px; background: #f9f9f9; border-radius: 8px; border: 1px solid #ddd; display: flex; flex-direction: column; gap: 10px;">
                                <div style="display: flex; align-items: center;">
                                    <Checkbox id="new_has_consented" v-model="newConsent.has_consented" :binary="true" />
                                    <label for="new_has_consented" style="margin-left: 10px; font-weight: bold; cursor: pointer;">Informed Consent Given</label>
                                </div>

                                <div style="display: flex; flex-direction: column; gap: 5px;">
                                    <label style="font-size: 0.9em; font-weight: bold; text-align: left;">Consent Type</label>
                                    <Dropdown 
                                        v-model="newConsent.consent_type" 
                                        :options="consentTypeOptions" 
                                        optionLabel="label" 
                                        optionValue="value" 
                                        placeholder="Select Type" 
                                        style="width: 100%" 
                                    />
                                </div>

                                <div style="display: flex; flex-direction: column; gap: 5px;">
                                    <label style="font-size: 0.9em; font-weight: bold; text-align: left;">Given By</label>
                                    <InputText v-model="newConsent.given_by" placeholder="e.g. Patient, Power of Attorney" style="width: 100%" />
                                </div>

                                <div style="display: flex; flex-direction: column; gap: 5px;">
                                    <label style="font-size: 0.9em; font-weight: bold; text-align: left;">Given Date</label>
                                    <input type="date" v-model="newConsent.given_date" style="padding: 8px; border: 1px solid #ced4da; border-radius: 4px; width: 100%;" />
                                </div>
                                
                                <div style="display: flex; justify-content: flex-end; margin-top: 5px;">
                                    <Button label="Save Consent" class="p-button-sm p-button-success" @click="submitInlineConsent" style="height: 32px; font-size: 0.9em; background-color: #0870DC; border: none; font-weight: bold; color: white; box-shadow: none; border-radius: 8px;" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="sliding" style="padding: 10px;
                                border: 1px solid black;
                                margin: 10px 0;
                                border-radius: 5px;">
                        <h4  style="text-align: left; font-weight: normal; margin: 0">{{ slidingScaleType ? slidingScaleType.label : 'Sliding Scale' }}</h4>
                        <p v-if="isWarfarinOrINR" style="text-align: left; margin: 5px 0 10px; font-size: 0.85em; color: #856404;">
                            <i class="pi pi-exclamation-triangle" style="margin-right: 5px;"></i>
                            Readings outside the INR Min/Max range above are always flagged automatically to staff during administration.
                        </p>
                        <div style="grid-column-start: 1; grid-column-end: 4; margin-left: 10px; display: flex; align-items: center;"
                             class="schedule-table">

                            <table style="width: fit-content">
                                <tbody>
                                    <tr>
                                        <th></th>
                                        <th>{{ isWarfarinOrINR ? 'INR Min' : 'Min' }}</th>
                                        <td v-for="(item, index) in form.prescription_payload.sliding_scale" :key="index">
                                            <input
                                                :style="!displayDropDown ? {backgroundColor:'white', border:'1px solid #cdcdcd'}:{}"
                                                :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                                type="number"
                                                step="any"
                                                v-model="item.min"
                                            >
                                        </td>
                                    </tr>
                                    <tr>
                                        <th style="width: 50px; padding: 0 10px;">{{ isWarfarinOrINR ? 'INR' : (slidingScaleType ? slidingScaleType.label : 'BGL') }} Readings</th>
                                        <th>{{ isWarfarinOrINR ? 'INR Max' : 'Max' }}</th>
                                        <td v-for="(item, index) in form.prescription_payload.sliding_scale" :key="index">
                                            <input
                                                :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                                :style="!displayDropDown ? {backgroundColor:'white', border:'1px solid #cdcdcd'}:{}"
                                                type="number"
                                                step="any"
                                                v-model="item.max"
                                            >
                                        </td>
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <th style="padding: 0 10px;">{{ isWarfarinOrINR ? 'Dosage' : 'Amount' }}</th>
                                        <td v-for="(item, index) in form.prescription_payload.sliding_scale" :key="index">
                                            <input
                                                type="text"
                                                :disabled="!$store.state.user.role.permissions.includes('can_sign_prescription') || disableAll"
                                                :style="!displayDropDown ? {backgroundColor:'white', border:'1px solid #cdcdcd'}:{}"
                                                v-model="item.value">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style="display: flex;" v-if="$store.state.user.role.permissions.includes('can_sign_prescription') || !disableAll">
                                <p class="blue-button" v-if="form.prescription_payload.sliding_scale && form.prescription_payload.sliding_scale.length > 1"
                                style="padding: 5px 0; width: fit-content; margin: 0; margin-right: 10px;"
                                @click="removeSlidingTable()"><i class="pi pi-minus"></i></p>
                                <!-- INR only ever needs a single reading range (see isWarfarinOrINR guard in
                                     addSlidingTable) - hide the Add button once an INR scale already has its one band. -->
                                <p class="blue-button" v-if="!isWarfarinOrINR || !form.prescription_payload.sliding_scale || form.prescription_payload.sliding_scale.length < 1"
                                style="padding: 5px 0; width: fit-content; margin: 0; margin-right: 10px;"
                                @click="addSlidingTable()"><i class="pi pi-plus"></i></p>
                            </div>
                        </div>
                        <p v-if="slidingScaleValidationError" style="text-align: left; margin: 10px 0 0; color: #E04F39; font-weight: bold; font-size: 0.9em;">
                            <i class="pi pi-times-circle" style="margin-right: 5px;"></i>{{ slidingScaleValidationError }}
                        </p>
                    </div>

                    <!-- CREATE CHART PBS CONTAINER DISPLAYING AT THE END OF THE PRESCRIPTION -->
                    <div id="reason-input-container"
                        style="grid-column-start: 1; grid-column-end: 4; width: 100%; margin-top:20px;"
                        v-if="selectedChart && (displayDropDown || dashboardRenew)">
                        <div style="display: flex;">
                            <p style="text-align: left; margin: 0; margin-left: 20px;">
                                Prescription Type
                            </p>
                            <p style="text-align: left; margin: 0; margin-left: 80px;">
                                Indication
                            </p>
                        </div>
                        <div class="col-11 md:col-4">
                            <div class="p-inputgroup">
                                <Button @click="prescriptionType = 'private', pbsFilter = '', changePBSOption()" style="
                                        border-top-right-radius: 0px !important;
                                        border-bottom-right-radius: 0px !important;
                                        height: 35px;" label='Private'
                                    :class="prescriptionType == 'private' ? 'blue-button' : 'p-button-secondary p-button-outlined'" />
                                <Button @click="displayStreamlineCodeModal = true, prescriptionType = 'pbs/rpbs', pbsFilter = 'pbs', changePBSOption()"
                                    style="border-right: none;
                                        border-left: none;
                                        border-top-right-radius: 0px !important;
                                        border-bottom-right-radius: 0px !important;
                                        border-top-left-radius: 0px !important;
                                        border-bottom-left-radius: 0px !important;
                                        height: 35px;" :disabled="!indications_list.length || (disableAll && (!dashboardRenew && !indications_list.length))"
                                    :label="loading_pbs ? 'Loading...' : 'PBS/RPBS'"
                                    :class="prescriptionType == 'pbs/rpbs' ? 'blue-button' : 'p-button-secondary p-button-outlined'" />
                                <inputText v-tooltip="'Indication'"
                                    placeholder="Select from PBS/RPBS list or type indication for private medication"
                                    style="min-width: 50%; width: 553px;  border: 1px solid #c3d4c3"
                                    :disabled="!selectedChart.inputs.includes('indication') && !indications_list.length || disableAll"
                                    v-model="form.prescription_payload.indication" />
                            </div>
                        </div>
                    </div>
                    <div class="valid-prescription-notes" v-if="selectedChart && (displayDropDown || dashboardRenew)"
                        style="margin-top: 0; padding-bottom: 0; padding-left: 0px; background-color: transparent">
                        <div class="prescriber-options-container"
                            :style="selected_pbs_code.restriction_flag == 'A' || form.prescription_payload.authority_prescription_number ? {} : { justifyContent: 'flex-start' }"
                            style="align-items: self-end; margin-left: 0px; margin-top: 0;margin-right: 0; height: 53px;">
                            <div :style="selected_pbs_code.restriction_flag == 'A' ? {} : {}">
                                <p style="margin: 0; text-align: left; margin-left: 10px;"
                                    :style="selected_pbs_code.restriction_flag == 'A' ? { marginLeft: '20px' } : {}">
                                    PBS Code
                                </p>
                                <InputText disabled style="width:14em; border: 1px solid #ced4da;"
                                    :style="displayDropDown ? { backgroundColor: '#F3F4F4' } : {}"
                                    v-model="form.prescription_payload.pbs_code" />
                            </div>
                            <div
                                v-if="(pbsFilter == 'pbs' || pbsFilter == 'rpbs') && (selected_pbs_code.restriction_flag == 'A' || form.prescription_payload.authority_prescription_number)">
                                <p style="margin: 0; text-align: left; margin-left: 20px;">
                                    Authority Number
                                </p>
                                <InputText disabled style="width:14em; background-color: #F3F4F4"
                                    placeholder="Create Number"
                                    v-model="form.prescription_payload.authority_prescription_number"
                                    @click="form.prescription_payload.authority_prescription_number ? '' : updatePBSPrescription()" />
                            </div>
                            <div :style="selected_pbs_code.restriction_flag == 'A' ? {} : { marginLeft: '20px' }">
                                <div>
                                    <p style="margin: 0; text-align: left; margin-left: 10px;">
                                        Approval Code <span v-if="form.prescription_payload.authority_prescription_number" style="color: red; font-size: 1em">*</span>
                                    </p>
                                </div>
                                <span class="p-input-icon-right">
                                    <!-- :disabled="selected_pbs_code.restriction_flag != 'A'" -->
                                    <InputText 
                                        :style="displayDropDown ? { backgroundColor: '#F3F4F4' } : {}"
                                        style="width:14em; border: 1px solid #ced4da;" type="text"
                                        v-model="form.prescription_payload.pbs_authority_code" />
                                </span>
                            </div>
                        </div>
                        <p style="font-size: 1em; color: red" v-if="form.prescription_payload.authority_prescription_number && !form.prescription_payload.pbs_authority_code">Authority scripts require an approval code in order to sign.</p>
                    </div>
                </div>
                <div>
                    <div class="chart-approval" style="margin-top: 20px;" v-if="dashboardRenew">
                        <p class="blue-button" @click="cancelPrescription(), addedToReview = true"
                            v-if="(!addedToReview || !chartReview) && $store.state.user.role.permissions.includes('can_sign_prescription') && !renewingCancelledScript && !isCeased"
                            style="font-weight: bold; width:fit-content; margin-right: 10px; background-color: #E04E39 !important"
                            >
                            {{ activePresChart && activePresChart.prescription_payload.signed ? 'Cancel Rx' : 'Cancel Draft'
                            }}</p>
                        <p class="blue-button"
                            v-if="$store.state.user.role.permissions.includes('can_create_draft_prescription') && !phone_order && !isCeased"
                            @click="createChart(false, false)"
                            style="width:150px; margin-right: 10px; background-color: #EF9600 !important">
                            {{ 'Save Draft' }}
                        </p>
                        <p class="green-button" v-if="!phoneOrder && (isDraft || ((!addedToReview || !chartReview) && activePresChart && activePresChart.chart_payload.prescription_id && $store.state.user.role.permissions.includes('can_sign_prescription'))) && !isCeased"
                            :style="form.prescription_payload.authority_prescription_number && !form.prescription_payload.pbs_authority_code ? {backgroundColor: '#EF9600 !important'}:{}"
                            @click="submitRenewal()" >
                            {{ form.prescription_payload.authority_prescription_number ? (!form.prescription_payload.pbs_authority_code ? 'Save Draft':'Save Rx'):'Amend Rx' }}</p>
                        <p class="green-button" v-if="phoneOrder && $store.state.user.role.permissions.includes('can_sign_prescription')"
                            :style="form.prescription_payload.authority_prescription_number && !form.prescription_payload.pbs_authority_code ? {backgroundColor: '#EF9600 !important'}:{}"
                            @click="submitRenewal()" >
                            Sign Phone Order
                        </p>
                        
                    </div>
                    <div class="chart-approval" style="margin-top: 20px;"
                        v-if="selectedChart && !viewOnly && !dashboardRenew"
                        :style="displayDropDown ? '' : { justifyContent: 'flex-start', marginTop: '10px' }">
                        <p class="blue-button"
                            v-if="(activePresChart && activePresChart.chart_payload && activePresChart.chart_payload.prescription_id && last_administration && activePresChart.prescription_payload.signed)"
                            @click="showAdminHistory()" style="font-weight: bold; margin-right: 10px; display: flex; align-items: center;"
                            :style="last_administration.quantity ? {}: {backgroundColor: '#cdcdcd !important', cursor: 'inherit'}">
                            Admin History
                        </p>
                        <p class="blue-button"
                            v-if="form.prescription_payload.dose_times && activePresChart" style="font-weight: bold; margin-right: 10px;"
                            @click="displayScheduledDoseTimesModal = true" >
                            Admin Schedule
                        </p>
                        <p class="blue-button" @click="displayCancelReasonModal = true"
                            v-if="/*!phoneOrder and otherwise phone orders run indefinitely*/ (!addedToReview || !chartReview) && ($store.state.user.role.permissions.includes('can_cancel_prescription')) && this.$store.state.user.type == 'prescriber' && !expired && !isCeased"
                            style="font-weight: bold; width:fit-content; margin-right: 10px; background-color: #E04E39 !important">
                            {{ activePresChart && activePresChart.prescription_payload.signed ? 'Cancel Rx' : 'Cancel Draft'
                            }}</p>
                        <p class="blue-button" @click="dismissPrescription()"
                            v-if="/*!phoneOrder && otherwise phone orders run indefinitely*/ (!addedToReview || !chartReview) && ($store.state.user.role.permissions.includes('can_cancel_prescription')) && (this.$store.state.user.type == 'prescriber' || $store.state.user?.role?.permissions?.includes('can_dismiss_expired_charts')) && expired && !isCeased"
                            style="font-weight: bold; width:fit-content; margin-right: 10px; background-color: #E04E39 !important">
                            Dismiss Rx</p>
                         <p class="blue-button" @click="cancelPrescription(), addedToReview = true"
                            v-if="(!addedToReview || !chartReview) && ($store.state.user.role.permissions.includes('can_cancel_prescription') && !activePresChart?.prescription_payload?.signed) && this.$store.state.user.type != 'prescriber' && !isCeased"
                            style="font-weight: bold; width:fit-content; margin-right: 10px; background-color: #E04E39 !important">
                            Cancel Draft</p>
                        <!-- <p class="blue-button"
                            v-if="(form.signatures && form.signatures.length) && $store.state.user.role.permissions.includes('can_sign_prescription')"
                            @click="createChart(true, false)" style="font-weight: bold; margin-right: 10px; ">Disable
                            Prescription</p> -->
                        <p class="blue-button"
                            v-if="( !phoneOrder && !addedToReview && (chartReview && form.prescription_payload.authority_prescription_number? false :  true) && (isDraft || (activePresChart && !activePresChart.prescription_payload.signed) || !activePresChart)) && (activePresChart && !activePresChart.prescription_payload.signed ? $store.state.user.role.permissions.includes('can_edit_draft_prescription') : $store.state.user.role.permissions.includes('can_create_draft_prescription')) && !isCeased"
                            @click="activePresChart || form.prescription_payload.authority_prescription_number ? updateChart(false) : createChart(false, false), chartReview ? addedToReview = true: ''"
                            style="width:150px; margin-right: 10px; background-color: #EF9600 !important">
                            {{ activePresChart || form.prescription_payload.authority_prescription_number ? 'Update Draft' : 'Save Draft' }}
                        </p>
                        
                        <p class="green-button"
                            v-if="!expired && !isCeased && (!isDraft && !displayDropDown && ((!phoneOrder || (!phoneOrder && !disableAll)) && (!addedToReview || !chartReview) && $store.state.user.type == 'prescriber' 
                            && ((activePresChart && ((!activePresChart?.prescription_payload?.authority_prescription_number && !activePresChart?.prescription_payload?.pbs_authority_code ) || 
                            (activePresChart?.prescription_payload?.pbs_authority_code && (activePresChart?.prescription_payload?.pbs_type == 'S')))) || 
                            editingPrescription)  && $store.state.user.role.permissions.includes('can_sign_prescription') && $store.state.user.type == 'prescriber'))"
                            @click="((((( activePresChart?.prescription_payload?.authority_prescription_number || form.prescription_payload.authority_prescription_number  ) && form.prescription_payload.pbs_authority_code)) && form.chart_payload.prescription_id))  ? updateChart(true) : createChart(true, true), chartReview ? addedToReview = true: '' " >
                            {{ chartReview ? 'Save Changes' : expired ? 'Renew Rx' : 'Amend Rx' }}
                        </p>
                        <p class="green-button"
                            v-if="(expired || isCeased) && activePresChart?.prescription_payload.pbs_type != 'A' && activeSelectedChart?.chart_name != 'intermittent' && $store.state.user.type == 'prescriber'"
                            @click="((((( activePresChart?.prescription_payload?.authority_prescription_number || form.prescription_payload.authority_prescription_number  ) && form.prescription_payload.pbs_authority_code)) && form.chart_payload.prescription_id))  ? updateChart(true) : createChart(true, true), chartReview ? addedToReview = true: '' " >
                            Renew Rx
                        </p>
                        <p class="green-button"
                            v-if="isDraft && chartReview && ((!phoneOrder || (!phoneOrder && !disableAll)) || expired && (!addedToReview || !chartReview) && $store.state.user.type == 'prescriber'  && !isCeased
                            && ((activePresChart && ((!activePresChart?.prescription_payload?.authority_prescription_number && !activePresChart?.prescription_payload?.pbs_authority_code) || 
                            (activePresChart?.prescription_payload?.pbs_authority_code && !activePresChart?.prescription_payload?.authority_prescription_number))) || 
                            editingPrescription)  && $store.state.user.role.permissions.includes('can_sign_prescription'))"
                            @click="((((( activePresChart?.prescription_payload?.authority_prescription_number || form.prescription_payload.authority_prescription_number  ) && form.prescription_payload.pbs_authority_code)) && form.chart_payload.prescription_id))  ? updateChart(true) : createChart(true, true), chartReview ? addedToReview = true: '' " >
                            {{ chartReview ? 'Save Changes' : '' }}
                        </p>
                        <!-- Signed phone orders should not allow the opportunity to sign again. -->
                        <p class="green-button"
                            v-if="phoneOrder && !disableAll && $store.state.user.type == 'prescriber'  && $store.state.user.role.permissions.includes('can_sign_prescription') && !prescriberSigned && !isCeased"
                            @click="signOffPhoneOrder()">
                            Sign Phone Order
                        </p>
                        
                        <p class="blue-button"
                            v-if="!isDraft && !addedToReview && chartReview && !form.prescription_payload.authority_prescription_number && activePresChart.chart_payload.prescription_id && $store.state.user.role.permissions.includes('can_sign_prescription') && !isCeased"
                            @click="addIDToReview(), addedToReview = true" style="font-weight: bold; margin-left: 10px;">
                            Continue Unchanged Rx
                        </p>
                        
                        <!-- <button class="blue-button"
                            v-if="!isDraft && addedToReview && chartReview && activePresChart.chart_payload.prescription_id && $store.state.user.role.permissions.includes('can_sign_prescription')"
                            @click="addedToReview = false"
                            style="font-weight: 500; margin-left: 10px;">Remove from Review
                        </p> -->
                        <p class="green-button"
                            v-if="!phoneOrder && $store.state.user.type == 'prescriber' && !chartReview && !editingPrescription && !isCeased  
                            && ((form.prescription_payload.pbs_authority_code) 
                            || ((isDraft && (form.prescription_payload.pbs_authority_code && form.prescription_payload.authority_prescription_number)) 
                            || ((isDraft || !activePresChart) && (!form.prescription_payload.pbs_authority_code && !form.prescription_payload.authority_prescription_number)) 
                            || (!form.chart_payload.prescription_id && (activePresChart && activePresChart.chart_payload.prescription_id && (form.prescription_payload.pbs_authority_code) ? true : false)))) 
                            && (!activePresChart || (activePresChart && !activePresChart.prescription_payload.signed)) 
                            && $store.state.user.role.permissions.includes('can_sign_prescription')"
                            @click="activePresChart || form.chart_payload.prescription_id ? updateChart(true) : initateChartCreation()"
                            style="font-weight: bold; margin: 0;">
                            Save & Approve Chart
                        </p>
                        <p class="green-button"
                            v-if="($store.state.user.type == 'nurse' || $store.state.user.type == 'clinician') && selectedChart.chart_name != 'regular' && !chartReview
                            && (!activePresChart || (activePresChart && !activePresChart.prescription_payload.signed)) 
                            && $store.state.user.role.permissions.includes('can_sign_prescription') && !isCeased"
                            @click="confirmPhoneOrder()"
                            style="font-weight: bold; margin: 0;">
                            Sign As Phone Order
                        </p>
                        
                    </div>
                </div>

            </div>
        </div>
        <!-- END OF CHART -->



        <SignatureModal
            v-if="displaySignatureModal"
            :payload="payload"
            @close="close"
            :endpoint="endpoint"
            :signatureType="signatureType"
            @error="handleSignatureError"
        />
        <StreamlineCodeModal
            v-if="displayStreamlineCodeModal"
            :streamlineOptions="indications_list"
            @close="close"
            @confirmCode="confirmCode"
        />
        <PBSAlertModal
            ref="pbsalert"
            v-if="displayPBSAlertModal && selected_pbs_code"
            :exceededQty="form.prescription_payload.prescribed_quantity > selected_pbs_code.max_quantity"
            :authCode="form.prescription_payload.authority_prescription_number"  
            :patient="patient"
            :dashboardRenew="dashboardRenew"
            :medicare="medicare && medicare.data ? medicare.data : 'NO MEDICARE'"
            :hasAuthCode="hasAuthCode"
            :pbsCode="selected_pbs_code"
            @updatePrescriptionQuantityAndRepeats="updatePrescriptionQuantityAndRepeats" 
            @passAuthCode="passAuthCode"
            @passPhoneCode="passPhoneCode"
            :streamlineOptions="selected_pbs_code"
            @close="closePBSModal"
            @revertQtyUpdate="revertQtyUpdate" 
            :instructions="form.prescription_payload.notes"
        />
        <!-- :loadingDelay="loadingDelay" -->
        <SuccessModal :loading="loading" @stopAction="stopAction" @successfullySubmitted="successfullySubmitted"
            @close="close" v-if="(displaySuccessModal || signFromMedicationChartRow) && !displayPhoneOrderModal" :action="signature"
            actionType='sign' :calculated_stop_date="calculated_stop_date" :noAuthRequired="!scheduledMedicine && !custom_s8 && !form.prescription_payload.authority_prescription_number" :payload="prescriptionSignPayload"
            :statusMessage="'Prescription Action'" :first_spec_line="displayMessage" :second_spec_line="displayMessage2" @cancelDraft="cancelDraft"
            signature_endpoint="/prescription/sign" @backToEdit="backToEdit" @closeSuccess="closeSuccess" :closeOnRenew="dashboardRenew ? true: false" :adminSchedule="adminSchedule"
            :displayFirstDose="true" :doNotReload="renewExpired" :forceCeaseRequired="forceCeaseRequired" :dismissRequired="dismissRequired" :forceCreateRequired="forceCreateRequired" :dismissLoading="dismissLoading" :forceCreateLoading="forceCreateLoading" @forceCease="cancelPrescription(true)" @dismiss="dismissChart" @forceCreate="forceCeaseAndCreate" />
        <SuccessModal v-if="displayErrorModal && IHICheck" :first_spec_line="errorMessage"   :statusMessage="'IHI Error'"
            @close="closeError" :closeOnRenew="dashboardRenew ? true: false" @closeSuccess="closeSuccess"
            :forceCeaseRequired="forceCeaseRequired" :dismissRequired="dismissRequired" :forceCreateRequired="forceCreateRequired" :dismissLoading="dismissLoading" :forceCreateLoading="forceCreateLoading" @forceCease="cancelPrescription(true)" @dismiss="dismissChart" @forceCreate="forceCeaseAndCreate" />
        <!-- A modal for any other generic warnings -->
        <SuccessModal v-if="displayErrorModal" :first_spec_line="errorMessage" :statusMessage="errorTitle"
            @close="closeError" @closeSuccess="closeSuccess" 
            :forceCeaseRequired="forceCeaseRequired" :dismissRequired="dismissRequired" :forceCreateRequired="forceCreateRequired" :dismissLoading="dismissLoading" :forceCreateLoading="forceCreateLoading" @forceCease="cancelPrescription(true)" @dismiss="dismissChart" @forceCreate="forceCeaseAndCreate" />
        <SuccessModal v-if="displayPhoneOrderModal" :first_spec_line="displayMessage2" :phone_order="true" @updateSelectedPrescriber="updateSelectedPrescriber" :action="signature" actionType='sign' :statusMessage="'Prescription Action'" signature_endpoint="/prescription/phone-sign"
            @close="close" :closeOnRenew="dashboardRenew ? true: false" @closeSuccess="closeSuccess" :prescribers="patient?.prescribers ? patient?.prescribers : []" :payload="prescriptionSignPayload" @backToEdit="backToEdit"
            :signPhoneOrder="signPhoneOrder" @createPhoneOrder="createPhoneOrder" @successfullySubmitted="successfullySubmitted" />
        <ScheduledDoseTimesModal v-if="displayScheduledDoseTimesModal" :uuid="activePresChart?.chart_payload?.prescription_id" :dose_times="form.prescription_payload.dose_times" :dose_unit="form.prescription_payload.dose_unit"
        @close="closeDoseTimes" />
        <!-- <CMIPIModal ref="cmiPiModal" v-if="displayCMIPIModal" :drug="draftDrug" off_market="true" :mimsImage="mimsImage"
            @close="closeCMICP" /> -->
        <PatientAdministrationSummaryModal v-if="displayPatientAdministrationSummaryModal" @close="closeAdminHistory" :prn="activeSelectedChart?.chart_name == 'prn' ? true : false" :admin_history="administration_history" 
        :prescription_id="activePresChart && activePresChart.chart_payload && activePresChart.chart_payload.prescription_id ? activePresChart.chart_payload.prescription_id : '' " />
        <PrescribingQuestionnaire v-if="displayQuestionnaire" @bubbleQestions="setQ" @continue="close(); createChart(true, false);"  @close="close"/>
        
        <RobertsProtocolModal 
            v-if="showRobertsModal" 
            :initial-age="dosingAge" 
            @close="showRobertsModal = false" 
        />
        
        <!-- Brand Confirmation Modal -->
        <div class="modal-mask" v-if="displayBrandPrompt">
            <div class="modal-wrapper">
                <div class="modal-container" style="width: 30%">
                    <div class="modal-header">
                        <h3 class="form-header">Confirm Brand Selection</h3>
                        <button @click="confirmBrand(false)" class="red-close-button">
                            <i class="pi pi-times" style="padding: 0"></i>
                        </button>
                    </div>
                    <div class="modal-body" style="padding: 20px; text-align: center;">
                        <p style="font-size: 1.1em; margin-bottom: 20px;">
                            You have selected a brand name medication (<b>{{ pendingDrugItem ? pendingDrugItem.full_name : '' }}</b>). 
                            Is this brand clinically necessary for the patient?
                        </p>
                    </div>
                    <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 5px 20px; gap: 10px;">
                        <button class="grey-button" @click="confirmBrand(false)">No</button>
                        <button class="green-button" @click="confirmBrand(true)">Yes</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Allergy Cross-Check Warning Modal -->
        <ConfirmationModal
            v-if="displayAllergyWarningModal"
            :actionDescription="allergyWarningMessage"
            acceptText="Continue"
            rejectText="Cancel Selection"
            @close="cancelAllergySelection"
            @accepted="acknowledgeAllergyWarning"
        />

        <!-- Cancellation Reason Modal -->
        <div class="modal-mask" v-if="displayCancelReasonModal">
            <div class="modal-wrapper">
                <div class="modal-container" style="width: 30%">
                    <div class="modal-header">
                        <h3 class="form-header">Cancel Prescription</h3>
                        <button @click="closeCancelReasonModal" class="red-close-button">
                            <i class="pi pi-times" style="padding: 0"></i>
                        </button>
                    </div>
                    <div class="modal-body" style="padding: 20px;">
                        <p style="font-size: 1.1em; margin-bottom: 10px;">
                            Please provide a reason for cancelling this prescription (optional).
                        </p>
                        <textarea v-model="cancelReason" rows="4" style="width: 100%;" placeholder="Reason for cancellation"></textarea>
                    </div>
                    <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 5px 20px; gap: 10px;">
                        <button class="grey-button" @click="closeCancelReasonModal">Back</button>
                        <button class="green-button" @click="confirmCancelWithReason">Continue</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios';
import { searchIndex } from '@/services/algoliaSearch';
import { applyTallmanLettering, applyTallmanToPack } from '@/services/TallmanLettering';
import { isWeightDependentDrug } from '@/services/WeightDependentDrugs';
import { isAllergyTextMatch } from '@/services/allergyMatch';
import { isVariableValue, isVariableFrequency, findVariableFrequency } from '@/services/frequencies';
import SignatureModal from './modals/SignatureModal.vue';
import SuccessModal from './modals/SuccessModal.vue';
import StreamlineCodeModal from './modals/StreamlineCodeModal.vue';
import PBSAlertModal from './modals/PBSAlertModal.vue';
import PatientAdministrationSummaryModal from './modals/PatientAdministrationSummaryModal.vue';
// import QPTextInteractions from './qualitypharma/QPTextInteractions.vue';
import MimsImage from './mims/MimsImage.vue';
import CMIPIModal from './mims/CMIPIModal.vue';
import ScheduledDoseTimesModal from './modals/ScheduledDoseTimesModal.vue';
import PrescribingQuestionnaire from './modals/PrescribingQuestionnaire.vue';
import RobertsProtocolModal from './modals/RobertsProtocolModal.vue';
import ConfirmationModal from './modals/ConfirmationModal.vue';
import { isLmbc, isLemi } from '../utils/compliance_lists.js';
import { diffForHumans } from '../services/dates';

import { sortMedicationList } from '../services/SortMedicationList';

// Weight-based dosing hard block: the drug list backing this check (WeightDependentDrugs.js)
// is a placeholder, not an authoritative clinical reference, so the hard block (banner +
// submit-time validation, both driven by weightDependentDrugBlockMessage below) is disabled
// via this single flag rather than commenting out each consumer individually - that pattern
// is easy to half-revert/forget and doesn't self-document why it's off. Flip this back to
// `true` once a proper government/TGA-sourced list is in place; nothing else needs to change.
// The underlying isWeightDependentDrugSelected/dosingWeight pre-population stay active
// regardless, since dosingWeight also feeds CrCl/Cockcroft-Gault-style dosing calculations
// independent of this block.
const WEIGHT_DOSING_HARD_BLOCK_ENABLED = false;

// Serum creatinine unit conversion. Australian pathology labs report creatinine in µmol/L and
// that is what the app captures and stores (the `creatinine` entry in ReadingPanel's
// readingPanels.js), but the published warfarin dosing algorithm in ujjinDose() is defined
// against mg/dL. 1 mg/dL = 88.4 µmol/L.
const MICROMOL_PER_L_TO_MG_PER_DL = 88.4;

export default {
    props: ['patientId', 'patient', 'activePresChart', 'activeSelectedChart', 'draftDrug', 'isDraft', 'displayDropDown', 'acknowledgedReading', 'acknowledgedReadingDate', 
        'parentIndex', 'checkHeight', 'signFromMedicationChartRow', 'viewOnly', 'chartReview', 'reviewed', 'new', 'medicare', 'nextReviewDate',
        'frequencyOptions', 'administration_history', 'disableAll','expired', 'dashboardRenew', 'renewingCancelledScript', 'phoneOrder', 'prescriberSigned',
        'renewExpired', 'scid', 'currentErxStatus', 'signNow', 'isCeased', 'forceNoErx'],
    components: {
        SignatureModal,
        SuccessModal,
        StreamlineCodeModal,
        PatientAdministrationSummaryModal,
        PBSAlertModal,
        // MimsImage,
        // CMIPIModal,
        // QPTextInteractions,
        ScheduledDoseTimesModal,
        PrescribingQuestionnaire,
        RobertsProtocolModal,
        ConfirmationModal
    },
    data() {
        return {
            mimsApiKey: localStorage.getItem('mimsApiKey'),
            lastDosingPatientId: null,
            dosingWeight: null,
            dosingAge: null,
            dosingCreatinine: null,
            targetInrMin: 2.0,
            targetInrMax: 3.0,
            hasMechanicalValve: false,
            dosingHeight: null,
            dosingRace: null,
            hasEnzymeInducer: false,
            hasAmiodarone: false,
            raceOptions: [
                { label: 'Asian', value: 'Asian' },
                { label: 'Black or African American', value: 'Black' },
                { label: 'White / Caucasian', value: 'White' },
                { label: 'Mixed / Unknown', value: 'Mixed' }
            ],
            showRobertsModal: false,
            displayConsentModal: false,
            mimsImage: '',
            custom_s8: false,
            customMedication:{
                concat_name:'',
                name:'',
                form:'',
                strength:0,
                quantity: 0,
                measurement_unit_1:'',
                measurement_unit_2:'',
                tags:[]
            },
            medicationTimer: 0,
            medicationSaveStatus:'',
            IHICheck: false,
            beginWeekDate: '', // the date that the week begins, may be used for prev week calc
            endWeekDate: '', // the date that the week ends, may be used for next week calc
            currentWeekIndex: 0,
            numWeeks: 1,
            isPopulating: false,
            sliding: false,
            prescription_answers: null,
            rpbs: false,
            pbs: false,
            ctg: false,
            is_extemp: false,
            addedToReview: false,
            payload: {},
            signature: false,
            loading: false,
            loadingDelay: false,
            forceCeaseRequired: false,
            dismissRequired: false,
            forceCreateRequired: false,
            dismissLoading: false,
            forceCreateLoading: false,
            lastCreateArgs: null,
            cancelAction: null,
            displaySuccessModal: false,
            displayStreamlineCodeModal: false,
            displayPatientAdministrationSummaryModal: false,
            displaySignatureModal: false,
            displayPBSAlertModal: false,
            displayErrorModal: false,
            displayCMIPIModal: false,
            displayPhoneOrderModal: false,
            displayMessage: '',
            displayMessage2: '',
            displayScheduledDoseTimesModal: false,
            displayQuestionnaire: false,
            displayBrandPrompt: false,
            pendingDrugItem: null,
            displayAllergyWarningModal: false,
            allergyWarningMatches: [],
            pendingAllergyDrugName: '',
            displayCancelReasonModal: false,
            cancelReason: '',
            searchedDrugName: '',
            errorTitle: 'Form Error',
            errorMessage: '',
            clearDrug: false,
            last_administration: [],
            selectedCTPP: null,
            weeks: {},
            drugList: [],
            ctppList: [],
            selectedDrug: {},
            loadingDrugs: false,
            selectedUse: '',
            useOptions: [
                'For dental treatment only.',
                'For midwifery use only.',
                'For optometry use only.',
                'For podiatric treatment only.',
                'For treatment of foot conditions only.',
                'For ocular treatment only.'
            ],
            // Transient banner set by commitTime() when a dose time is rejected; cleared when a
            // valid one lands, when the field is refocused, or when the schedule is rebuilt.
            // Display only - the submit guard scans schedule_quantity instead, because a
            // rejected entry has already been reverted to a valid value.
            timeValidationError: '',
            timeBeforeEdit: null,
            // True once the grid's dose times came from somewhere other than the current
            // frequency template - a prescriber edit, or a saved chart's own times - so
            // updateDoseSchedule knows not to overwrite them. See updateDoseSchedule.
            scheduleTimesCustomised: false,
            schedule_quantity: [
                {
                    time: '0600',
                    qty: null,
                    date: null,
                    sliding_scale: false,
                },
                {
                    time: '0800',
                    qty: null,
                    date: null,
                    sliding_scale: false,
                },
                {
                    time: '1200',
                    qty: null,
                    date: null,
                    sliding_scale: false,
                },
                {
                    time: '1400',
                    qty: null,
                    date: null,
                    sliding_scale: false,
                },
                {
                    time: '1600',
                    qty: null,
                    date: null,
                    sliding_scale: false,
                },
                {
                    time: '1700',
                    qty: null,
                    date: null,
                    sliding_scale: false,
                },
                {
                    time: '2000',
                    qty: null,
                    date: null,
                    sliding_scale: false,
                },
                {
                    time: '2200',
                    qty: null,
                    date: null,
                    sliding_scale: false,
                }
            ],
            weekly_schedule: [
                {
                    day: "SU",
                    dayId: 0,
                    times: []
                },
                {
                    day: "MO",
                    dayId: 1,
                    times: []
                },
                {
                    day: "TU",
                    dayId: 2,
                    times: []
                },
                {
                    day: "WE",
                    dayId: 3,
                    times: []
                },
                {
                    day: "TH",
                    dayId: 4,
                    times: []
                },
                {
                    day: "FR",
                    dayId: 5,
                    times: []
                },
                {
                    day: "SA",
                    dayId: 6,
                    times: []
                }
            ],
            // `name` is the scale's reading type - see readingIdentityForChart in
            // services/slidingScale.js. The deprecated reading_type/reading_unit fields were never
            // persisted or returned by the backend and have been removed.
            sliding_scale_template: {
                name: 'BGL',
                min: '',
                max: '',
                value: '',
                reading: null
            },
            statDoseTime:[
                {
                    "day": null,
                    "times": [
                        {
                            "time": '0800',
                            "qty": '0', 
                            "date": '',
                            "sliding_scale": false
                        }
                    ]
                }
            ],
            slidingScaleType: { label: 'BGL', type: 'insulin', unit: 'BGL' },
            slidingScaleTypes: [
                { label: 'BGL', type: 'insulin', unit: 'BGL' },
                { label: 'INR', type: 'Blood Test', unit: 'INR' }
            ],
            stock: null, // CTPP Selection
            endpoint: '/prescription/create',
            endpoint2: '/chart',
            prescription_sign_payload: {
                prescription_id: '',
                is_paper: false
            },
            selected_administration_options: [],
            selected_packing: {},
            checkTimeout: null,
            apiTimeout: null,
            form: {
                chart_payload: {
                    prescription_id: '',
                    chart_form: {
                        type: '',
                        route: '',
                        max_dose: '',
                        indication: '',
                        tags: [],
                        schedule_quantity: [],
                        
                    }
                },
                prescription_payload: {
                    paper_prescription_number: '',
                    patient_id: '',
                    prescriber: '',
                    prescriber_id: '',
                    drug_uuid: '',
                    sliding_scale: [],
                    use_pbs: false,
                    pbs_manufacturer_code: '',
                    pbs_code: '',
                    pbs_authority_code: '',
                    permit_number: '',
                    authority_prescription_number: '',
                    prescribed_quantity: 0,
                    max_times_per_day: 0,
                    unusual_dose: false,
                    is_lemi: false,
                    dose_unit: '',
                    substitution_not_permitted: false,
                    dose: '',
                    max_dose: '',
                    max_daily_admin: '',
                    max_admin_dose: '',
                    start_date: '',
                    stop_date: '',
                    date_added: '',
                    indication: '',
                    is_paper: false,
                    frequency_shorthand: '',
                    interval: 1,
                    frequency: '',
                    dose_times: [],
                    route: '',
                    reason: '',
                    notes: '',
                    instructions: '',
                    additional_regulatory_checks: '',
                    num_repeats_authorised: 0,
                    unusual_qty: false,
                    repeat_interval: 0,
                    privacy_statement: true,
                    aslr_consent: true,
                    private_prescription: false,
                    emergency_supply: false,
                    ctg: false,
                    is_extemp: false,
                    script_ctg_annotation: '',
                    dispense_all_repeats: false,
                    old_prescription_id: '',
                    consent_uuid: '',
                    consent: null,
                }
            },
            newConsent: {
                has_consented: false,
                consent_type: 'psychotropic',
                given_by: '',
                given_date: new Date().toISOString().substr(0, 10),
            },
            consentTypeOptions: [
                { label: 'Psychotropic', value: 'psychotropic' },
                { label: 'Prescribing', value: 'prescribing' }
            ],
            administration_options: [
                { label: 'Do not crush', value: 'Do not crush' },
                { label: 'Self Admin', value: 'Self Administered' },
                { label: 'Unusual Dose', value: 'Unusual Dose' },
                { label: 'Unusual Qty', value: 'Unusual Quantity' },
            ],
            packing_options: [ 
                { label: 'Non-packed', value: 'Non-packed' },
                { label: 'Packed', value: 'Packed' }
            ],
            charts: [
                {
                    name: 'Regular Medicine Order',
                    chart_name: 'regular',
                    inputs: [
                        'dose',
                        'route',
                        'start_date',
                        'stop_date',
                        'frequency',
                        'schedule',
                        // 'reason',
                        'substitution',
                        'indication',
                        'single_multi',
                        'packed',
                        'comments',
                    ],
                    subtext: '',
                    color: '#9F5CC0',
                    prescriber: true,
                    sign1: false,
                    sign2: false,
                },
                {
                    name: 'Insulin Order',
                    chart_name: 'insulin',
                    inputs: [
                        'dose',
                        'route',
                        'start_date',
                        'stop_date',
                        'frequency',
                        'schedule',
                        // 'reason',
                        'substitution',
                        'indication',
                        'single_multi',
                        'packed',
                        'comments',
                    ],
                    subtext: '',
                    color: '#F3C400',
                    prescriber: true,
                    sign1: false,
                    sign2: false,
                },
                {
                    name: 'PRN Medicine',
                    chart_name: 'prn',
                    inputs: [
                        // 'reason',
                        'indication',
                        'frequency',
                        'max_24_dose',
                        'dose',
                        'route',
                        'max_dose',
                        'substitution',
                        'packed',
                        'prescription_date',
                        'start_date',
                        'stop_date',
                        'comments',
                        'min_admin',
                        'max_admin'
                    ],
                    subtext: '',
                    color: '#00B2A2',
                    prescriber: true,
                    sign1: false,
                    sign2: false,
                },
                {
                    name: 'Short Term Medicine',
                    chart_name: 'short_term',
                    inputs: [
                        'now_or_next_pack',
                        'dose',
                        'route',
                        'packed',
                        'frequency',
                        'indication',
                        'prescription_date',
                        'start_date',
                        'stop_date',
                        'schedule',
                        // 'reason',
                        'substitution',
                        'comments',

                    ],
                    subtext: '(antibiotics)',
                    color: '#D6001C',
                    prescriber: true,
                    sign1: false,
                    sign2: false,
                },
                {
                    name: 'Once Only Meds (Stat)',
                    chart_name: 'stat',
                    inputs: [
                        'datetime',
                        'dose',
                        'route',
                        'schedule'
                        // 'reason'
                    ],
                    subtext: '',
                    color: '#8E0018',
                    prescriber: true,
                    sign1: true,
                    sign2: false,
                },
                {
                    name: 'Intermittent Medicine',
                    chart_name: 'intermittent',
                    inputs: [
                        'frequency',
                        'start_date',
                        'schedule'
                    ],
                    subtext: '',
                    color: '#5B00AA',
                    prescriber: true,
                    sign1: false,
                    sign2: false,
                },
                // {
                //     name: 'Variable Dose Meds',
                //     chart_name: 'variable_dose',
                //     inputs: [
                //         'frequency',
                //         'dose',
                //         'route',
                //         'packed',
                //         'prescription_date',
                //         'start_date',
                //         'stop_date',
                //         'comments',
                //     ],
                //     subtext: '(not insulin)',
                //     color: '#00AD50',
                //     prescriber: true,
                //     sign1: false,
                //     sign2: false,
                // },
                //   {
                //       name:'Nurse Initiated Meds',
                //       inputs:[
                //           'frequency',
                //           'dose',
                //           'route',
                //           'reason',
                //           'start_date',
                //           'comments'
                //       ],
                //       subtext:'(non-prescription)',
                //       color: '#274188',
                //       prescriber:false,
                //       sign1:false,
                //       sign2: false,
                //       nurse: true,
                //   },
                // {
                //     name: 'Non Prescription Meds',
                //     chart_name: 'non_prescription',
                //     inputs: [
                //         'frequency',
                //         'dose',
                //         'route',
                //         // 'reason',
                //         'start_date',
                //         'comments',
                //         'schedule'
                //     ],
                //     subtext: '(resident initiated)',
                //     color: '#EF9600',
                //     prescriber: true,
                //     sign1: false,
                //     sign2: false,
                // },
                {
                    name: 'Nutritional Supplement',
                    chart_name: 'supplement',
                    inputs: [
                        'frequency',
                        'dose',
                        'route',
                        // 'reason',
                        'start_date',
                        'stop_date',
                        'substitution',
                        'packed',
                        'comments',
                        'schedule'
                    ],
                    subtext: '',
                    color: '#E56DB1',
                    prescriber: true,
                    sign1: false,
                    sign2: false,
                },
            ],
            administrationTypes: [
                'PO - Oral',
                'PR - Rectal',
                'Topical',
                'Subcut - Subcutaneous',
                'Subling - Sublingual',
                'Each ear',
                'Each eye',
                'Each nostril',
                'Left ear',
                'Left eye',
                'Left nostril',
                'Right ear',
                'Right eye',
                'Right nostril',
                'Mucosal',
                'Nasoduodenal',
                'Percutaneous',
                'NG - Nasogastric',
                'NJ - Nasojejunal',
                'PEG - Percutaneous endoscopic gastrostomy',
                'PEJ - Percutaneous endoscopic jejunostemy',
                'IM - Intramuscular',
                'IV - Intravenous',
                'Epidural',
                'Inhale/Inhalation',
                'Intraarticular (joint)',
                'Intrathecal (spine)',
                'Intranasal (nose)',
                'Irrigation',
                'NEB - Nebuliser',
                'PV - Vaginal',
                'PICC - Peripherally Inserted Central Catheter'
            ],
            administrationInsulinTypes:[
                'Subcutaneous',
                'Intravenous'
            ],
            statFrequency:[
                {
                    frequency_name: "Stat",
                    display_name: "Stat",
                    interval: 1,
                    period: 'daily',
                    times: ['0800'],
                    days_of_week: []
                }
            ],
            frequencyTypes: [
                {
                    frequency_name: "Daily (except on Mon)",
                    interval: 1,
                    period: 'weekly',
                    times: ['0800'],
                    days_of_week: ['TU', 'WE', 'TH', 'FR', 'SA', 'SU']
                },
                {
                    frequency_name: "Daily (except on Tue)",
                    interval: 1,
                    period: 'weekly',
                    times: ['0800'],
                    days_of_week: ['MO', 'WE', 'TH', 'FR', 'SA', 'SU']
                },
                {
                    frequency_name: "Daily (except on Wed)",
                    interval: 1,
                    period: 'weekly',
                    times: ['0800'],
                    days_of_week: ['TU', 'MO', 'TH', 'FR', 'SA', 'SU']
                },
                {
                    frequency_name: "Daily (except on Thu)",
                    interval: 1,
                    period: 'weekly',
                    times: ['0800'],
                    days_of_week: ['TU', 'WE', 'MO', 'FR', 'SA', 'SU']
                },
                {
                    frequency_name: "Daily (Mon to Fri)",
                    interval: 1,
                    period: 'weekly',
                    times: ['0800'],
                    days_of_week: ['MO', 'TU', 'WE', 'TH', 'FR']
                },
                {
                    frequency_name: "4 Hourly",
                    interval: 1,
                    period: 'daily',
                    times: ['0600', '1000', '1400', '1800', '2200'],
                    days_of_week: []
                },
                {
                    frequency_name: "6 Hourly",
                    interval: 1,
                    period: 'daily',
                    times: ['0600', '1200', '1800'],
                    days_of_week: []
                },
                // { "label": "TDS", "data": "TDS" },
                // { "label": "QiD", "data": "QiD" },
                // { "label": "Periodic", "data": "Periodic" },
                //   {"label": "PRN", "data": "PRN"},
                // { "label": "Daily", "data": "daily" },
                // { "label": "Weekly", "data": "weekly" },
                // { "label": "Monthly", "data": "monthly" },
                // { "label": "Variable", "data": "variable" },
            ],
            daysOfWeek: [
                {
                    value: 'MO',
                    label: 'Monday'
                },
                {
                    value: 'TU',
                    label: 'Tuesday'
                },
                {
                    value: 'WE',
                    label: 'Wednesday'
                },
                {
                    value: 'TH',
                    label: 'Thursday'
                },
                {
                    value: 'FR',
                    label: 'Friday'
                },
                {
                    value: 'SA',
                    label: 'Saturday'
                },
                {
                    value: 'SU',
                    label: 'Sunday'
                }
            ],
            doseTypes: [],
            doseTypeInsulin:['Unit'],
            selectedChart: this.activeSelectedChart ? this.activeSelectedChart : {name: 'Regular', chart_name: 'regular', color: '#BCA136', inputs: []},
            formTimes: {
                time1: '',
            },
            drugSearchFilter: 1,
            pbsFilter: '',
            prescriptionType: '',
            searchTypes: [
                { name: 'All', value: 0 },
                { name: 'Brands', value: 2 },
                { name: 'Active Ingredients', value: 1 },
                { name: 'Custom', value: 3 }
            ],
            benefitTypes: [
                { name: 'Private', value: '' },
                { name: 'PBS/RPBS', value: 'pbs' }
            ],
            loading_pbs: false,
            pbs_codes: [],
            indications_list: [],
            selected_pbs_code: '',
            packed: '',
            now_or_next_pack: '',
            single_multi: '',
            error_message: '',
            start_date: '',
            stop_date: '',
            date_added: '',
            dateRange: [],
            hasAuthCode: false,
            authorisationReferenceNumberLabel: 'Permit Number',
            scheduledMedicine: false,
            prescription_id: '',
            readyToDisplaySchedule: false,
            // Set when checkPrescription() bails because the patient hasn't loaded yet; the
            // patient watcher runs the check once it has.
            erxCheckDeferred: false,
            generateCode: false,
            displayPRNSliding: false,
            adminSchedule:null,
            yes_or_no:[
                {label:'Yes',
                  value: true},
                {label:'No',
                  value: false},
            ],
            calculated_stop_date: null,
            editingPrescription: false,
            cancelPrescriptionFirst: false,
            selectedPrescriber: null,
            phone_order: false,
            signPhoneOrder: false,
            parentFunction:{
                type: Function,
                required: true
            },
            isVariableMode: false,
            // True when the prescriber turned on the calendar with "Customize / Variable Dose" on
            // a chart that isn't saved as variable yet. Variable mode is component state and is
            // never written into prescription_payload, so without this the activePresChart watcher
            // could not tell "the prescriber just built this" from "the saved chart isn't
            // variable" and cleared it on every re-emit from the parent.
            variableModeSetLocally: false,
            acknowledgeINR: false
        }
    },

    methods: {
        initializeDosingVariables() {
            if (this.patient) {
                // Guards below only pre-populate when a dosing value is still empty, so if this
                // component/form gets reused for a different resident without remounting, a
                // previous resident's weight/age/etc could otherwise silently stick around.
                if (this.patient.uuid && this.patient.uuid !== this.lastDosingPatientId) {
                    this.lastDosingPatientId = this.patient.uuid;
                    this.dosingWeight = null;
                    this.dosingAge = null;
                    this.dosingHeight = null;
                    this.dosingCreatinine = null;
                }

                // Pre-populate Age from DOB
                if (this.patient.personal_information && !this.dosingAge) {
                    if (this.patient.personal_information.age) {
                        this.dosingAge = this.patient.personal_information.age;
                    } else if (this.patient.personal_information.dob) {
                        const dobStr = this.patient.personal_information.dob;
                        // Handle both YYYY-MM-DD and DD/MM/YYYY
                        let dobParts = dobStr.includes('/') ? dobStr.split('/') : dobStr.split('-');
                        if (dobParts.length === 3) {
                            let val1 = parseInt(dobParts[0]);
                            let year, month, day;
                            if (val1 > 31) {
                                year = val1;
                                month = parseInt(dobParts[1]);
                                day = parseInt(dobParts[2]);
                            } else {
                                day = val1;
                                month = parseInt(dobParts[1]);
                                year = parseInt(dobParts[2]);
                            }
                            const dob = new Date(year, month - 1, day);
                            const ageDifMs = Date.now() - dob.getTime();
                            if (ageDifMs > 0) {
                                const ageDate = new Date(ageDifMs);
                                this.dosingAge = Math.abs(ageDate.getUTCFullYear() - 1970);
                            }
                        }
                    }
                }
                
                // Pre-populate Weight
                if (!this.dosingWeight) {
                    if (this.patient.latest_weight_reading?.value) {
                        this.dosingWeight = parseFloat(this.patient.latest_weight_reading.value);
                    } else if (this.patient.weights && this.patient.weights.length > 0) {
                        // Legacy Weight table fallback
                        // Sort descending, get newest
                        const sortedWeights = [...this.patient.weights].sort((a,b) => new Date(b.date) - new Date(a.date));
                        this.dosingWeight = parseFloat(sortedWeights[0].weight);
                    }
                }

                // Pre-populate Height
                if (!this.dosingHeight) {
                    if (this.patient.latest_height_reading?.value) {
                        this.dosingHeight = parseFloat(this.patient.latest_height_reading.value);
                    }
                }
                
                // Pre-populate Creatinine
                if (this.patient.latest_creatinine_reading?.value && !this.dosingCreatinine) {
                    this.dosingCreatinine = parseFloat(this.patient.latest_creatinine_reading.value);
                }
            }
        },
        detectVariableMode(data = null) {
            const chart = data || this.activePresChart;
            if (!chart || !chart.prescription_payload) return;
            
            const payload = chart.prescription_payload;

            // A saved chart is variable only if it says so. Dates on the dose times don't mean
            // variable - updateDoseSchedule() stamps one on every weekly dose, and the backend
            // copies the first dose's date up to the day entry, so weekly and stat charts came
            // back looking variable on every screen that passes dose_times through unremapped
            // (renew, expired, chart review, medication history) and reopened with the frequency
            // dropdown replaced by the calendar. cellId was the other signal and it isn't a
            // column, so it never survives a save either. The two real signals are this check and
            // convertToVariableDose(), which sets the mode directly.
            const period = payload.frequency?.period || payload.frequency;
            if (isVariableValue(period) || isVariableValue(payload.frequency_shorthand) || isVariableValue(payload.frequency)) {
                this.isVariableMode = true;
            }
        },
        updateSelectedPrescriber(value){
            if(value){
                console.log('updating prescriber id', value);
                this.selectedPrescriber = {uuid: value};
            }
        },
        debounceSearchDrugs() {
            if (this.timeout)
                clearTimeout(this.timeout);

            this.timeout = setTimeout(() => {
                this.dispenseSearchDrugs()
            }, 400); // delay
        },
        dispenseSearchDrugs() {
            if (this.selectedCTPP) {
                this.$store.dispatch('getRefreshToken');
                this.getAMTMeds();
            }
        },
        selectCTPP(item) {
            this.selectedCTPP = item;
            if (item && item.quantity) {
                this.form.prescription_payload.prescribed_quantity = item.quantity;
            }
            if (item.drugs && item.drugs.length === 1) {
                this.stock = item.drugs[0];
            } else {
                this.stock = null;
            }
        },
        onPackFilter(event) {
            if (this.packSearchTimeout) clearTimeout(this.packSearchTimeout);
            this.packSearchTimeout = setTimeout(() => {
                this.getAMTMeds(false, false, event.value);
            }, 400);
        },
        getAMTMeds(changingPackSize, silentFetch = false, searchTerm = null) {
            if (this.loadingDrugs || (searchTerm === null && this.ctppList && this.ctppList.length > 0)) return;

            if (!silentFetch && !searchTerm) {
                this.selectedCTPP = null;
            }
            if (!searchTerm) {
                this.ctppList = [];
            }
            
            let alias_id = this.selectedDrug ? (this.selectedDrug.drug_uuid || this.selectedDrug.alias_id) : null;
            
            if (alias_id) {
                 this.loadingDrugs = true;
                 axios.post(`/get-drug-packs`, { alias_id: alias_id, name: searchTerm }, this.$store.state.header).then(res => {
                    console.log('this is the drug packs data', res.data);
                    if (res.data) {
                        res.data.forEach(pack => {
                            if (pack.name) pack.name = applyTallmanToPack(pack.name);
                            if (pack.drugs) {
                                pack.drugs.forEach(drug => {
                                    drug.pack_size_id = pack.uuid;
                                })
                            }
                        })
                        this.ctppList = res.data;

                        if (this.ctppList.length === 1 && !silentFetch) {
                            this.selectCTPP(this.ctppList[0]);
                        } else if (silentFetch) {
                            let match = null;
                            let activePack = (this.activePresChart && this.activePresChart.prescription_payload && this.activePresChart.prescription_payload.pack_size) || this.selectedCTPP;
                            if (activePack) {
                                match = this.ctppList.find(p => (activePack.uuid && p.uuid === activePack.uuid) || (activePack.ctpp && p.ctpp === activePack.ctpp));
                            }
                            if (!match && this.form && this.form.prescription_payload && this.form.prescription_payload.prescribed_pack_size_id) {
                                match = this.ctppList.find(p => p.uuid === this.form.prescription_payload.prescribed_pack_size_id);
                            }
                            if (match) this.selectedCTPP = match;
                        }
                    }
                }).catch(err => {
                    console.error('Error fetching drug packs:', err);
                }).finally(() => {
                    this.loadingDrugs = false;
                    if (!silentFetch) {
                        this.$nextTick(() => {
                            if (this.$refs.ctppDropdown) {
                                this.$refs.ctppDropdown.show();
                            }
                        });
                    }
                });
            }
        },
        confirmPhoneOrder(){
            console.log('this is the phone order being confirmed');
            if (!this.activePresChart?.prescription_payload?.prescriber) this.displayPhoneOrderModal = true;
            else {
                // go straight to sign
                this.displayPhoneOrderModal = true;
                this.phone_order = true;
                this.signature = true;
                // add the prescription id to the payload for signing
                this.prescription_sign_payload.prescription_id = this.activePresChart?.chart_payload?.prescription_id;
                this.prescription_sign_payload.is_paper = this.activePresChart?.prescription_payload?.is_paper ? true : false;
            }
        },
        createPhoneOrder(value){
            if(value){
                this.createChart(true,false,false, true)
            }
        },
        signOffPhoneOrder(){
            if (this.activePresChart && this.activePresChart.chart_payload && this.activePresChart.chart_payload.prescription_id) {
                console.log('signing off phoneOrder', this.activePresChart.chart_payload.prescription_id);
                this.payload = {
                    prescription_id: this.activePresChart.chart_payload.prescription_id,
                    // Transitional conformance items are never sent to eRx, so flag it here too
                    // or signing a phone order for a chartless patient would demand eRx setup.
                    no_erx: this.isTransitionalConformance,
                    // The prescriber's own sign-off only ever needs their single signature -
                    // see the matching note in prescriptionSignPayload().
                    has_scheduled_items: false
                }
                this.endpoint = '/prescription/sign'
                this.displaySignatureModal = true;
            } else {
                console.error('Cannot sign off phone order: activePresChart not available');
            }
        },
        cancelDraft(value){
            
        },  
        closeSuccess(value){
            if(value){
                this.displaySuccessModal=false;
                this.displayPhoneOrderModal = false;

            }
        },
        backToEdit(value){
            if(value){
                console.log('editing live prescription', value);
                this.editingPrescription = true;
                this.displaySuccessModal = false;
            }
           
        },
        showAdminHistory(){
            if(this.last_administration.quantity){
                this.displayPatientAdministrationSummaryModal = true
            }
        },
        resetToTemplate() {
            this.isVariableMode = false;
            this.variableModeSetLocally = false;

            // convertToVariableDose() layers the calendar over a real frequency, so that
            // frequency is still selected and updateDoseSchedule(true) can rebuild from it. A
            // chart that was *saved* as variable has no underlying template - the frequency
            // column and the shorthand both just say 'variable' - and the Variable option's own
            // times are placeholders (0600-2200), not this patient's schedule. Resetting to
            // those would silently invent a schedule, so clear the selection instead and send
            // the prescriber back to the frequency list to pick a real one.
            if (isVariableFrequency(this.form.prescription_payload.frequency)) {
                this.form.prescription_payload.frequency = '';
                this.form.prescription_payload.times = [];
                this.form.prescription_payload.dose_times = [];
                this.numWeeks = 1;
            }

            this.updateDoseSchedule(true);
        },
        convertToVariableDose() {
            if (!this.form.prescription_payload.frequency) return;
            
            this.isVariableMode = true;
            this.variableModeSetLocally = true;
            this.numWeeks = 1;

            // Clear existing schedule first
            this.clearWeeklySchedule();
            this.form.prescription_payload.times = [];
            
            // Map current frequency pattern to the first week
            this.populatePayloadForWeek(0);
            
            // Pulse the display and populate the DOM cells
            this.readyToDisplaySchedule = false;
            setTimeout(() => {
                this.readyToDisplaySchedule = true;
                this.$nextTick(() => {
                    this.populateWeeklySchedule();
                    this.updateInstructions();
                });
            }, 100);
        },
        closeAdminHistory(){
            this.displayPatientAdministrationSummaryModal = false
        },
        saveCustomMedication(){
            let strengthVal = this.customMedication.strength;

            this.date_added = new Date();
            this.medicationSaveStatus = 'Saving';
            this.customMedication.measurement_unit = `${this.customMedication.measurement_unit_1}`;
            strengthVal = parseFloat(strengthVal).toFixed(5);
            this.customMedication.quantity = parseInt(this.customMedication.quantity);
            if(this.custom_s8){
                this.customMedication.tags.push('s8');
            }

            axios.post('/create-custom-drug', this.customMedication, this.$store.state.header).then(res=>{
                this.customMedication.uuid = res.data.uuid;
                this.medicationSaveStatus = 'Medication saved!';

                // let units = this.customMedication.measurement_unit.split('/')
                // this.doseTypes.push(this.customMedication.form, units[0], units[1], 'application')
            })
            .catch(err => {
            if(err.response) {
                this.medicationSaveStatus = 'Failed to save!';
            
                setTimeout(() => {
                this.medicationSaveStatus = '';
                }, 5000);
            }
            })
            this.selected_pbs_code = '';
            this.form.prescription_payload.pbs_code = '';
            this.form.prescription_payload.authority_prescription_number = '';
            this.form.prescription_payload.pbs_authority_code = '';
            this.form.prescription_payload.pbs_manufacturer_code = '';
            this.form.prescription_payload.permit_number='';
            
        },
        clearCustomMedForm(){
            console.log('hitting clear custom med fuction');
            this.custom_s8 = false;
            this.customMedication = {
                concat_name:'',
                name:'',
                form:'',
                strength:0,
                quantity: 0,
                measurement_unit_1:'',
                measurement_unit_2:'',
                tags:[]
            }
            this.medicationSaveStatus = '';
            this.selectedDrug = {};
            if(!this.dashboardRenew){
                this.selected_pbs_code = '';
                this.form.prescription_payload.pbs_code = '';
                this.form.prescription_payload.authority_prescription_number = '';
                this.form.prescription_payload.pbs_authority_code = '';
                this.form.prescription_payload.pbs_manufacturer_code = '';
                this.form.prescription_payload.permit_number='';
                // this.doseTypes = [];
            }
            this.searchedDrugName = '';
            
            
            
        },
        assignFrequencyList(){
            console.log('this is the selected chart', this.selectedChart, this.selectedChart.chart_name);
            if(this.selectedChart.chart_name == 'stat'){
                this.statDoseTime = [
                    {
                        "day": null,
                        "times": [
                            {
                                "time": '0800',
                                "qty": '0', 
                                "date": '',
                                "sliding_scale": false
                            }
                        ]
                    }
                ]
                this.form.prescription_payload.frequency = this.statFrequency[0];
                this.form.prescription_payload.notes = '';
            } else{
                let templateText = '-------Please write any additional notes below this line------- \n';
                if (this.isInfusion) {
                    templateText += this.infusionTemplateText;
                }
                this.form.prescription_payload.notes = templateText;
            }
        },
        updateStatInstructions(){
            this.form.prescription_payload.notes = `Administer ${this.statDoseTime[0].times[0].qty} ${this.form.prescription_payload.dose_unit}/s at ${this.statDoseTime[0].times[0].time}. \n ${this.form.prescription_payload.route}`
        },
        checkIfPRNOrInsulin(){
            this.$store.dispatch('getRefreshToken');
            this.displayPRNSliding = true;
        },
        updatePBSPrescription() {
            this.$store.dispatch('getRefreshToken');
            this.form.prescription_payload.prescribed_quantity = this.selected_pbs_code.max_quantity;
            // this.form.prescription_payload.authority_prescription_number = '';
            this.form.prescription_payload.pbs_authority_code = '';
            if (this.selected_pbs_code.restriction_flag == 'A') {
                this.hasAuthCode = false;
                this.displayPBSAlertModal = true;
            }
        },
        updatePrescriptionQuantityAndRepeats(value) {
            this.$store.dispatch('getRefreshToken');
            console.log('this is the update prescription quantity and repeats func', this.selected_pbs_code);
            if (value && value.quantity && this.selected_pbs_code) {
                this.selected_pbs_code.max_quantity = value?.quantity;
                this.form.prescription_payload.prescribed_quantity = value?.quantity;
                this.form.prescription_payload.num_repeats_authorised = value?.repeats?.toString();
                this.displayPBSAlertModal = false;
            }
        },
        checkPrescribedQty() {
            this.$store.dispatch('getRefreshToken');
            if ((this.form.prescription_payload.prescribed_quantity > this.selected_pbs_code.max_quantity) && !this.form.prescription_payload.authority_prescription_number && this.pbsFilter) {
                this.displayPBSAlertModal = true;
            }
        },
        revertQtyUpdate(value) {
            this.$store.dispatch('getRefreshToken');
            if (value) {
                this.form.prescription_payload.prescribed_quantity = this.selected_pbs_code.max_quantity;
            }
        },
        changePBSOption() {
            this.$store.dispatch('getRefreshToken');
            this.selected_pbs_code = '';
            console.log('changing pbs option', this.selected_pbs_code);
            if(this.form.prescription_payload.authority_prescription_number){
                this.cancelPrescriptionFirst = true;
            }
            this.form.prescription_payload.authority_prescription_number = '';
            this.form.prescription_payload.pbs_code = '';
            this.form.prescription_payload.pbs_authority_code = '';
            this.form.prescription_payload.indication = '';
            this.form.prescription_payload.pbs_type = '';
        },
        normaliseTimeInput(raw) {
            // Accepts 0700, 700, 7:00 and 07:00; returns canonical HHMM, or null if it isn't a
            // valid 24hr time. The template's minlength/maxlength aren't enforced against paste
            // or programmatic input, so this is the only thing between a typo and a dose_times
            // entry the administration screens can't schedule against.
            //
            // Deliberately match the whole string rather than stripping non-digits: "8:00pm"
            // would strip to 0800 and hand the prescriber a morning dose where they entered an
            // evening one, with nothing on screen to say so. Only a colon is tolerated as a
            // separator - anything else is rejected so the prescriber retypes it.
            const value = (raw === null || raw === undefined ? '' : raw).toString().trim();
            if (!/^\d{1,2}:?\d{2}$/.test(value)) return null;
            let digits = value.replace(':', '');
            if (digits.length === 3) digits = `0${digits}`;
            if (!/^([01][0-9]|2[0-3])[0-5][0-9]$/.test(digits)) return null;
            return digits;
        },
        captureTimeBeforeEdit(item) {
            // The dose time inputs bind with :value + @change rather than v-model, so a
            // half-typed value never reaches the model - it would churn the weekly grid's
            // vcell-* ids (which saveWeeklySchedule looks the qty cells up by) on every
            // keystroke. The trade-off is that we have to stash the pre-edit value ourselves so
            // a rejected entry has something to revert to.
            this.timeBeforeEdit = item ? item.time : null;
            // The banner is transient feedback about the keystrokes that were rejected, not a
            // statement about the form - revert() already put a valid time back. Clear it as
            // soon as the prescriber returns to the field.
            this.timeValidationError = '';
        },
        commitTime(item, event, isWeekly = false) {
            this.$store.dispatch('getRefreshToken');
            if (!item) return;

            const previous = this.timeBeforeEdit !== null && this.timeBeforeEdit !== undefined
                ? this.timeBeforeEdit
                : item.time;
            this.timeBeforeEdit = null;

            const raw = event && event.target ? event.target.value : item.time;
            const revert = (message) => {
                this.timeValidationError = message;
                item.time = previous;
                if (event && event.target) event.target.value = previous === null || previous === undefined ? '' : previous;
            };

            const normalised = this.normaliseTimeInput(raw);
            if (!normalised) {
                revert(`"${raw}" is not a valid dose time. Enter a 24 hour time as HHMM, e.g. 0700.`);
                return;
            }
            // Two entries on the same time would render two identical columns and, in the weekly
            // grid, two qty cells sharing one vcell-* id - saveWeeklySchedule would read the same
            // element twice and silently drop one of the quantities. Swap rather than reject: the
            // prescriber re-timing a whole schedule (0000 -> 0600 while 0600 is still there) hits
            // a collision on every edit, and reverting made that impossible to do in place. The
            // clashing entry takes the time this one just left, so the set stays unique.
            const clash = this.schedule_quantity.find(t => t !== item && t && t.time === normalised);
            if (clash) clash.time = previous;

            this.timeValidationError = '';
            item.time = normalised;
            if (event && event.target) event.target.value = normalised;
            // These times are the prescriber's now, not the frequency template's - see
            // updateDoseSchedule.
            this.scheduleTimesCustomised = true;

            if (isWeekly) {
                // The qty cells' ids are derived from p.time, so they only carry the new time
                // once Vue has re-rendered - saveWeeklySchedule reads the DOM by those ids.
                this.$nextTick(() => this.saveWeeklySchedule());
            } else {
                this.updateInstructions();
            }
        },
        parseDoseTimes() {
            this.$store.dispatch('getRefreshToken');
            console.log('PARSING DOSE TIME');
            let period = '';
            if (this.form.prescription_payload.frequency) {
                period = this.form.prescription_payload.frequency.period || this.form.prescription_payload.frequency;
                if (typeof period === 'string') {
                    period = period.toLowerCase();
                }
            }
            if (period == 'daily' || period == 'monthly') {
                let valid_times = this.schedule_quantity.filter(item => item.qty !== null && item.qty !== '');
                let cloned_times = valid_times.map(t => ({...t, qty: String(t.qty), date: ''}));
                
                this.form.prescription_payload.dose_times = cloned_times.length ? [
                    {
                        day: null,
                        times: cloned_times
                    }
                ] : [];
            } else if (period == 'weekly' || period == 'variable') {
                let daysContainingTimes = [];
                this.weekly_schedule.forEach(day => {
                    if (day.times.length) {
                        daysContainingTimes.push(day);
                    }
                })
                this.form.prescription_payload.dose_times = daysContainingTimes;
            } 
            // else if (this.form.prescription_payload.frequency.period == 'variable') {
            //     this.removeDuplicatesInSchedule();
            // }
        },
        clearDaysInputs() {
            this.$store.dispatch('getRefreshToken');
            // this.form.prescription_payload.days_of_week.forEach(item=>{
            //     if
            // })
        },
        getSunday(direction) {
            this.$store.dispatch('getRefreshToken');
            var startDay = new Date();
            startDay.setDate(startDay.getDate() - (startDay.getDay() + 7) % 7);
            var curr; // get current date
            let first;
            if (direction == 'next' && this.endWeekDate) {
                this.endWeekDate.setDate(this.endWeekDate.getDate() + 7);
                curr = this.endWeekDate;
                first = this.endWeekDate.getDate() - this.endWeekDate.getDay();
            } else if (direction == 'prev' && this.endWeekDate) {
                this.beginWeekDate.setDate(this.beginWeekDate.getDate() - (this.beginWeekDate.getDay() + 7));
                curr = this.beginWeekDate;
                first = this.beginWeekDate.getDate() - this.beginWeekDate.getDay();
            } else {
                curr = startDay;
                first = startDay.getDate() - startDay.getDay();
            }
            console.log('THIS IS THE FIRST', first);
            this.dateRange = [];
            for (var i = 0; i < 7; i++) {
                var next = new Date(curr.getTime());
                next.setDate(first + i);
                if (i == 6) {
                    this.endWeekDate = next;
                    console.log('END WEEK LOOP', this.endWeekDate);
                }
                if (i == 0) {
                    this.beginWeekDate = next;
                }
                next = next.toLocaleString("en-au", { timeZone: "Australia/Sydney" });
                next = next.slice(0, 10);
                console.log(next);
                this.dateRange.push({
                    date: next,
                    edit: true
                });
            }
            setTimeout(() => {
                this.disablePastDates();
            }, 400)

        },
        disablePastDates() {
            this.$store.dispatch('getRefreshToken');
            let currentDate = new Date().toLocaleString("en-au", { timeZone: "Australia/Sydney" });
            currentDate = currentDate.slice(0, 10);
            console.log('THIS IS THE CURRENT DATE', currentDate);
            if (this.currentWeekIndex == 0) {
                this.dateRange.forEach(item => {
                    if ((item.date.split('/')[1] < currentDate.split('/')[1]) || (item.date.split('/') < currentDate.split('/'))) {
                        item.edit = false;
                    }
                })
            }

        },
        addWeek() {
            try {
                const newWeekIndex = this.numWeeks;
                this.numWeeks += 1;
                
                if (this.isVariableMode) {
                    this.isPopulating = true;
                    this.populatePayloadForWeek(newWeekIndex);
                    
                    // Ensure instructions are updated immediately
                    this.updateInstructions();

                    // UI SYNC FIX: Ensure the new week inputs are populated after they've rendered.
                    // IMPORTANT: We DISCONTINUED the "pulse" (toggling readyToDisplaySchedule) 
                    // because it destroys the DOM for existing weeks, losing manual edits.
                    this.$nextTick(() => {
                        this.populateWeeklySchedule();
                        this.isPopulating = false; // Reset here as we didn't use setTimeout
                    });
                }
            } catch (error) {
                console.error("Error in addWeek:", error);
                this.readyToDisplaySchedule = true;
            }
        },
        populatePayloadForWeek(weekIndex) {
            if (!this.form.prescription_payload.frequency) return;
            
            // Use current displayTimes instead of frequency template times to ensure grid consistency
            const timesToUse = this.displayTimes.map(t => t.time);
            const daysFromFreq = this.form.prescription_payload.frequency.days_of_week || [];
            const dose = (this.form.prescription_payload.dose || 0).toString();
            const weekDates = this.getWeekDates(weekIndex);
            
            this.weekly_schedule.forEach((dayObj, dayIndex) => {
                const matchesFreq = daysFromFreq.length === 0 || daysFromFreq.some(val => {
                    const v = val.toUpperCase();
                    const d = dayObj.day.toUpperCase();
                    return v.startsWith(d) || d.startsWith(v);
                });
                const isActiveDay = matchesFreq && weekDates[dayIndex].edit;
                
                if (isActiveDay) {
                    timesToUse.forEach(timeStr => {
                        // Check if this entry already exists to avoid duplicates
                        const exists = this.form.prescription_payload.times.some(t => 
                            t.week === weekIndex && t.day === dayObj.day && 
                            (t.time === timeStr || (t.times && t.times.time === timeStr))
                        );
                        
                        if (!exists) {
                            this.form.prescription_payload.times.push({
                                day: dayObj.day,
                                week: weekIndex,
                                times: {
                                    qty: dose,
                                    time: timeStr,
                                    cellId: `vcell-${weekIndex}-${dayObj.day}-${timeStr}`,
                                    date: weekDates[dayIndex].date,
                                    week: weekIndex,
                                    sliding_scale: false
                                }
                            });
                        }
                    });
                }
            });
        },
        removeWeek() {
            try {
                if (this.numWeeks > 1) {
                    this.isPopulating = true;
                    this.numWeeks -= 1;
                    // Cleanup times for the removed week
                    if (this.form.prescription_payload.times) {
                        this.form.prescription_payload.times = this.form.prescription_payload.times.filter(t => t.week < this.numWeeks);
                    }
                    // Also cleanup dose_times if it exists (for variable mode)
                    if (this.form.prescription_payload.dose_times) {
                        this.form.prescription_payload.dose_times = this.form.prescription_payload.dose_times.filter(day => {
                            if (day.times && day.times.length > 0) {
                                const w = day.times[0].week !== undefined ? day.times[0].week : 0;
                                return w < this.numWeeks;
                            }
                            return true;
                        });
                    }
                    // Ensure instructions are updated immediately
                    this.updateInstructions();
                    
                    // UI SYNC: Ensure remaining values are restored in the DOM
                    this.$nextTick(() => {
                        this.populateWeeklySchedule();
                    });
                }
            } catch (error) {
                console.error("Error in removeWeek:", error);
            }
        },
        getWeekDates(weekIndex) {
            let baseDate = new Date();
            
            // ANCHOR FIX: Use prescription start_date if available
            if (this.form.prescription_payload.start_date) {
                const parts = this.form.prescription_payload.start_date.split('/');
                if (parts.length === 3) {
                    // Assuming dd/mm/yyyy
                    baseDate = new Date(parts[2], parts[1] - 1, parts[0]);
                } else {
                    // Fallback to native parsing
                    baseDate = new Date(this.form.prescription_payload.start_date);
                }
            }

            // If baseDate is invalid, fallback to now
            if (isNaN(baseDate.getTime())) baseDate = new Date();
            baseDate.setHours(0, 0, 0, 0);

            // Get Sunday of the week containing the baseDate
            let startDay = new Date(baseDate);
            startDay.setDate(startDay.getDate() - startDay.getDay());
            
            var targetSunday = new Date(startDay);
            targetSunday.setDate(targetSunday.getDate() + (weekIndex * 7));
            
            const freq = this.form && this.form.prescription_payload && this.form.prescription_payload.frequency;
            let isVarCal = this.isVariableMode;
            if (freq && (freq === 'variable' || freq.period === 'variable')) isVarCal = true;

            let stopDateObj = null;
            if (this.form.prescription_payload.stop_date) {
                const parts = this.form.prescription_payload.stop_date.split('/');
                if (parts.length === 3) {
                    stopDateObj = new Date(parts[2], parts[1] - 1, parts[0]);
                } else {
                    stopDateObj = new Date(this.form.prescription_payload.stop_date);
                }
                if (!isNaN(stopDateObj.getTime())) {
                    stopDateObj.setHours(0, 0, 0, 0);
                } else {
                    stopDateObj = null;
                }
            }

            let dates = [];
            for (let i = 0; i < 7; i++) {
                let d = new Date(targetSunday);
                d.setDate(targetSunday.getDate() + i);
                d.setHours(0, 0, 0, 0);
                let dateStr = d.toLocaleString("en-au", { timeZone: "Australia/Sydney" }).slice(0, 10);
                
                let isEditable = true;
                if (isVarCal) {
                    isEditable = d.getTime() >= baseDate.getTime();
                    if (isEditable && stopDateObj) {
                        isEditable = d.getTime() <= stopDateObj.getTime();
                    }
                }
                
                dates.push({
                    date: dateStr,
                    edit: isEditable
                });
            }
            return dates;
        },
        displayNextWeek() {
            this.addWeek();
        },
        displayPrevWeek() {
            this.removeWeek();
        },
        dismissPrescription(){
            if (this.activePresChart && this.activePresChart.chart_payload && this.activePresChart.chart_payload.prescription_id) {
                axios.post('/dismiss-expired-prescriptions', {prescription_ids: [this.activePresChart.chart_payload.prescription_id]}, this.$store.state.header).then(res=>{
                    console.log('dismissed expired med', res.data);
                    console.log('testing retrieveallcharts --- refreshlist - isSuccessful --dismissPrescription');
                    // this.$emit('isSuccessful', true);
                    this.$emit('dismissExpiredScript', this.activePresChart.chart_payload.prescription_id);
                }).catch(err => {
                    console.log('Error dismissing prescription:', err);
                })
            }
        },
        flattenPBSCodes() {
            let newStructure = [];
            if (!this.pbs_codes || !Array.isArray(this.pbs_codes)) {
                this.indications_list = newStructure;
                return;
            }
            this.pbs_codes.forEach(code => {
                if (code.restrictions && code.restrictions.length) {
                    // restriction.restriction_flag != '
                    code.restrictions.forEach(restriction => {
                            restriction.pbs_code = code.pbs_code;
                            restriction.pbs_manufacturer_code = code.pbs_manufacturer_code;
                            restriction.max_quantity = code.max_quantity;
                            restriction.pack_size = code.pack_size;
                            restriction.max_repeats = code.max_repeats;
                            restriction.restriction_flag = code.restriction_flag;
                            restriction.prescribers = code.prescribers;
                            // If there is not a note then update to 'no restriction description'
                            if (restriction.note) {
                                restriction.indication = restriction.note;
                            } else {
                                restriction.note = 'No restriction description';
                                restriction.indication = '';
                            }

                            console.log('splitting the restriction text', restriction);
                            if(restriction.restriction_flag == 'R' || restriction.restriction_flag == 'U'){
                                restriction.indication_id = '';
                                newStructure.push(restriction);
                            } else{
                                newStructure.push(restriction);
                            }
                            
                        
                        
                    })
                } else{
                    newStructure.push({
                        pbs_code : code.pbs_code,
                        pbs_manufacturer_code: code.pbs_manufacturer_code,
                        max_quantity : code.max_quantity,
                        pack_size: code.pack_size,
                        max_repeats: code.max_repeats,
                        restriction_flag: code.restriction_flag ?? 'None',
                        restriction_id: 'General',
                        note: 'No restrictions',
                        indication: '',
                        prescribers: code.prescribers
                    })
                }
            });
            this.indications_list = newStructure;
        },
        saveWeeklySchedule() {
            this.$store.dispatch('getRefreshToken');

            // TOGGLE GUARD: Don't save while the grid is hidden/re-rendering OR populating
            if (!this.readyToDisplaySchedule || this.isPopulating) return;
            
            // CRASH GUARD: If no times are defined yet, we can't build a schedule
            if (!this.displayTimes || !this.displayTimes.length) {
                console.warn('Cannot save schedule: displayTimes is empty');
                return;
            }

            let saveArray = [];
            let multiWeekDoseTimes = [];

            const currentTimes = [...(this.form.prescription_payload.times || [])];
            
            // Loop through all Weeks currently built/displayed
            for (let w = 0; w < this.numWeeks; w++) {
                const dates = this.getWeekDates(w);
                
                // ROBUSTNESS FIX: Check if ANY cell for this week exists in the DOM
                // instead of relying just on Sunday + the first time.
                let isWeekRendered = false;
                for (let d = 0; d < 7; d++) {
                    const dayName = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"][d];
                    const timeVal = this.displayTimes[0].time;
                    if (this.$el.querySelector(`#vcell-${w}-${dayName}-${timeVal}`)) {
                        isWeekRendered = true;
                        break;
                    }
                }
                
                // If the DOM hasn't rendered this week yet, preserve its existing data from payload
                if (w >= 0 && !isWeekRendered) {
                    const existingForWeek = currentTimes.filter(t => t.week === w);
                    if (existingForWeek.length > 0) {
                        saveArray.push(...existingForWeek);
                        // Also update multiWeekDoseTimes for instructions
                        existingForWeek.forEach(item => {
                            const doseObj = item.times || item;
                            let dayEntry = multiWeekDoseTimes.find(d => d.week === w && d.day === item.day);
                            if (!dayEntry) {
                                dayEntry = { day: item.day, date: doseObj.date || item.date || dates[["SU","MO","TU","WE","TH","FR","SA"].indexOf(item.day)]?.date, week: w, times: [] };
                                multiWeekDoseTimes.push(dayEntry);
                            }
                            dayEntry.times.push(doseObj);
                        });
                        continue;
                    }
                }

                let currentWeekSaveArray = []; // To fix the per-week storage later

                for (let day = 0; day < 7; day++) {
                    const dayName = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"][day];
                    let dayEntry = {
                        day: dayName,
                        date: dates[day].date,
                        times: []
                    };
                    let dayActive = false;

                    for (let t = 0; t < this.displayTimes.length; t++) {
                        const timeVal = this.displayTimes[t].time;
                        const cellId = `vcell-${w}-${dayName}-${timeVal}`;
                        const cellElement = this.$el.querySelector(`#${cellId}`);
                        
                        let qtyToSave = null;
                        if (cellElement) {
                            // A rendered cell is the prescriber's answer: empty means no dose on
                            // this day. Falling back to the payload for an empty cell too meant a
                            // cleared cell came back with its old quantity, so a day could never
                            // be removed - the only way out was typing 0, which then reached the
                            // backend as a real dose and generated calendar rows for it.
                            qtyToSave = cellElement.value !== "" ? cellElement.value.toString() : null;
                            if (qtyToSave !== null && this.isZeroOutsideVariable(qtyToSave)) {
                                cellElement.value = '';
                                cellElement.classList.remove('blue-input');
                                qtyToSave = null;
                            }
                        } else {
                            // Cell not rendered (grid mid-rebuild): keep what the payload has so a
                            // DOM flush can't wipe a manual edit.
                            const existing = currentTimes.find(ct => ct.week === w && ct.day === dayName && (ct.time === timeVal || (ct.times && ct.times.time === timeVal)));
                            if (existing) {
                                qtyToSave = (existing.times && existing.times.qty) || existing.qty || null;
                            }
                        }

                        if (qtyToSave !== null) {
                            dayActive = true;
                            const dose = {
                                qty: qtyToSave,
                                time: timeVal,
                                cellId: cellId,
                                date: dates[day].date,
                                week: w,
                                sliding_scale: false
                            };
                            saveArray.push({ day: dayName, week: w, times: dose });
                            currentWeekSaveArray.push({ day: dayName, week: w, times: dose });
                            dayEntry.times.push(dose);
                        }
                    }
                    if (dayActive) {
                        multiWeekDoseTimes.push(dayEntry);
                    }
                }

                // DATA INTEGRITY FIX: Only store the current week's data in the indexed weeks object
                if (w === this.currentWeekIndex) {
                    this.weeks[`week${w}`] = currentWeekSaveArray;
                }
            }
            
            this.form.prescription_payload.times = saveArray;

            if (this.isVariableMode) {
                this.form.prescription_payload.dose_times = multiWeekDoseTimes;
            }
            
            console.log('THIS IS THE SAVE ARRAY', saveArray, this.form.prescription_payload.times);
            
            // UI weekly_schedule mapping (7-day template for the grid)
            let weeklyschedule = [
                { day: "SU", dayId: 0, times: [] },
                { day: "MO", dayId: 1, times: [] },
                { day: "TU", dayId: 2, times: [] },
                { day: "WE", dayId: 3, times: [] },
                { day: "TH", dayId: 4, times: [] },
                { day: "FR", dayId: 5, times: [] },
                { day: "SA", dayId: 6, times: [] }
            ];
            
            if (this.form.prescription_payload.times) {
                this.form.prescription_payload.times.forEach(time => {
                    weeklyschedule.forEach(dayOfWeek => {
                        if (time.day == dayOfWeek.day) {
                            // Avoid duplicates in the UI template row if multiple weeks have the same time
                            if (!dayOfWeek.times.some(t => t.time === time.times.time)) {
                                dayOfWeek.times.push(time.times);
                            }
                        }
                    });
                });
            }
            this.weekly_schedule = weeklyschedule;
            console.log('THIS THE LOCAL VARIABLE WEEKLYSCHEDULE', weeklyschedule);
            this.updateInstructions();
        },
        customInputSchedule(cellId) {
            this.$store.dispatch('getRefreshToken');
            const element = this.$el.querySelector(`#${cellId}`);
            if (!element) return;

            if (element.value) {
                element.classList.add('blue-input');
            } else {
                element.classList.remove('blue-input');
            }
            
            this.saveWeeklySchedule();
            this.updateInstructions();
        },
        populateWeeklySchedule() {
            this.$store.dispatch('getRefreshToken');
            this.isPopulating = true;
            try {
                const freq = this.form && this.form.prescription_payload && this.form.prescription_payload.frequency;
                let isVarCal = this.isVariableMode;
                if (freq && (freq === 'variable' || freq.period === 'variable')) isVarCal = true;

                // ANCHOR FIX: Clear all variable dose cells first so disabled/past cells show up blank
                if (isVarCal) {
                    const allCells = this.$el.querySelectorAll('.schedule-input');
                    allCells.forEach(cell => {
                        if (cell.id && cell.id.startsWith('vcell-')) {
                            cell.value = '';
                            cell.classList.remove('blue-input');
                        }
                    });
                }

                if (this.form.prescription_payload.times) {
                    this.form.prescription_payload.times.forEach(item => {
                        const dose = item.times || item;
                        const time = dose.time;
                        const day = item.day;
                        const week = item.week !== undefined ? item.week : (dose.week !== undefined ? dose.week : 0);
                        
                        const cellId = `vcell-${week}-${day}-${time}`;
                        const element = this.$el.querySelector(`#${cellId}`);
                        if (element) {
                            element.value = (dose.qty !== undefined && dose.qty !== null) ? dose.qty.toString() : '';
                            if (dose.qty && dose.qty !== '0') {
                                element.classList.add('blue-input');
                            } else {
                                element.classList.remove('blue-input');
                            }
                        }
                    })
                }
            } finally {
                this.isPopulating = false;
            }
        },
        populateVariableScheduleCells() {
            this.$store.dispatch('getRefreshToken');
            setTimeout(() => {
                this.weeks[`week${this.currentWeekIndex}`].forEach((time) => {
                    if (this.$el.querySelector(`#${time.cellId}`)) {
                        this.$el.querySelector(`#${time.cellId}`).value = (time.qty !== null && time.qty !== undefined) ? time.qty.toString() : '';
                        if (time.qty) {
                            this.$el.querySelector(`#${time.cellId}`).classList.add('blue-input')
                        } else {
                            this.$el.querySelector(`#${time.cellId}`).classList.remove('blue-input')
                        }
                    }
                })

            }, 300)

        },
        clearWeeklySchedule() {
            this.$store.dispatch('getRefreshToken');
            let inputs = this.$el.getElementsByClassName('schedule-input');

            for (let item of inputs) {
                console.log('trying to clear weekly schedule', item, inputs);
                // item.firstElementChild
                if (item) {
                    console.log('CLEARING VALUE HERE', item.value);
                    item.value = null;
                    item.classList.remove('blue-input')
                    item.value = null;
                }
            }
            // document.getElementsByClassName('schedule-input').forEach(item=>{
            //     console.log('CLEARING VALUE HERE', item.firstElementChild.value);
            //     item.firstElementChild.value = null;
            //     item.firstElementChild.classList.remove('blue-input')
            //     item.value = null;
            // })
        },
        updateInstructions() {
            this.$store.dispatch('getRefreshToken');
            if (!this.form.prescription_payload.frequency) return;
            let instructionList = [];
            const groupBy = (x, f) => x.reduce((a, b) => ((a[f(b)] ||= []).push(b), a), {});
            
            // Helper to get day name from index (0=Sun, 6=Sat)
            const getDayName = (index) => ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][index];

            // Helper to format a list of day indices into shorthand (e.g. [1,2,3,6] -> "Mon to Wed and Sat")
            const formatDayRange = (indices) => {
                if (!indices.length) return "";
                indices.sort((a, b) => a - b);
                let groups = [];
                let currentGroup = [indices[0]];

                for (let i = 1; i < indices.length; i++) {
                    if (indices[i] === indices[i - 1] + 1) {
                        currentGroup.push(indices[i]);
                    } else {
                        groups.push(currentGroup);
                        currentGroup = [indices[i]];
                    }
                }
                groups.push(currentGroup);

                return groups.map(group => {
                    if (group.length >= 3) {
                        return `${getDayName(group[0])} to ${getDayName(group[group.length - 1])}`;
                    } else if (group.length === 2) {
                        return `${getDayName(group[0])} and ${getDayName(group[1])}`;
                    } else {
                        return getDayName(group[0]);
                    }
                }).join(", ").replace(/, ([^,]*)$/, " and $1");
            };

            if ((this.form.prescription_payload.frequency?.period == 'Daily' || this.form.prescription_payload.frequency?.period == 'Monthly') && !this.isVariableMode) {
                if (this.form.prescription_payload.frequency?.frequency_name && this.form.prescription_payload.frequency.frequency_name.includes('Hourly') && parseInt(this.form.prescription_payload.frequency.frequency_name.split(' ')[0]) < 4) {
                    let range = ``
                    if(this.selectedChart.chart_name == "prn") {
                        if(this.form.prescription_payload.dose < this.form.prescription_payload.max_admin_dose) {
                            range = `-${this.form.prescription_payload.max_admin_dose}`
                        }
                    }
                    instructionList.push(`Give ${this.form.prescription_payload.dose ? this.form.prescription_payload.dose : '1'}${range} ${this.form.prescription_payload.dose_unit}/s every ${this.form.prescription_payload.frequency?.frequency_name?.split(' ')[0] || ''} hour${parseInt(this.form.prescription_payload.frequency?.frequency_name?.split(' ')[0] || 0) > 1 ? 's': ''}. \n`)
                } else {
                    let groupedQuantities = groupBy(this.schedule_quantity, v => (v.qty));
                    if(this.selectedChart.chart_name != "prn") {
                        for (const key in groupedQuantities) {
                            let direction = `Give ${key} ${this.form.prescription_payload.dose_unit} at `;
                            groupedQuantities[key].forEach((item, index) => {
                                direction += (index === 0 ? "" : ", ") + item.time;
                            })
                            instructionList.push(direction + '. ');
                        }
                    } else {
                        for (const key in groupedQuantities) {
                            let range = groupedQuantities[key][0].qty < this.form.prescription_payload.max_admin_dose ? `-${this.form.prescription_payload.max_admin_dose}` : "";
                            const direction = `Give ${key}${range} ${this.form.prescription_payload.dose_unit}/s ${this.form.prescription_payload.frequency?.frequency_name || ''} PRN`;
                            instructionList.push(direction + '. ');
                        }
                    }
                }
            } else if (this.form.prescription_payload.frequency?.period == 'Weekly' || this.isVariableMode) {
                // Determine how many weeks to iterate
                const totalWeeks = this.isVariableMode ? this.numWeeks : 1;

                for (let w = 0; w < totalWeeks; w++) {
                    let weekInstructions = [];
                    let patternGroups = {}; // key: pattern string, value: array of day indices

                    for (let d = 0; d < 7; d++) {
                        // Find doses for this specific week and day
                        let dayDoses = this.form.prescription_payload.times.filter(t => {
                            const dayName = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"][d];
                            const doseWeek = t.week !== undefined ? t.week : (t.times && t.times.week !== undefined ? t.times.week : 0);
                            return doseWeek === w && t.day === dayName;
                        });

                        if (dayDoses.length > 0) {
                            // Deduplicate doses for this day to avoid redundant instructions (e.g., "1600 and 1600")
                            const uniqueDoses = [];
                            const seen = new Set();
                            dayDoses.forEach(t => {
                                const qty = t.qty || (t.times && t.times.qty) || '';
                                const time = t.time || (t.times && t.times.time) || '';
                                // Robust key conversion to avoid duplicate instructions due to type mismatches or whitespace
                                const key = `${String(time).trim()}:${String(qty).trim()}`;
                                if (!seen.has(key)) {
                                    seen.add(key);
                                    uniqueDoses.push({time, qty});
                                }
                            });

                            // Create a stable pattern key (e.g., "0800:2|2000:2")
                            const pattern = uniqueDoses
                                .map(d => `${d.time}:${d.qty}`)
                                .sort()
                                .join('|');
                            
                            if (!patternGroups[pattern]) patternGroups[pattern] = [];
                            patternGroups[pattern].push(d);
                        }
                    }

                    // Build instructions for each pattern group in this week
                    for (const pattern in patternGroups) {
                        const days = patternGroups[pattern];
                        const doses = pattern.split('|').map(p => p.split(':')); // Array of [time, qty]
                        
                        // Group by quantity to make it "Give 2 at 0800 and 2000"
                        const groupedByQty = doses.reduce((acc, [time, qty]) => {
                            if (!acc[qty]) acc[qty] = [];
                            acc[qty].push(time);
                            return acc;
                        }, {});

                        for (const qty in groupedByQty) {
                            const timesStr = groupedByQty[qty].join(" and ");
                            const daysRange = formatDayRange(days);
                            
                            // "0" DOSE FIX: Allow "0" to be printed as the quantity instead of defaulting to main dose
                            const displayQty = (qty !== undefined && qty !== null && qty !== '') ? qty : (this.form.prescription_payload.dose || '0');
                            
                            weekInstructions.push(`Give ${displayQty} ${this.form.prescription_payload.dose_unit} at ${timesStr} ${daysRange}`);
                        }
                    }

                    if (weekInstructions.length) {
                        if (totalWeeks > 1) {
                            instructionList.push(`Week ${w + 1}: ${weekInstructions.join(", ")}. \n`);
                        } else {
                            instructionList.push(`${weekInstructions.join(". ") + ". "} \n`);
                        }
                    }
                }
            }

            // Assemble final notes string
            const separator = '-------Please write any additional notes below this line------- \n';
            let notesContent = this.form.prescription_payload.notes || '';
            const existingUserNotes = notesContent.split(separator)[1] || '';
            
            let finalNotes = instructionList.join('');
            if (this.form.prescription_payload.route) finalNotes += this.form.prescription_payload.route + ' \n';
            if (this.selectedUse) finalNotes += this.selectedUse + ' \n';
            
            finalNotes += separator + existingUserNotes;
            this.form.prescription_payload.notes = finalNotes;
            console.log('updated instructions notes', finalNotes);
        },
        applyDoseToSchedule() {
            // The Quantity field is the chart level dose, so changing it should follow through to
            // every dose time. updateDoseSchedule() no longer rewrites the grid's quantities (it
            // was flattening per-time doses on load), so push the new dose in from here instead -
            // the prescriber can re-customise individual cells afterwards.
            const period = this.form.prescription_payload.frequency
                ? (this.form.prescription_payload.frequency.period || this.form.prescription_payload.frequency)
                : '';
            if (!this.isVariableMode && period !== 'variable') {
                const dose = (this.form.prescription_payload.dose || '1.00').toString();
                this.schedule_quantity.forEach(t => {
                    if (t) t.qty = dose;
                });
            }
            this.updateDoseSchedule();
        },
        // A saved weekly chart opens from its own dose times, not from its frequency template.
        // The load path used to set the matched frequency option and call updateDoseSchedule(),
        // which takes the days from the template and the quantity from the chart level dose -
        // a chart customised to Tue/Thu/Sat under a "Mon & Wed" template reopened as Mon/Wed 2,
        // and re-saved that way. Times were already protected (scheduleTimesCustomised); this
        // covers days and per-day quantities, the way the variable path reconstructs its weeks.
        // The one rule about zeros. Outside variable dosing a 0 in a grid cell means "no dose on
        // this day" - it was the prescriber's way of removing a day back when a cleared cell was
        // put back from the payload, and it otherwise goes to the backend as a real dose time that
        // generates calendar rows for 0 and a "Give 0 ..." instruction. Variable dosing keeps 0 as
        // a value (updateInstructions prints it on purpose). Applied where the grid is read
        // (saveWeeklySchedule) and where a saved chart is loaded (hydrateWeeklyScheduleFromSaved);
        // payload and instructions derive from those, so they need no rule of their own.
        isZeroOutsideVariable(qty) {
            if (this.isVariableMode || isVariableFrequency(this.form.prescription_payload.frequency)) {
                return false;
            }
            return qty !== null && qty !== undefined && String(qty).trim() !== '' && Number(qty) === 0;
        },
        hydrateWeeklyScheduleFromSaved(doseTimes) {
            const times = [];
            (doseTimes || []).forEach(dayEntry => {
                if (!dayEntry.day) return;
                (dayEntry.times || []).forEach(dose => {
                    if (this.isZeroOutsideVariable(dose.qty)) return;
                    times.push({
                        day: dayEntry.day,
                        week: 0,
                        times: {
                            qty: dose.qty,
                            time: dose.time,
                            cellId: `vcell-0-${dayEntry.day}-${dose.time}`,
                            date: dose.date || '',
                            week: 0,
                            sliding_scale: dose.sliding_scale || false
                        }
                    });
                });
            });

            this.form.prescription_payload.times = times;
            this.schedule_quantity = this.unique(times.map(t => ({ ...t.times })), 'time');
            this.scheduleTimesCustomised = true;

            const weeklySchedule = [
                { day: "SU", dayId: 0, times: [] },
                { day: "MO", dayId: 1, times: [] },
                { day: "TU", dayId: 2, times: [] },
                { day: "WE", dayId: 3, times: [] },
                { day: "TH", dayId: 4, times: [] },
                { day: "FR", dayId: 5, times: [] },
                { day: "SA", dayId: 6, times: [] }
            ];
            times.forEach(t => {
                const dayObj = weeklySchedule.find(d => d.day === t.day);
                if (dayObj) {
                    dayObj.times.push(t.times);
                }
            });
            this.weekly_schedule = weeklySchedule;
            this.form.prescription_payload.dose_times = weeklySchedule.filter(d => d.times.length);

            // Same render-then-paint sequence as updateDoseSchedule: the grid's v-if waits on
            // readyToDisplaySchedule, and populateWeeklySchedule finds cells by id.
            setTimeout(() => {
                this.readyToDisplaySchedule = true;
                this.$nextTick(() => {
                    this.populateWeeklySchedule();
                    this.updateInstructions();
                });
            }, 400);
        },
        updateDoseSchedule(force = false) {
            this.$store.dispatch('getRefreshToken');
            
            // CRITICAL GUARD: Do not reset the schedule if we are in Variable Mode 
            // unless explicitly forced (e.g. by the "Reset to Template" button).
            // This prevents automated resets from wiping custom manual edits.
            if (!force && this.isVariableMode && this.form.prescription_payload.times && this.form.prescription_payload.times.length > 0) {
                console.log('Blocking automated updateDoseSchedule as we are in Variable Mode');
                return;
            }

            console.log('BEING CALLED', force ? '(FORCED)' : '(AUTOMATED)');

            // Only `force` means "take the frequency template's days". An unforced rebuild - the
            // Quantity field via applyDoseToSchedule - keeps the days already on the chart, or a
            // weekly chart hydrated from its saved dose times snapped back to the template's days
            // the moment the dose was changed. Captured before weekly_schedule is reset below.
            const savedDays = force
                ? []
                : [...new Set((this.form.prescription_payload.times || []).map(t => t.day).filter(Boolean))];

            this.weekly_schedule = [
                { day: "SU", dayId: 0, times: [] },
                { day: "MO", dayId: 1, times: [] },
                { day: "TU", dayId: 2, times: [] },
                { day: "WE", dayId: 3, times: [] },
                { day: "TH", dayId: 4, times: [] },
                { day: "FR", dayId: 5, times: [] },
                { day: "SA", dayId: 6, times: [] }
            ];
            
            this.clearWeeklySchedule();
            // The grid is being rebuilt, so a banner about keystrokes rejected in the old one no
            // longer describes anything on screen.
            this.timeValidationError = '';
            this.timeBeforeEdit = null;
            console.log('Frequency Update:', this.form.prescription_payload.frequency);
            
            // Only `force` means "take the frequency template" - see the note below. Mount calls
            // this unforced after setting interval from the saved chart, so applying the
            // template's interval here reopened an "every 2 days" chart as every 1 day and
            // re-saved it that way on amend.
            if (force && this.form.prescription_payload.frequency) {
                this.form.prescription_payload.interval = parseInt(this.form.prescription_payload.frequency.interval) || 1;
            }

            // Sync prescribed_times array from frequency template.
            // `|| {}` because frequency is '' until one is picked and can come back null from a
            // saved chart, while the Quantity field can call in at any time.
            const freq = this.form.prescription_payload.frequency || {};
            const dose = (this.form.prescription_payload.dose || '1.00').toString();
            // `force` means "take the frequency template's times": the prescriber picked a new
            // frequency, or hit Reset to Template. Every other caller - notably the Quantity
            // field, which also fires this - must leave the grid's times alone, or changing the
            // dose would snap a customised 0700 (or a saved chart's own times) back to the
            // template's 0800 and, because the daily payload is built straight off
            // schedule_quantity, write the template times over the patient's real ones on sign.
            if (force) this.scheduleTimesCustomised = false;
            const keepEditedTimes = this.scheduleTimesCustomised && this.schedule_quantity.length > 0;
            const timesFromFreq = keepEditedTimes ? this.schedule_quantity.map(t => t.time) : (freq.times || []);
            // Per-time quantities, kept alongside the times they belong to. The template carries
            // one dose for every time, so rebuilding the grid from `dose` alone flattened a chart
            // saved as 2 at 0800 and 1 at 2000 back to 2 and 2 - on load, and again whenever the
            // Quantity field fired this.
            const savedQty = new Map((this.schedule_quantity || []).map(t => [t.time, t.qty]));
            const qtyFor = (timeStr) => {
                if (freq.period === 'variable') return '';
                if (!keepEditedTimes) return dose;
                const saved = savedQty.get(timeStr);
                return (saved === undefined || saved === null || saved === '') ? dose : saved;
            };
            const daysFromFreq = savedDays.length ? savedDays : (freq.days_of_week || []);
            const weekDates = this.getWeekDates(0);

            // Clear and rebuild payload times for Week 0
            this.form.prescription_payload.times = [];
            
            this.weekly_schedule.forEach((dayObj, dayIndex) => {
                const matchesFreq = daysFromFreq.length === 0 || daysFromFreq.some(val => {
                    const v = val.toUpperCase();
                    const d = dayObj.day.toUpperCase();
                    return v.startsWith(d) || d.startsWith(v);
                });
                const isActiveDay = matchesFreq && weekDates[dayIndex].edit;
                
                if (isActiveDay) {
                    timesFromFreq.forEach(timeStr => {
                        const doseObj = {
                            qty: qtyFor(timeStr),
                            time: timeStr,
                            cellId: `vcell-0-${dayObj.day}-${timeStr}`,
                            date: weekDates[dayIndex].date,
                            week: 0,
                            sliding_scale: false
                        };
                        
                        this.form.prescription_payload.times.push({
                            day: dayObj.day,
                            week: 0,
                            times: doseObj
                        });
                        
                        dayObj.times.push(doseObj);
                    });
                }
            });

            // When the times are already the prescriber's (or a saved chart's), the grid holds the
            // right entries with their quantities, dates and sliding_scale flags - rebuilding it
            // from the times alone threw all of that away. Only reseed from the template.
            if (!keepEditedTimes) {
                this.schedule_quantity = (freq.times || []).map(tStr => ({
                    time: tStr,
                    qty: dose
                }));
            }

            setTimeout(() => {
                console.log('CALLING THE POPULATE FUNCTION');
                // Render the grid before painting values into it. populateWeeklySchedule finds
                // the qty cells by id, and readyToDisplaySchedule is what the table's v-if is
                // waiting on, so populating first found no cells and left the day columns blank -
                // then the next cell or time edit had saveWeeklySchedule scrape those empty cells
                // and drop the day's dose out of dose_times.
                this.readyToDisplaySchedule = true;
                this.$nextTick(() => {
                    this.populateWeeklySchedule();
                    this.updateInstructions();
                });
            }, 400);
        },
        addSlidingTable() {
            this.$store.dispatch('getRefreshToken');
            // INR only needs a single reading range to check administrations against (the
            // downstream safe-range check in slidingScale.js's getSafeRangeFromSlidingScale
            // treats the whole scale as one min/max envelope regardless of band count, and in
            // practice INR dosing only ever needs one) - multiple INR bands aren't a supported
            // pattern, so don't add a second band once one already exists for an INR-typed
            // scale. This is called from several places (the "sliding" checkbox handler, the
            // isWarfarinOrINR watcher, displaySlideTable, and the template's Add button - which
            // is itself hidden for this case, but guarding here covers the other callers too).
            if (
                this.isWarfarinOrINR &&
                this.form.prescription_payload.sliding_scale &&
                this.form.prescription_payload.sliding_scale.length >= 1
            ) {
                return;
            }
            console.log('adding sliding column')
            let slideTable = {
                name: this.slidingScaleType ? this.slidingScaleType.unit : 'BGL',
                min: '',
                max: '',
                value: '',
                reading: null,
            }
            this.form.prescription_payload.sliding_scale.push(slideTable);
        },
        updateSlidingScaleType() {
            if (this.form.prescription_payload.sliding_scale && this.form.prescription_payload.sliding_scale.length) {
                // Switching the dropdown to INR after multiple bands were already entered
                // under a different type (e.g. BGL) would otherwise leave more than one INR
                // band, which addSlidingTable() no longer allows going forward - collapse down
                // to just the first band so the scale is left in a state consistent with that
                // rule.
                if (
                    this.slidingScaleType &&
                    this.slidingScaleType.label === 'INR' &&
                    this.form.prescription_payload.sliding_scale.length > 1
                ) {
                    this.form.prescription_payload.sliding_scale = [
                        this.form.prescription_payload.sliding_scale[0],
                    ];
                }
                this.form.prescription_payload.sliding_scale.forEach(scale => {
                    scale.name = this.slidingScaleType.unit;
                });
            }
        },
        removeSlidingTable() {
            this.form.prescription_payload.sliding_scale.pop();
        },
        displaySlideTable() {
            console.log('DISPLAY SLIDING TABLE FORM', this.form.prescription_payload);
            this.sliding = false;
            this.schedule_quantity.forEach(item => {
                if (item.sliding_scale) {
                    this.sliding = true;
                    if(this.form.prescription_payload.sliding_scale?.length == 1 && !this.form.prescription_payload.sliding_scale[0].min){
                        this.form.prescription_payload.sliding_scale = [];
                        this.addSlidingTable();
                    } else{
                        this.addSlidingTable();
                    }
                }
            })
        },
        validateSlidingTables() {
            this.$store.dispatch('getRefreshToken');
            this.form.prescription_payload.sliding_scale.forEach((scale, index) => {
                if (!scale.value) {
                    this.form.prescription_payload.sliding_scale.splice(index, 1);
                }
            })
        },
        show() {
            this.$store.dispatch('getRefreshToken');
            console.log('HITING SAVE FUNCTION');
            let interval = setInterval(() => {
                console.log('HITTING INTERVAL');
                if (!this.loadingDrugs && this.drugList.length) {
                    clearInterval(interval);
                    this.$refs.med.show();
                }
            }, 100)
        },
        addIDToReview() {
            this.$store.dispatch('getRefreshToken');
            let id = this.parentIndex + '';

            this.$emit('addToReview', {
                prescription_id: this.activePresChart.chart_payload.prescription_id,
                status: this.activePresChart.chart_payload && this.activePresChart.chart_payload.chart_form && (this.activePresChart.chart_payload.chart_form.type != 'stat' && this.activePresChart.chart_payload.chart_form.type != 'short_term')
                    ? 'continue'
                    : 'reviewed'
                });
            this.$emit('displayItem', id);
        },
        removeIDFromReview() {
            this.$emit('removeFromReview', this.form.chart_payload.prescription_id);
            //  this.$emit('displayItem', id);
        },
        formatDate(start_or_end) {
            console.log('its the', start_or_end, this.stop_date?.toString().includes('/'), this.start_date, this.form.prescription_payload);
            if (start_or_end == 'end') {
                if(!this.stop_date?.toString().includes('/')){
                    console.log('hitting thie sstop date condition that does not include slash', this.stop_date)
                    this.form.prescription_payload.stop_date = new Date(this.stop_date).toLocaleDateString('en-AU');
                } 
            } else {
                
                if(!this.form.prescription_payload.start_date || (this.start_date && !this.start_date.toString().includes('/'))){
                    this.form.prescription_payload.start_date = this.start_date ? new Date(this.start_date).toLocaleDateString('en-AU') : new Date().toLocaleDateString('en-AU');
                }
                
                if(this.stop_date && !this.stop_date.toString().includes('/')){
                    console.log('hitting thie sstop date condition that does not include slash', this.stop_date)
                    this.form.prescription_payload.stop_date = new Date(this.stop_date).toLocaleDateString('en-AU');
                } 

            }
            console.log('this is the end of the formatdate function', this.start_date);
        },
        stopAction(value) {
            if (value == true) {
                this.cancelAction = true;
                this.close(value);
            }
            if (value == false) {
                this.cancelAction = false;
            }
        },
        readHeightMeasurer() {
            this.$store.dispatch('getRefreshToken');
            console.log('this is the height', this.$refs['height-measurer' + this.parentIndex].clientHeight);
            setTimeout(() => {
                this.$emit('updateHeightCheck', { checkHeight: false, index: this.parentIndex, height: this.$refs['height-measurer' + this.parentIndex].clientHeight });

            }, 100)
        },
        closeError(value) {
            if (value) {
                this.displayErrorModal = false;
            }
        },
        closePhoneOrder(value) {
            if (value) {
                this.displayPhoneOrderModal = false;
                this.displaySuccessModal = false;
            }
        },
        closeDoseTimes(value) {
            if (value) {
                this.displayScheduledDoseTimesModal = false;
            }
        },
        close(value) {
            this.displayQuestionnaire = false
            this.$store.dispatch('getRefreshToken');
            if (value) {
                this.displaySuccessModal = false;
                this.displaySignatureModal = false;
                this.displayCMIPIModal = false;
                // this.displayMessage = '';
                // this.displayMessage2 = '';
                console.log('closing prescription chart success modal');
                if (!this.chartReview && !this.displayStreamlineCodeModal && !this.renewExpired) {
                    console.log('testing retrieveallcharts --- refreshlist - isSuccessful -- close if');
                    this.$emit('isSuccessful', true);
                } else {
                    this.displayStreamlineCodeModal = false;
                }
                if (this.displayMessage.includes('success') && !this.chartReview) {
                    window.location.reload();
                }
                if(this.closeOnRenew){
                    console.log('testing retrieveallcharts --- refreshlist - isSuccessful -- closeOnRenew');
                    this.$emit('isSuccessful', true);
                }
            }
        },
        closePBSModal(value){
            if(value){
                console.log('hitting the close pbs modal', value);
                this.displayPBSAlertModal = false;
            }
        },
        closeCMICP() {
            this.$store.dispatch('getRefreshToken');
            this.displayCMIPIModal = false;
        },
        mimsImageChanged(value) {
            this.$store.dispatch('getRefreshToken');
            this.mimsImage = value;
        },
        confirmCode(value) {
            this.$store.dispatch('getRefreshToken');
            console.log('THIS IS THE value confirmcode', value);
            if (value) {
                this.pbsFilter = 'pbs';

                // Set the prescription_payload.indication to the text before \n in value.indication
                this.form.prescription_payload.indication = value.indication ? value.indication.split(/\r?\\n/g, 1)[0].trim() : '';

                this.form.prescription_payload.pbs_code = value.pbs_code;
                this.form.prescription_payload.pbs_manufacturer_code = value.pbs_manufacturer_code;
                this.selected_pbs_code = value;
                this.form.prescription_payload.prescribed_quantity = JSON.stringify(value.max_quantity);
                this.displayStreamlineCodeModal = false;
                this.pbs_type = value.restriction_flag;
                if (value.restriction_flag != 'A') {
                    this.form.prescription_payload.pbs_authority_code = value.indication_id;
                } else {
                    this.displayPBSAlertModal = true;
                }
            }
        },
        translatePbsType(pbsType){
            if(pbsType == "A"){
                return "Authority Required";
            }
            if(pbsType == "S"){
                return "Streamlined";
            }
            return "PBS";

        },
        passAuthCode(value){

            this.$store.dispatch('getRefreshToken');
            console.log('passauthcode value', value);
            this.generateCode = true;
            if((this.cancelPrescriptionFirst && this.activePresChart?.chart_payload?.prescription_id) || !this.form.chart_payload.prescription_id || (this.form.chart_payload.prescription_id && !this.form.prescription_payload.authority_prescription_number) || this.dashboardRenew || !this.activePresChart){
                this.hasAuthCode = true;
                console.log('hitting if condition on passauthcode');
                // If we need to cancel a prescription first, set the old_prescription_id on the payload
                if((this.cancelPrescriptionFirst && this.activePresChart?.chart_payload?.prescription_id) || (this.form.chart_payload.prescription_id && this.form.prescription_payload.authority_prescription_number)){
                    this.form.prescription_payload.old_prescription_id = this.form.chart_payload.prescription_id ? this.form.chart_payload.prescription_id : this.activePresChart?.chart_payload?.prescription_id;
                }
                if(this.dashboardRenew){
                    console.log('hitting passauthcode, dashboard renew if conditional', value);
                    this.createChart(false,true, true);
                } else{
                    this.createChart(false,false);
                }
            } else{
                console.log('hitting else condition on passauthcode');
                if (this.activePresChart?.chart_payload?.prescription_id) {
                    axios.post('/apn/create', {prescription_id: this.activePresChart.chart_payload.prescription_id, prescriber: JSON.parse(localStorage.getItem('user_id'))}, this.$store.state.header)
                    .then(response=>{
                        // Do error handling here 
                        console.log(response)
                        this.form.prescription_payload.authority_prescription_number = response.data.authority_prescription_number;
                        this.hasAuthCode = true;
                    })
                    .catch(error => {
                        this.displayPBSAlertModal = false
                        this.loading = false
                        this.error_message = error.response.data.message
                        this.displayMessage2 = error.response.data.errors
                        this.displayMessage = 'Error: ' + this.error_message
                        console.log('HITTING CREATE ERROR', this.error_message)
                    })
                } else {
                    console.error('Cannot create APN: activePresChart not available');
                }
            }
        },
        getFirstAdminRoundTime(){
            if(this.form?.chart_payload?.prescription_id || this.prescription_id){
                axios.post(`/prescription/${this.form?.chart_payload?.prescription_id ? this.form?.chart_payload.prescription_id : this.prescription_id}/admin-schedule`, {}, this.$store.state.header).then(res=>{
                        this.adminSchedule = res.data;
                })
            }
        },
        passPhoneCode(value) {
            this.$store.dispatch('getRefreshToken');
            if (value) {
                this.form.prescription_payload.pbs_authority_code = value;
                this.prescription_date = new Date();
                console.log('hitting the close pbs modal pass phone code func', value);
                this.displayPBSAlertModal = false;
            }
        },
        successfullySubmitted(value) {
                this.$store.dispatch('getRefreshToken');
                if (value) {
                    if (!this.chartReview) {
                        console.log('testing retrieveallcharts --- refreshlist - isSuccessful -- successfullySubmitted');
                        this.$emit('isSuccessful', true);
                    } else {
                        this.$emit('softRefresh');
                    }
                    this.displaySuccessModal = false;
                    this.displaySignatureModal = false;
                    this.editingPrescription = false;
                    // Prevent a previously typed cancellation reason from silently
                    // attaching to a future, unrelated cancellation.
                    this.cancelReason = '';

                    if(!this.chartReview && !this.displayMessage.includes("Error")){
                    this.displayPhoneOrderModal = false;
                    if(!this.chartReview){
                        this.clearForm();
                        this.clearCustomMedForm();
                    }
                    this.displayMessage = '';
                    this.displayMessage2 = '';
                    if (this.chartReview && this.activePresChart?.chart_payload?.prescription_id) {
                        this.$emit('addToReview', { prescription_id: this.activePresChart.chart_payload.prescription_id, status: 'continue' });
                    }
                }
            }
        },
        confirmCancelWithReason() {
            this.displayCancelReasonModal = false;
            this.addedToReview = true;
            this.cancelPrescription();
        },
        closeCancelReasonModal() {
            // Dismissing without continuing - clear so it can't leak into a later,
            // unrelated cancellation attempt.
            this.displayCancelReasonModal = false;
            this.cancelReason = '';
        },
        // Payload for the controlled-drug (S8) cancellation signature modal - built once and
        // reused both for the initial S8 path and the "backend determined it's actually S8"
        // graceful-upgrade path below, so they can't drift out of sync.
        buildCancelSignaturePayload(force_cease) {
            return {
                prescription_id: this.activePresChart.chart_payload.prescription_id,
                // A transitional conformance item was signed locally and never reached eRx, so it
                // must be cancelled locally regardless of whether it carries a signature.
                no_erx: !this.activePresChart.prescription_payload.signed || this.isTransitionalConformance,
                s8: true,
                force_cease: force_cease,
                reason: this.cancelReason,
                // Cancelling/ceasing a prescription only ever requires a single (primary)
                // signature - there is never a witness signature for a cancellation, so this
                // must stay false to stop SignatureModal's dual-signature (primary+witness) UI
                // from being forced for scheduled/S8 drugs.
                has_scheduled_items: false
            };
        },
        cancelPrescription(force_cease = false) {
            this.$store.dispatch('getRefreshToken');
            this.forceCeaseRequired = false;
            // If S8, we need to sign (scheduled is S8)
            if (this.activePresChart && this.activePresChart.prescription_payload && this.activePresChart.prescription_payload.scheduled) {
                // Set the endpoint and payload for the signature modal
                this.endpoint = `/prescription/cancel`;
                this.payload = this.buildCancelSignaturePayload(force_cease);
                // Display the signature modal for authorization
                this.displaySignatureModal = true;
            } else {
                // Else, cancel normally with our timer
                console.log('CANCEL PRESCRIPTION FUNCTION RUNNING');
                let timer = 1;
                this.displaySuccessModal = true;
                
                let interval = setInterval(() => {
                    timer--;
                    this.displayMessage = `${timer}`;
                    this.loadingDelay = true;
                    if (timer == 0 || this.cancelAction == true) {
                        clearInterval(interval);
                        this.loadingDelay = false;
                        this.displayMessage = 'Cancelling prescription...';
                        if (this.cancelAction == true) {
                            console.log('CANCELLING THE ACTION', this.cancelAction)
                        }
                        if (this.cancelAction == null) {
                            console.log('Cancel action should be null', this.cancelAction)
                            if (this.activePresChart && this.activePresChart.chart_payload.prescription_id) {
                                console.log('should be submitting cancel prescription request', this.activePresChart);
                                if (this.chartReview) {
                                    this.$emit('addToReview', { prescription_id: this.activePresChart.chart_payload.prescription_id, status: 'cancelled' });
                                }
                                // no_erx also covers transitional conformance - see buildCancelSignaturePayload().
                                axios.post(`/prescription/cancel`, { prescription_id: this.activePresChart.chart_payload.prescription_id, no_erx: !this.activePresChart.prescription_payload.signed || this.isTransitionalConformance, s8: false, force_cease: force_cease, reason: this.cancelReason }, this.$store.state.header).then(res => {
                                    console.log('cancelled the prescription', res.data);
                                    this.displayMessage = 'Successfully cancelled prescription.';
                                    this.cancelReason = '';
                                    this.$store.dispatch('getRefreshToken');
                                    if(!this.chartReview){
                                        console.log('testing retrieveallcharts --- refreshlist - isSuccessful -- cancelPrescription');
                                        this.$emit('isSuccessful', this.activePresChart.chart_payload.prescription_id);
                                    }

                                }).catch(err => {
                                    this.loading = false;
                                    
                                    this.error_message = err.response.data.message ? err.response.data.message : err.response.data;
                                    this.displayMessage = this.error_message;

                                    const detailedError = err.response.data?.errors ? (Array.isArray(err.response.data.errors.message) ? err.response.data.errors.message.join(' ') : String(err.response.data.errors.message)) : null;
                                    
                                    if (detailedError && detailedError !== this.error_message) {
                                        this.displayMessage2 = detailedError;
                                    } else {
                                        this.displayMessage2 = '';
                                    }

                                    console.log('HITTING CREATE ERROR', this.error_message);
                                    if ((this.displayMessage + ' ' + this.displayMessage2).toLowerCase().includes('requires a signature')) {
                                        // Backend determined this is actually a controlled drug (S8) - our client-side
                                        // 'scheduled' flag was stale/wrong. Gracefully upgrade to the signature modal.
                                        this.displaySuccessModal = false;
                                        this.endpoint = `/prescription/cancel`;
                                        this.payload = this.buildCancelSignaturePayload(force_cease);
                                        this.displaySignatureModal = true;
                                    } else if ((this.displayMessage + ' ' + this.displayMessage2).toLowerCase().includes('ceased')) {
                                        this.dismissRequired = true;
                                    } else {
                                        this.forceCeaseRequired = true;
                                        this.forceCreateRequired = true;
                                    }

                                    this.signature = false;
                                })
                            } else {
                                console.log('no active chart to cancel from', this.activePresChart)
                            }
                            this.clearForm();
                        }
                        this.cancelAction = null;
                    }
                }, 1000)
                timer = 1;
            }
        },
        handleSignatureError(err) {
            console.log('Signature Error Handler:', err);
            // If it's a cease error (we assume signature modal is open for cease if endpoint matches)
            if (this.endpoint == '/prescription/cancel') {
                this.displaySignatureModal = false;
                this.displaySuccessModal = true;

                // Robustly extract error data from either Axios error or direct data
                const data = err.response ? err.response.data : err;

                this.error_message = data.message ? data.message : (typeof data === 'string' ? data : JSON.stringify(data));
                this.displayMessage = this.error_message;

                const detailedError = data?.errors ? (Array.isArray(data.errors.message) ? data.errors.message.join(' ') : String(data.errors.message)) : null;
                
                if (detailedError && detailedError !== this.error_message) {
                    this.displayMessage2 = detailedError;
                } else {
                    this.displayMessage2 = '';
                }

                if ((this.displayMessage + ' ' + this.displayMessage2).toLowerCase().includes('ceased')) {
                    this.dismissRequired = true;
                } else {
                    this.forceCeaseRequired = true;
                    this.forceCreateRequired = true;
                }
            }
        },
        dismissChart() {
            this.dismissLoading = true;
            // First cancel with no_erx: true (failsafe), then dismiss
            axios.post(`/prescription/cancel`, {
                prescription_id: this.activePresChart.chart_payload.prescription_id,
                no_erx: true,
                force_cease: false,
                reason: this.cancelReason
            }, this.$store.state.header).then(() => {
                return axios.post('/dismiss-expired-prescriptions', {
                    prescription_ids: [this.activePresChart.chart_payload.prescription_id],
                    no_erx: true
                }, this.$store.state.header);
            }).then(() => {
                this.dismissLoading = false;
                this.cancelReason = '';
                this.closeSuccess();
                this.$emit('refreshList'); // Ensure list is refreshed
            }).catch(err => {
                console.error('Dismissal failed:', err);
                this.dismissLoading = false;
                this.error_message = "Dismissal failed: " + (err.response?.data?.message || err.message || err);
                this.displayMessage = this.error_message;
            });
        },
        forceCeaseAndCreate() {
            this.forceCreateLoading = true;
            const prescriptionIdToCease = this.activePresChart?.chart_payload?.prescription_id || this.form.prescription_payload.old_prescription_id;
            
            axios.post(`/prescription/cancel`, {
                prescription_id: prescriptionIdToCease,
                force_cease: true,
                // Force ceasing a transitional conformance item must stay local. Without this the
                // cease reaches prepChartForErx() with a null chart, which falls back to ERX101 and
                // posts a chart *create* to eRx for a patient deliberately kept off it.
                no_erx: this.isTransitionalConformance,
                reason: this.cancelReason
            }, this.$store.state.header).then(() => {
                // Reset flags
                this.dismissRequired = false;
                this.forceCreateRequired = false;
                this.forceCreateLoading = false;
                this.cancelReason = '';
                this.displayMessage = 'Retrying creation...';
                this.displayMessage2 = '';
                
                // Retry createChart with stored arguments
                if (this.lastCreateArgs) {
                    this.createChart(
                        this.lastCreateArgs.sign,
                        this.lastCreateArgs.renew,
                        this.lastCreateArgs.generateapn,
                        this.lastCreateArgs.phoneOrder,
                        false, // noErx
                        true   // isCeaseAndNewRetry
                    ).catch(err => {
                        this.displayMessage = 'Retry preparation failed.';
                        this.displayMessage2 = err.message || String(err);
                        console.error('Retry creation failed synchronously:', err);
                    });
                } else {
                    this.displayMessage = 'Cannot retry: internal state lost.';
                    this.displayMessage2 = 'Please refresh the page and try again.';
                }
            }).catch(err => {
                console.error('Force cease failed:', err);
                this.dismissLoading = false;
                this.error_message = "Failed to force cease: " + (err.response?.data?.message || err.message);
                this.displayMessage = this.error_message;
            });
        },
        clearForm() {
            this.$store.dispatch('getRefreshToken');
            this.form = {
                chart_payload: {
                    prescription_id: '',
                    chart_form: {
                        type: '',
                        route: '',
                        indication: '',
                        tags: [],
                        schedule_quantity: []
                    }
                },
                prescription_payload:{
                    paper_prescription_number:'',
                    patient_id:'',
                    prescriber:'',
                    drug_uuid:'',
                    sliding_scale:[
                    ],
                    use_pbs:false,
                    pbs_manufacturer_code:'',
                    pbs_code:'',
                    pbs_authority_code:'',
                    pbs_type: '',
                    permit_number:'',
                    authority_prescription_number:'',
                    prescribed_quantity:0,
                    max_times_per_day: 0,
                    unusual_dose:false,
                    dose_unit:'',
                    substitution_not_permitted: false,
                    dose: '',
                    max_dose: '',
                    max_daily_admin: '',
                    max_admin_dose:'',
                    start_date: '',
                    stop_date: '',
                    date_added:'',
                    indication:'',
                    is_paper: false,
                    frequency_shorthand:'',
                    interval: 1,
                    frequency: '',
                    dose_times: [],
                    route: '',
                    reason: '',
                    notes: '-------Please write any additional notes below this line------- \n',
                    instructions:'',
                    additional_regulatory_checks: '',
                    num_repeats_authorised:0,
                    unusual_qty:false,
                    repeat_interval:0,
                    privacy_statement: true,
                    aslr_consent: true,
                    private_prescription: false,
                    emergency_supply: false,
                    ctg: this.patient && this.patient.ctg ? true : false,
                    is_extemp: false,
                    script_ctg_annotation: '',
                    dispense_all_repeats: false,
                    old_prescription_id: '',
                    consent_uuid: ''
                }
            }
            this.formTimes = {
                time1: '',
            }
            this.selectedDrug = {
                full_name: '',
                form: '',
                strength: '',
                measurement_unit: '',
                name: '',
                tags: [],
                drug_uuid: ''
            };
            this.searchedDrugName = '';
            this.packed = '';
            this.now_or_next_pack = '';
            this.single_multi = '';
            this.error_message = '';
            this.sliding = false;
            this.signature = false;
            this.prescription_sign_payload.prescription_id = null;
            this.prescription_sign_payload.is_paper = false;
            this.prescriptionType = '';
            // Starting a fresh chart, so the previous one's calendar is no longer the prescriber's
            // unsaved work and must stop pinning variable mode on against the incoming payload.
            this.variableModeSetLocally = false;


        },
        searchDrugs() {
            this.$store.dispatch('getRefreshToken');
            // Limit search to only every 200ms
            clearTimeout(this.medicationTimer);
            this.medicationTimer = setTimeout(function () {
                console.log("SEARCHING DRUGS");
                if (this.searchedDrugName) {
                    this.loadingDrugs = true;
                    axios.post('/get-drug-aliases', { drug: this.searchedDrugName, generics: parseInt(this.drugSearchFilter) }, this.$store.state.header).then(res => {
                        console.log('this is the res data', res.data);
                        this.$store.dispatch('getRefreshToken');
                        res.data.drug_aliases.forEach(item => {
                            item.full_name = `(${item.generic_name}) ${item.name}`
                        })
                        this.drugList = res.data.drug_aliases;

                        this.loadingDrugs = false;
                        // document.getElementsByClassName('p-dropdown-panel')[0].style.display = 'block';
                    }).catch(err => {
                        console.log('this is the err', err);
                        this.loadingDrugs = false;
                        if (err.response && err.response.data && err.response.data.split(' ').includes('expired')) {
                            console.log('yes, it does include expired')
                            this.$router.push('/login');
                        }
                    })
                }
            }.bind(this), 200);
        },
        handleConsentSelection(val) {
            if (val === 'new') {
                this.form.prescription_payload.consent = 'new';
                this.form.prescription_payload.consent_uuid = '';
                // No longer opening modal, fields are inlined in template
            } else if (val) {
                this.form.prescription_payload.consent = val;
                this.form.prescription_payload.consent_uuid = val.uuid;
            } else {
                this.form.prescription_payload.consent = null;
                this.form.prescription_payload.consent_uuid = '';
            }
        },
        handleConsentSuccess(consentData) {
            console.log('Consent success:', consentData);
            this.$emit('patientConsentUpdated', consentData);
            this.form.prescription_payload.consent_uuid = consentData.uuid;
            this.form.prescription_payload.consent = consentData;
        },
        async submitInlineConsent() {
            if (this.form.prescription_payload.consent !== 'new') return Promise.resolve(null);
            
            this.displayMessage = 'Saving new consent...';
            try {
                const res = await axios.post(`/person/${this.patientId}/consent`, this.newConsent, this.$store.state.header);
                console.log('Inlined consent saved:', res.data);
                this.handleConsentSuccess(res.data);
                return res.data;
            } catch (err) {
                console.error('Error saving inlined consent:', err);
                this.displayErrorModal = true;
                this.errorTitle = 'Consent Error';
                this.errorMessage = 'Failed to save patient consent: ' + (err.response?.data?.message || err.message);
                throw err;
            }
        },
        algoliaDrugSearch(searchedDrugName) {
            var searchName = '';
            this.drugList = [];
            // Check if the search term is the full object or just a string
            if (typeof searchedDrugName === 'object') {
                searchName = searchedDrugName.full_name;
            } else {
                searchName = searchedDrugName;
            }

            // Check if there is brand/generic searching
            // If searching for all meds
            if (this.drugSearchFilter == 0) {
                searchIndex(this.$store.state, `${this.$store.state.subdomain}_drugs`, `typoTolerance=false&query=${searchName}`)
                .then(res => {
                    console.log('this is the algolia res', res.data.hits);
                    this.drugList = sortMedicationList(res.data.hits);
                    // state.commit('setDrugNames', res.data.hits);
                })
                .then(() => {
                    const medListDropdown = document.querySelector('#prescription-med-search_list');
                    medListDropdown.querySelectorAll('.p-dropdown-item.p-focus').forEach((med, index) => {
                        med.classList.remove('p-focus');
                    });
                }).then(() => {
                    const medListDropdown = document.querySelector('#prescription-med-search_list');
                    const firstMed = medListDropdown.querySelector('.p-dropdown-item');
                    if(firstMed) {
                        firstMed.classList.add('p-focus');
                    }
                })
                // Algolia gives up after 5s per host (see services/algoliaSearch.js). On a bad
                // connection that rejection had nothing catching it; the drug list just stays empty.
                .catch(err => {
                    console.log('medication search failed', err);
                })
            } else {
                if(this.drugSearchFilter == 1 || this.drugSearchFilter == 2){
                    var is_generic = true;
                    // If searching for brands
                    if (this.drugSearchFilter == 2) {
                        is_generic = false;
                    }

                    searchIndex(this.$store.state, `${this.$store.state.subdomain}_drugs`, `typoTolerance=false&query=${searchName}&facetFilters=is_generic:${is_generic}`)
                    .then(res => {
                        this.drugList = sortMedicationList(res.data.hits);
                        // this.$refs.med.scrollTop = 0;
                        // state.commit('setDrugNames', res.data.hits);
                    })
                    .then(() => {
                        const medListDropdown = document.querySelector('#prescription-med-search_list');
                        medListDropdown.querySelectorAll('.p-dropdown-item.p-focus').forEach((med, index) => {
                            med.classList.remove('p-focus');
                        });
                    }).then(() => {
                        const medListDropdown = document.querySelector('#prescription-med-search_list');
                        const firstMed = medListDropdown.querySelector('.p-dropdown-item');
                        if(firstMed) {
                            firstMed.classList.add('p-focus');
                        }
                    })
                    .catch(err => {
                        console.log('medication search failed', err);
                    })
                }
                
            }
        },
        algoliaDoseUnitSearch() {
            searchIndex(this.$store.state, 'dose_units', `typoTolerance=false&query=${this.form.prescription_payload.dose_unit}`)
            .then(res => {
                this.doseTypes = res.data.hits;
            })
            .catch(err => {
                console.log('dose unit search failed', err);
            })
        },
        drugSelect(item) {
            if (!item) {
                this.continueDrugSelect(item);
                return;
            }

            // If "Active Ingredient" search is used, we never need to do the brand check
            if (this.drugSearchFilter == 1) {
                this.continueDrugSelect(item);
                return;
            }

            // The local `strength` array contains all the ingredients and their strengths
            if (item.strength && Array.isArray(item.strength)) {
                item.active_ingredients = item.strength.map(ing => ing.name);
            }

            const drugIsLemi = isLemi(item);
            const drugIsLmbc = isLmbc(item);
            
            // Check if brand medication is selected and prompt
            const notGeneric = item.is_generic === false || item.is_generic === "false" || item.is_generic === 0 || item.is_generic === "0";
            
            if (!drugIsLemi && notGeneric) {
                // Do not assign is_lemi here yet, wait until clinically necessary is confirmed
                this.pendingDrugItem = item;
                this.displayBrandPrompt = true;
                if (this.$refs.med) {
                    this.$refs.med.hide();
                }
                return;
            }
            this.form.prescription_payload.is_lemi = drugIsLemi;
            this.continueDrugSelect(item);
        },
        confirmBrand(clinicallyNecessary) {
            this.displayBrandPrompt = false;
            let item = this.pendingDrugItem;
            this.pendingDrugItem = null;
            
            if (clinicallyNecessary) {
                this.form.prescription_payload.is_lemi = false; // We confirmed a brand, so it isn't LEMI
                this.continueDrugSelect(item);
            } else {
                this.searchedDrugName = '';
                this.drugSearchFilter = 1; // Switch back to active ingredient search
                this.clearDrug = true;
                this.drugList = [];
                if (this.$refs.med) {
                    this.$refs.med.hide();
                }
            }
        },
        continueDrugSelect(item) {
            this.generateCode = false;
            this.$store.dispatch('getRefreshToken');
            this.loadingDrugs = true;
            this.pbsFilter = '';
            if (this.$refs.med) {
                this.$refs.med.hide();
            }
            console.log('this is the drug item selected', item);
            this.selectedDrug.drug_uuid = item.alias_id;
            this.loading_pbs = true;
            
            // Fix for [object Object] display
            if (item && item.full_name) {
                this.searchedDrugName = item.full_name;
            }

            if (item && item.tags && (item.tags.includes('s8') || item.tags.includes('S8'))) {
                console.log('includes s8 med, setting schedule to true', item.tags)
                this.scheduledMedicine = true;
            } else {
                console.log('not an s8 med, setting schedule to false', item && item.tags ? item.tags : null)
                this.scheduledMedicine = false;
            }
            this.form.prescription_payload.indication = '';
            this.form.prescription_payload.pbs_code = '';
            this.form.prescription_payload.pbs_authority_code = '';
            this.form.prescription_payload.authority_prescription_number = '';
            this.form.prescription_payload.prescribed_quantity = 0;
            this.selected_pbs_code = '';
            this.hasAuthCode = false;
            // this.getAMTMeds(); // Removed auto-fetch
            this.drugList = []; // Clear previous
            this.ctppList = []; // Clear previous CTPP packs
            this.selectedCTPP = null; // Clear previous
            this.loadingDrugs = false; // Don't show loading yet

            axios.post('/get-pbs', { alias_id: item.alias_id }, this.$store.state.header).then(res => {
                console.log('THESE ARE THE PBS DETAILS');
                this.loading_pbs = false;
                this.pbs_codes = res.data;
                this.flattenPBSCodes();
                // if (this.pbs_codes.length == 1) {
                //     this.form.prescription_payload.pbs_code = this.pbs_codes[0].pbs_code;
                //     this.selected_pbs_code = this.pbs_codes[0];
                //     this.updatePBSPrescription();
                // }
            })
            this.selectedDrug = {
                ...this.selectedDrug,
                full_name: item.full_name,
                form: item.form ? item.form[0].toUpperCase() + item.form.slice(1) : '',
                strength: `${item.strength}`,
                measurement_unit: `${item.measurement_unit}`,
                name: item && item.name ? item.name[0].toUpperCase() + item.name.slice(1) : '',
                tags: item.tags,
                drug_uuid: item.alias_id
            };
            this.loadingDrugs = false;
            // if (this.selectedDrug.form == 'Patch') {
            //     this.doseTypes = ['Patch']
            // } else if(this.selectedDrug.name.includes('drop')){
            //     this.doseTypes = ['drop']
            // }else if(this.selectedDrug.name.includes('cream') || this.selectedDrug.name.includes('ointment') || this.selectedDrug.name.includes('gel')){
            //     this.doseTypes = ['application']
            // }else {
            //     this.doseTypes = [
            //         this.selectedDrug.form,
            //         this.selectedDrug.measurement_unit.split('/')[0]
            //     ]

            //     if (this.selectedDrug.measurement_unit.split('/')[1] != 'each') {
            //         this.doseTypes.push(this.selectedDrug.measurement_unit.split('/')[1]);
            //     }
            // }
            
            this.date_added = new Date().toLocaleString("en-au", { timeZone: "Australia/Sydney" });
            // this.drugList = [];
            // this.searchedDrugName = item.name;
            // this.clearDrug = true;

            this.checkAllergyWarning(item);
        },
        checkAllergyWarning(item) {
            if (!item || !this.patient || !this.patient.adr) {
                return;
            }
            const selectedGeneric = (item.generic_name || '').trim().toLowerCase();
            const selectedName = (item.name || '').trim().toLowerCase();
            const matches = this.patient.adr.filter((adr) => {
                // Matched against the drug database via the alias search field.
                if (selectedGeneric && adr.alias && adr.alias.generic_name &&
                    adr.alias.generic_name.trim().toLowerCase() === selectedGeneric) {
                    return true;
                }
                // Free-text "Custom / Other Substance" entries aren't linked to an alias,
                // so fall back to a name match against whatever was typed in. isAllergyTextMatch
                // requires a minimum length and a word-boundary occurrence for partial matches
                // (exact matches are always honoured) - a raw two-way substring check would
                // over-warn on short entries ("sul", "ace", a stray character) against a large
                // set of unrelated drugs, and alert fatigue on a clinical safety modal is its
                // own safety problem.
                const customText = (adr.custom || '').trim().toLowerCase();
                if (!customText) {
                    return false;
                }
                return (
                    isAllergyTextMatch(customText, selectedGeneric) ||
                    isAllergyTextMatch(customText, selectedName)
                );
            });
            if (matches.length) {
                this.allergyWarningMatches = matches;
                this.pendingAllergyDrugName = item.full_name || item.name;
                this.displayAllergyWarningModal = true;
            }
        },
        acknowledgeAllergyWarning() {
            this.displayAllergyWarningModal = false;
        },
        cancelAllergySelection() {
            this.displayAllergyWarningModal = false;
            this.selectedDrug = {};
            this.searchedDrugName = '';
            this.drugList = [];
        },
        // A 422 means the payload we built was wrong, not that the existing script is in a state
        // the backend won't let us replace. Arming the force cease / force create buttons on one
        // offered ceasing the patient's current script as the way past a missing form field - the
        // cease went through and the retry failed on the same field, leaving no script at all.
        isFormValidationError(err) {
            return err?.response?.status === 422;
        },
        showFormError(err, detailedError = null) {
            const data = err?.response?.data;
            this.displaySuccessModal = false;
            this.displayPhoneOrderModal = false;
            this.displayErrorModal = true;
            this.errorTitle = data?.title ? data.title : 'Form Error';
            this.errorMessage = detailedError
                || (data?.errors ? Object.values(data.errors).flat()[0] : null)
                || data?.message
                || data
                || err;
        },
        // Shared submit-time validation for updateChart/createChart. Sets the standard error
        // modal state and returns false if the chart should NOT be submitted; true if OK to proceed.
        validateChartBeforeSubmit() {
            if (!this.prescriptionType) {
                // note that even though nurses may choose a script type in a saved draft,
                // prescribers will still need to verify this with their on choice
                // only signed i.e. scripts will have their script type already labelled
                this.displayPhoneOrderModal = false; // because this modal tends to obscure this important error message
                this.errorTitle = 'Form Error';
                this.displayErrorModal = true;
                this.errorMessage = 'Please select a prescription type for this chart item (Private or PBS/RPBS).';
                return false;
            }
            this.forceCeaseRequired = false;
            this.forceCreateRequired = false;

            if (this.isWarfarinOrINR && (!this.form.prescription_payload.sliding_scale || !this.form.prescription_payload.sliding_scale.length)) {
                this.displayPhoneOrderModal = false;
                this.displayErrorModal = true;
                this.errorTitle = 'Form Error';
                this.errorMessage = 'Warfarin prescriptions must include an INR sliding scale.';
                return false;
            }

            if (this.sliding && this.slidingScaleValidationError) {
                this.displayPhoneOrderModal = false;
                this.displayErrorModal = true;
                this.errorTitle = 'Form Error';
                this.errorMessage = this.slidingScaleValidationError;
                return false;
            }

            // Gated by WEIGHT_DOSING_HARD_BLOCK_ENABLED (see script) via weightDependentDrugBlockMessage -
            // currently disabled since the backing drug list is a placeholder, not an authoritative
            // clinical reference.
            if (this.weightDependentDrugBlockMessage) {
                this.displayPhoneOrderModal = false;
                this.displayErrorModal = true;
                this.errorTitle = 'Form Error';
                this.errorMessage = this.weightDependentDrugBlockMessage;
                return false;
            }

            // Scan the actual form state rather than trusting timeValidationError: commitTime
            // reverts a rejected entry to its previous valid value, so the banner can be showing
            // while the data is perfectly fine, and blocking on it would strand the prescriber
            // on an error about a value no longer anywhere on the form. This catches what
            // matters - anything malformed still sitting in the grid, including times that
            // arrived that way from saved data, which parseDoseTimes copies straight into
            // dose_times.
            const invalidTime = (this.schedule_quantity || []).find(
                t => t && t.time !== null && t.time !== undefined && t.time !== '' && !this.normaliseTimeInput(t.time)
            );
            if (invalidTime) {
                this.displayPhoneOrderModal = false;
                this.displayErrorModal = true;
                this.errorTitle = 'Form Error';
                this.errorMessage = `Dose time "${invalidTime.time}" is not a valid 24 hour time. Enter it as HHMM, e.g. 0700.`;
                return false;
            }

            return true;
        },
        // The renewal modal's green button. An authority script used to route straight to
        // updateChart, so the prescriber could reopen the script they had already created and add
        // the approval code to it. That is wrong when the script being renewed has been cancelled:
        // it is soft deleted, EditPrescriptionRequest looks the id up without withTrashed(), and
        // Kraken answers "Invalid prescription id, or prescription has already been cancelled".
        // Renewing always creates a new script - createChart's skip_cancel path is already built
        // for a cancelled original.
        submitRenewal() {
            const awaitingApprovalCode = !!this.form.prescription_payload.authority_prescription_number
                && !this.form.prescription_payload.pbs_authority_code;

            // Only the first submit creates. In the authority flow passAuthCode() has already
            // called createChart to get the approval number and stored the new script's id here,
            // and the button has relabelled to "Save Rx" for that script - creating again would
            // leave the patient with two. form.chart_payload.prescription_id is only ever set
            // from a create or edit response in this component, never from activePresChart, so
            // it is empty for the first press on a cancelled renewal.
            if (this.renewingCancelledScript && !this.form.chart_payload.prescription_id) {
                return this.createChart(!awaitingApprovalCode, true);
            }
            if (this.form.prescription_payload.authority_prescription_number) {
                return this.updateChart(!awaitingApprovalCode);
            }
            return this.createChart(true, true);
        },
        // Every request that carries dose_times builds them here, from what the prescriber can
        // see on screen. createChart used to send form.prescription_payload.dose_times as it
        // stood and only rebuilt it from the grid when it was empty - on a renew or chart review
        // that field is seeded with the previous prescription's dose times, so it was never
        // empty and an old weekday rode along with the new frequency (a Tue/Wed chart continued
        // as Tue/Thu/Sat went out as all four and the calendar was generated for all four).
        // updateChart already rebuilt unconditionally; this is that logic, shared by both.
        // Returns stop_date only for Stat, which clears it.
        buildDoseTimesPayload() {
            const freq = this.form.prescription_payload.frequency;
            const period = freq && freq.period ? String(freq.period).toLowerCase() : '';
            const isStat = !!(freq && freq.frequency_name == 'Stat');
            const result = { dose_times: [], stop_date: undefined };

            if (this.isVariableMode || isVariableFrequency(freq)) {
                // The calendar is the source of truth here, and only saveWeeklySchedule() reads
                // every week out of it. weekly_schedule below is a single 7 day template, so the
                // other branches would drop week 2 onwards along with the dates. The frequency
                // check covers picking "Variable" straight from the dropdown, which renders the
                // calendar without setting isVariableMode.
                this.saveWeeklySchedule();
                result.dose_times = this.form.prescription_payload.dose_times || [];
            } else if ((period == 'daily' || period == 'monthly') && !isStat) {
                // Strip the date out of the dose time
                const times = [];
                for (let i = 0; i < this.schedule_quantity.length; i++) {
                    if (this.schedule_quantity[i].qty !== null && this.schedule_quantity[i].qty !== '') {
                        times.push({
                            time: this.schedule_quantity[i].time,
                            qty: String(this.schedule_quantity[i].qty),
                            date: '',
                            sliding_scale: this.schedule_quantity[i].sliding_scale
                        });
                    }
                }
                result.dose_times = times.length ? [{ day: null, times }] : [];
            } else if (!isStat) {
                this.weekly_schedule.forEach(day => {
                    const times = day.times
                        .filter(time => time.qty !== null && time.qty !== '')
                        .map(time => ({ ...time, qty: String(time.qty) }));
                    if (times.length) {
                        result.dose_times.push({ ...day, times });
                    }
                });
            } else {
                if (!this.statDoseTime[0].times[0].date.toString().includes('/')) {
                    this.statDoseTime[0].times[0].date = new Date(this.statDoseTime[0].times[0].date).toLocaleDateString('en-AU');
                }
                result.stop_date = '';
                result.dose_times = [this.statDoseTime[0]];
            }

            return result;
        },
        async updateChart(sign) {
            if (!this.validateChartBeforeSubmit()) return;

            this.$store.dispatch('getRefreshToken');
            this.error_message = '';
            this.calculated_stop_date = null;
            
            this.loading = true;
            this.displaySuccessModal = true;
            let payload = {};
            console.log('this is the  drug', this.selectedDrug, this.form.prescription_payload.start_date);
            // payload.dose = parseFloat(this.form.prescription_payload.dose).toFixed(2);
            // payload.max_dose = parseFloat(this.form.prescription_payload.max_dose).toFixed(2);
            // payload.drug_uuid = this.selectedDrug.alias_id;
            // new Date(this.form.prescription_payload.start_date).toLocaleDateString('en-AU')
            payload.calculate_stop_date = this.draftDrug?.tags?.includes('S8') || this.draftDrug?.tags?.includes('s8') || this.form.prescription_payload.authority_prescription_number ? true : false;
            payload.start_date = this.form.prescription_payload.start_date && this.form.prescription_payload.start_date.includes('/') ? this.form.prescription_payload.start_date : '';
            payload.stop_date = this.form.prescription_payload.stop_date && this.form.prescription_payload.stop_date.includes('/') ? this.form.prescription_payload.stop_date : '';
            payload.prescription_id = this.form.chart_payload.prescription_id ? this.form.chart_payload.prescription_id : this.activePresChart.chart_payload.prescription_id;
            // payload.days_of_week = this.form.prescription_payload.days_of_week;
            payload.interval = this.form.prescription_payload.interval ? parseInt(this.form.prescription_payload.interval) : 1;
            payload.frequency = this.form.prescription_payload.frequency?.period ? this.form.prescription_payload.frequency.period.toLowerCase() : this.activePresChart.prescription_payload.frequency ? this.activePresChart.prescription_payload.frequency.toLowerCase() : '';
            payload.frequency_shorthand = this.form.prescription_payload.frequency && this.form.prescription_payload.frequency.frequency_name ? this.form.prescription_payload.frequency.frequency_name :  this.activePresChart && this.activePresChart.prescription_payload.frequency_shorthand ? this.activePresChart.prescription_payload.frequency_shorthand : '';
            payload.dose_unit = this.form.prescription_payload.dose_unit ? this.form.prescription_payload.dose_unit : '';
            payload.indication = this.form.prescription_payload.indication ? this.form.prescription_payload.indication : '';
            payload.is_paper = this.form.prescription_payload.is_paper ? true : false;
            payload.max_daily_admin = this.form.prescription_payload.max_daily_admin ? this.form.prescription_payload.max_daily_admin : '';
            payload.old_prescription_id = this.form.prescription_payload.old_prescription_id ? this.form.prescription_payload.old_prescription_id : '';
            payload.patient_id = this.patientId;
            payload.pbs_authority_code = this.form.prescription_payload.pbs_authority_code ? this.form.prescription_payload.pbs_authority_code : '';
            payload.pbs_code = this.form.prescription_payload.pbs_code ? this.form.prescription_payload.pbs_code : '';
            payload.pbs_manufacturer_code = this.form.prescription_payload.pbs_manufacturer_code ? this.form.prescription_payload.pbs_manufacturer_code : '';
            payload.substitution_not_permitted = this.form.prescription_payload.substitution_not_permitted ? true : false;
            payload.authority_prescription_number = this.form.prescription_payload.authority_prescription_number ? this.form.prescription_payload.authority_prescription_number : '';
            payload.date_added = this.form.prescription_payload.date_added ? this.form.prescription_payload.date_added : '';
            payload.aslr_consent = this.form.prescription_payload.aslr_consent ? true : false;
            payload.ctg = this.form.prescription_payload.ctg ? true : false;
            payload.is_extemp = this.form.prescription_payload.is_extemp ? true : false;
            payload.additional_regulatory_checks = this.form.prescription_payload.additional_regulatory_checks ? this.form.prescription_payload.additional_regulatory_checks : '';

            payload.prescribed_quantity = this.form.prescription_payload.prescribed_quantity ? parseFloat(this.form.prescription_payload.prescribed_quantity).toFixed(2) : '0';
            payload.chart_type = this.selectedChart.chart_name ? this.selectedChart.chart_name : '';
            payload.dose = parseFloat(this.form.prescription_payload.dose).toFixed(2);
            payload.max_admin_dose = (this.form.prescription_payload.max_admin_dose !== '' && this.form.prescription_payload.max_admin_dose != null && !isNaN(this.form.prescription_payload.max_admin_dose)) ? parseFloat(this.form.prescription_payload.max_admin_dose).toFixed(2) : '';
            payload.max_dose = this.form.prescription_payload.max_dose ? parseFloat(this.form.prescription_payload.max_dose).toFixed(2) : '';
            payload.max_times_per_day = this.form.prescription_payload.max_times_per_day ? parseInt(this.form.prescription_payload.max_times_per_day) : 0;
            payload.prescriber = JSON.parse(localStorage.getItem('user_id'));
            payload.prescribed_pack_size_id = this.selectedCTPP ? this.selectedCTPP.uuid : '';
            payload.prescribed_ctpp_id = this.stock ? this.stock.alias_id : '';
            payload.drug_uuid = this.draftDrug && this.draftDrug.alias_id && !this.selectedDrug.drug_uuid ? this.draftDrug.alias_id : this.selectedDrug.drug_uuid;
            // this.form.prescription_payload.drug_uuid = this.selectedDrug && this.selectedDrug.alias_id ? this.selectedDrug.alias_id : this.draftDrug.alias_id;
            payload.reason = this.form.prescription_payload.reason ? this.form.prescription_payload.reason : '';
            payload.notes = this.form.prescription_payload.notes ? this.form.prescription_payload.notes : '';
            payload.use_pbs = this.form.prescription_payload.pbs_code ? true : false;
            payload.sliding_scale = this.form.prescription_payload.sliding_scale?.length && this.form.prescription_payload.sliding_scale[0].min ? this.form.prescription_payload.sliding_scale : [];
            
            if (this.acknowledgeINR && this.patient && this.patient.latest_inr_reading) {
                payload.acknowledged_reading_id = this.patient.latest_inr_reading.uuid;
                payload.reading_acknowledgement_date = new Date().toISOString();
            } else {
                payload.acknowledged_reading_id = null;
                payload.reading_acknowledgement_date = null;
            }

            payload.instructions = this.form.prescription_payload.notes ? this.form.prescription_payload.notes : '';
            payload.permit_number = this.form.prescription_payload.permit_number ? this.form.prescription_payload.permit_number : '';
            payload.num_repeats_authorised = this.form.prescription_payload.num_repeats_authorised ? this.form.prescription_payload.num_repeats_authorised.toString() : '0';
            payload.period = this.form.prescription_payload.frequency?.period ? this.form.prescription_payload.frequency.period.toLowerCase() : '';
            // convertToVariableDose() leaves the underlying template selected, so period,
            // frequency and frequency_shorthand above all read off that option - a calendar built
            // on "Morning" re-saved as frequency 'daily', shorthand 'Morning', and the dose_times
            // branch below then flattened every week into one dateless row. createChart applies
            // this override; this path never did, so signing or amending a variable chart undid
            // the create that had just stored it correctly.
            if (this.isVariableMode || isVariableFrequency(this.form.prescription_payload.frequency)) {
                payload.period = 'variable';
                payload.frequency = 'variable';
                payload.frequency_shorthand = 'variable';
            }
            payload.route = this.form.prescription_payload.route ? this.form.prescription_payload.route : '';
            payload.paper_prescription_number = this.form.prescription_payload.paper_prescription_number ? this.form.prescription_payload.paper_prescription_number : '';
            payload.unusual_dose = this.form.prescription_payload.unusual_dose ? this.form.prescription_payload.unusual_dose : false;
            payload.unusual_qty = this.form.prescription_payload.unusual_qty ? this.form.prescription_payload.unusual_qty : false;
            payload.repeat_interval = this.form.prescription_payload.repeat_interval ? parseInt(this.form.prescription_payload.repeat_interval) : 0;
            payload.privacy_statement = this.form.prescription_payload.privacy_statement ? this.form.prescription_payload.privacy_statement : true;
            payload.private_prescription = this.form.prescription_payload.pbs_code ? false : true;
            payload.emergency_supply = this.form.prescription_payload.emergency_supply ? this.form.prescription_payload.emergency_supply : false;
            payload.ctg = this.form.prescription_payload.ctg ? this.form.prescription_payload.ctg : false;
            payload.is_extemp = this.form.prescription_payload.is_extemp ? this.form.prescription_payload.is_extemp : false;
            payload.script_ctg_annotation = this.form.prescription_payload.script_ctg_annotation ? this.form.prescription_payload.script_ctg_annotation : '';
            payload.dispense_all_repeats = this.form.prescription_payload.dispense_all_repeats ? this.form.prescription_payload.dispense_all_repeats : false;
            payload.is_lemi = this.form.prescription_payload.is_lemi ? true : false;
            payload.consent_uuid = this.form.prescription_payload.consent_uuid ? this.form.prescription_payload.consent_uuid : (this.patient?.consent?.uuid || '');

            if(this.pbs_type != ''){
                payload.pbs_type = this.pbs_type;
                this.pbs_type = '';
            }

            payload.chart_form = {
                type: this.activePresChart && this.activePresChart.chart_payload ? this.activePresChart.chart_payload.chart_form.type : this.form.chart_payload.chart_form.type,
                route: this.form.prescription_payload.route,
                max_dose: this.form.prescription_payload.max_dose ? parseFloat(this.form.prescription_payload.max_dose).toFixed(2) : '0'
            };
            console.log('this is the payload', payload, sign)
            const doseTimesPayload = this.buildDoseTimesPayload();
            payload.dose_times = doseTimesPayload.dose_times;
            if (doseTimesPayload.stop_date !== undefined) {
                payload.stop_date = doseTimesPayload.stop_date;
            }

            if (sign && !this.chartReview) {
                this.signature = true;
            }

            let canProceedUpdate = true;
            if((this.draftDrug?.tags?.includes('S8') || this.draftDrug?.tags?.includes('s8') || this.form.prescription_payload.authority_prescription_number) && this.selectedChart.chart_name == 'regular'){
                if(payload.private_prescription == false){
                    let stopPayload = {
                        prescribed_qty: parseFloat(this.form?.prescription_payload?.prescribed_quantity).toFixed(2),
                        repeats: parseInt(this.form?.prescription_payload?.num_repeats_authorised),
                        dose: this.form?.prescription_payload?.dose?.toString(),
                        frequency:  this.activePresChart?.prescription_payload ? this.activePresChart?.prescription_payload?.frequency : this.form?.prescription_payload?.frequency?.period,
                        interval: this.form?.prescription_payload?.interval,
                        // The rebuilt schedule, not the form field - on a renew that still holds
                        // the previous prescription's dose times.
                        "dose_times": payload.dose_times,
                        start_date: this.form?.prescription_payload?.start_date,
                        facility_id: this.patient?.physical_location?.location?.facility?.uuid,
                    }
                    await axios.post(`/calculate-stop-date`, stopPayload, this.$store.state.header).then(res=>{
                        console.log('saved stop date', res.data);
                        if(res.data.hard_limit_exceed !== undefined && res.data.hard_limit_exceed) {
                            canProceedUpdate = false;
                            this.displaySuccessModal = false;
                            this.displayErrorModal = true;
                            this.errorTitle = `Prescription Limit`;
                            this.errorMessage = `Please note, the prescription intended has a calculated end date of (${res.data.date}). This prescription has a duration that extends beyond the legislated maximum allowable duration and end date (${res.data.hard_limit_date}). Try updating the start date or quantity.`;
                        } else {
                            this.calculated_stop_date = res.data;
                        }
                    }).catch(err=>{
                        console.log('this is the err', err.response);
                        this.displayMessage = 'Error: '+err.response?.data;
                    })
                } else {
                    payload.calculate_stop_date = false;
                }
            } else{
                this.calculate_stop_date = null;
            }

            if(!canProceedUpdate) {
                return;
            }
            
            await axios.post('/prescription/edit', payload, this.$store.state.header).then(res => {
                console.log('this is the res', res);
                this.prescription_id = res.data.uuid;
                this.$store.dispatch('getRefreshToken');
                this.loading = false;
                this.prescription_sign_payload.prescription_id = this.prescription_id;
                this.prescription_sign_payload.is_paper = this.form.prescription_payload.is_paper ? true : false;
                let tagArray = [];
                this.getFirstAdminRoundTime();
                if (this.selected_administration_options) {
                    this.selected_administration_options.forEach(tag => {
                        tagArray.push(tag.value.toLowerCase())
                    })
                }
                if (Object.keys(this.selected_packing).length != 0) {
                        tagArray.push(this.selected_packing.value.toLowerCase())
                }

                let chartId = this.activePresChart && this.activePresChart.prescription_payload ? this.activePresChart.prescription_payload.chart_id : null;

                if (!chartId) {
                    this.form.chart_payload.prescription_id = this.prescription_id;
                    this.form.chart_payload.chart_form.route = payload.route;
                    this.form.chart_payload.chart_form.type = this.selectedChart.chart_name ? this.selectedChart.chart_name : this.selectedChart.name;
                    
                    this.form.chart_payload.chart_form.tags = [];
                    if (this.selectedDrug && this.selectedDrug.tags) {
                        this.selectedDrug.tags.forEach(tag => {
                            this.form.chart_payload.chart_form.tags.push(tag.toLowerCase());
                        });
                    }
                    if (this.single_multi) {
                        this.form.chart_payload.chart_form.tags.push(this.single_multi);
                    }
                    if (this.now_or_next_pack) {
                        this.form.chart_payload.chart_form.tags.push(this.now_or_next_pack);
                    }
                    if (this.packed) {
                        this.form.chart_payload.chart_form.tags.push(this.packed);
                    }

                    axios.post('/chart', this.form.chart_payload, this.$store.state.header).then(res2 => {
                        console.log('submitted chart create during draft update, res', res2);
                        if(tagArray.length){
                            axios.post(`/chart/${res2.data.uuid}/add-tags`, {tags: tagArray}, this.$store.state.header).then(res3=>{
                                console.log('added tags to chart', res3.data);
                            });
                        }
                    }).catch(err => {
                        console.log('error creating chart during draft update', err);
                    });
                } else {
                    if(tagArray.length){
                        axios.post(`/chart/${chartId}/add-tags`,{tags: tagArray},this.$store.state.header).then(res3=>{
                            console.log('added tags to chart', res3.data);
                        })
                    }
                }
                if ((sign || this.signNow) && !this.chartReview) {
                    this.signature = true;
                    this.displayMessage2 = `Click the ${this.scheduledMedicine ||  this.form.prescription_payload.authority_prescription_number ? 'Sign' : 'Complete'} button to sign off on prescription.`;
                } else {
                    this.displayMessage = 'Successfully updated prescription draft.';
                    if (this.chartReview) {
                        this.$emit('addToReview', { prescription_id: this.prescription_id, status: 'edited' });
                    } else {
                        console.log('testing retrieveallcharts --- refreshlist - isSuccessful -- editPrescription');
                        this.$emit('isSuccessful', true);
                    }
                }
            }).catch(err => {
                this.loading = false;
                this.error_message = err.response.data.message;
                this.displayMessage = 'Error: ' + this.error_message;
                this.displayMessage2 = err.response.data.errors;
                console.log('HITTING CREATE ERROR', this.error_message);
                this.signature = false;

                if (this.activePresChart && !this.isFormValidationError(err)) {
                    this.forceCeaseRequired = true;
                } else {
                    this.showFormError(err);
                }
            })
        },
        initateChartCreation() {
            // if med == Anti-Infective then show the prompt 
            if (this.selectedDrug?.tags?.includes('Anti-infective agent')) {
                this.displayQuestionnaire = true
            } else {
                this.createChart(true, false)
            }
        },
        setQ(questionsSubmission) {
            this.prescription_answers = questionsSubmission
        },
        async createChart(sign, renew, generateapn, phoneOrder = false, noErx = false, isCeaseAndNewRetry = false) {
            this.lastCreateArgs = { sign, renew, generateapn, phoneOrder, noErx, isCeaseAndNewRetry };
            if (!this.validateChartBeforeSubmit()) return;

            if (this.selectedChart.chart_name == 'prn') {
                if ((this.form.prescription_payload.max_admin_dose <= 0 || this.form.prescription_payload.max_admin_dose == '') ||
                    (this.form.prescription_payload.max_dose <= 0 || this.form.prescription_payload.max_dose == '') ||
                    (this.form.prescription_payload.max_times_per_day <= 0 || this.form.prescription_payload.max_times_per_day == ''))
                {
                    this.displayPhoneOrderModal = false;
                    this.displayErrorModal = true;
                    this.errorTitle = 'Form Error';
                    this.errorMessage = 'PRN maximum parameters (max admin dose, 24 hrs max dose, max times perday) are required and values must be greater than 0.';
                    return;
                }
            }
            
            this.calculated_stop_date = null;
            this.$store.dispatch('getRefreshToken');
            this.parseDoseTimes();
            this.formatDate();
            let timer = 1;
            this.endpoint = '/prescription/create';
            
            
            this.displaySuccessModal = true;
            this.displayMessage2 = '';
            let interval = setInterval(async () => {
                timer--;
                this.displayMessage = `${timer}`;
                this.loadingDelay = true;
                if (timer == 0 || this.cancelAction == true) {

                    clearInterval(interval);
                    this.loadingDelay = false;
                    if (this.cancelAction == true) {
                        console.log('CANCELLING THE ACTION', this.cancelAction)
                    }
                    if (this.cancelAction == null) {
                        console.log('Cancel action should be null', this.cancelAction)
                        this.displayMessage = 'Submitting request...'
                        this.error_message = '';

                        // NEW: Handle inlined consent submission before prescription creation
                        try {
                            await this.submitInlineConsent();
                        } catch (err) {
                            // Error is already handled/displayed in submitInlineConsent
                            return;
                        }

                        // FUNCTION HERE
                        // FUNCTION HERE
                        console.log('this is the  date', this.form.prescription_payload.start_date);
                        this.form.prescription_payload.patient_id = this.patientId;
                        delete this.form.prescription_payload.days_of_week;
                        this.form.prescription_payload.interval = this.form.prescription_payload.interval ? parseInt(this.form.prescription_payload.interval) : 1;
                        // this.form.prescription_payload.frequency_shorthand = 'BD';
                        if (this.selected_administration_options.length) {
                            this.selected_administration_options.forEach(option => {
                                if (option.label == 'Unusual Dose') {
                                    this.form.prescription_payload.unusual_dose = true;
                                }
                                if (option.label == 'Unusual Qty') {
                                    this.form.prescription_payload.unusual_qty = true;
                                }
                                this.form.chart_payload.chart_form.tags.push(option);
                            })
                        }

                        // dose_times are built into newPayload below by buildDoseTimesPayload();
                        // the form field is left as loaded because the schedule modal and the
                        // grid read it.
                        if(this.form
                            && this.form.prescription_payload
                            && this.form.prescription_payload.frequency && this.form.prescription_payload.frequency.frequency_name == 'Stat'){
                            this.form.prescription_payload.dose = this.statDoseTime[0].times[0].qty;
                            this.form.prescription_payload.stop_date = '';
                        }
                        this.form.prescription_payload.calculate_stop_date = this.selectedDrug?.tags?.includes('S8') || this.selectedDrug?.tags?.includes('s8') || this.draftDrug?.tags?.includes('S8') || this.draftDrug?.tags?.includes('s8') || this.form.prescription_payload.authority_prescription_number ? true : false;
                        this.form.prescription_payload.authority_prescription_number = this.form.prescription_payload.authority_prescription_number ? this.form.prescription_payload.authority_prescription_number : '';
                        this.form.prescription_payload.old_prescription_id = renew && !this.editingPrescription ? this.activePresChart.chart_payload.prescription_id : renew && this.editingPrescription ? this.form.chart_payload.prescription_id : '';
                        this.form.prescription_payload.max_daily_admin = this.form.prescription_payload.max_daily_admin ? this.form.prescription_payload.max_daily_admin : '';
                        this.form.prescription_payload.prescribed_quantity = this.form.prescription_payload.prescribed_quantity ? parseFloat(this.form.prescription_payload.prescribed_quantity).toFixed(2) : '0';
                        this.form.prescription_payload.chart_type = this.selectedChart.chart_name ? this.selectedChart.chart_name : '';
                        this.form.prescription_payload.dose = parseFloat(this.form.prescription_payload.dose).toFixed(2);
                        this.form.prescription_payload.max_admin_dose = (this.form.prescription_payload.max_admin_dose !== '' && this.form.prescription_payload.max_admin_dose != null && !isNaN(this.form.prescription_payload.max_admin_dose)) ? parseFloat(this.form.prescription_payload.max_admin_dose).toFixed(2) : '';
                        this.form.prescription_payload.max_dose = this.form.prescription_payload.max_dose ? parseFloat(this.form.prescription_payload.max_dose).toFixed(2) : '';
                        this.form.prescription_payload.max_times_per_day = this.form.prescription_payload.max_times_per_day ? parseInt(this.form.prescription_payload.max_times_per_day) : 0;
                        this.form.prescription_payload.prescribed_pack_size_id = this.selectedCTPP ? this.selectedCTPP.uuid : '';
                        this.form.prescription_payload.prescribed_ctpp_id = this.stock ? this.stock.alias_id : '';
                         // ------------------------------------------------------------------------------------------------------------------------
                        // checking if user is a prescriber, if prescriber use own uuid and phone_order=false
                        // if non prescriber check if order is it's a phone_order and use the selected prescriber uuid from previous dropdown
                        // else don't include prescriber datapoint at all
                         // ------------------------------------------------------------------------------------------------------------------------
                        if(this.$store.state.user.type == 'prescriber'){
                            this.form.prescription_payload.prescriber = JSON.parse(localStorage.getItem('user_id'))
                        }else if(phoneOrder){
                            this.form.prescription_payload.prescriber =  this.selectedPrescriber?.uuid;
                        }
                        this.form.prescription_payload.phone_order = this.$store.state.user.type != 'prescriber' && phoneOrder ? true : false;
                        // ------------------------------------------------------------------------------------------------------------------------
                        // ------------------------------------------------------------------------------------------------------------------------
                        this.form.prescription_payload.aslr_consent = this.form.prescription_payload.aslr_consent ? this.form.prescription_payload.aslr_consent : false;
                        this.form.prescription_payload.ctg = this.form.prescription_payload.ctg ? true : false;
                        if(this.customMedication.uuid){
                            this.form.prescription_payload.drug_uuid = this.customMedication.uuid
                        } else{
                            this.form.prescription_payload.drug_uuid = this.draftDrug && this.draftDrug.alias_id && !this.selectedDrug.drug_uuid ? this.draftDrug.alias_id : this.selectedDrug.drug_uuid;
                        }
                        // check if prescription answers have to be appended
                        if(this.prescription_answers != null) {
                            this.form.prescription_payload.prescription_answers = this.prescription_answers
                        }
                        // this.form.prescription_payload.drug_uuid = this.selectedDrug && this.selectedDrug.alias_id ? this.selectedDrug.alias_id : this.draftDrug.alias_id;
                        this.form.prescription_payload.reason = this.form.prescription_payload.reason ? this.form.prescription_payload.reason : '';
                        this.form.prescription_payload.notes = this.form.prescription_payload.notes ? this.form.prescription_payload.notes : '';
                        this.form.prescription_payload.use_pbs = this.form.prescription_payload.pbs_code ? true : false;
                        this.form.prescription_payload.sliding_scale = this.form.prescription_payload.sliding_scale?.length && this.form.prescription_payload.sliding_scale[0].min ? this.form.prescription_payload.sliding_scale : [];
                        
                        if (this.acknowledgeINR && this.patient && this.patient.latest_inr_reading) {
                            this.form.prescription_payload.acknowledged_reading_id = this.patient.latest_inr_reading.uuid;
                            this.form.prescription_payload.reading_acknowledgement_date = new Date().toISOString();
                        } else {
                            this.form.prescription_payload.acknowledged_reading_id = null;
                            this.form.prescription_payload.reading_acknowledgement_date = null;
                        }

                        this.form.prescription_payload.instructions = this.form.prescription_payload.notes ? this.form.prescription_payload.notes : '';
                        this.form.prescription_payload.permit_number = this.form.prescription_payload.permit_number ? this.form.prescription_payload.permit_number : '';
                        this.form.prescription_payload.num_repeats_authorised = this.form.prescription_payload.num_repeats_authorised ? this.form.prescription_payload.num_repeats_authorised.toString() : '0';
                        // ANCHOR FIX: If frequency is a flat string 'variable' (because of Variable Dosing Mode), ensure period matches
                        let periodVal = this.form.prescription_payload.frequency?.period ? this.form.prescription_payload.frequency.period.toLowerCase() : '';
                        if (this.isVariableMode || isVariableFrequency(this.form.prescription_payload.frequency)) {
                            periodVal = 'variable';
                        }
                        this.form.prescription_payload.period = periodVal;

                        // Variable mode is normalised to lowercase 'variable' rather than the
                        // option's "Variable", so the value round trips through the saved chart's
                        // frequency_shorthand the way the frequency column already does. The
                        // activePresChart fallback mirrors updateChart() - without it a renewal
                        // whose frequency never resolved posted an empty required field and the
                        // whole script was rejected.
                        if (this.isVariableMode || isVariableFrequency(this.form.prescription_payload.frequency)) {
                            this.form.prescription_payload.frequency_shorthand = 'variable';
                        } else {
                            this.form.prescription_payload.frequency_shorthand = this.form.prescription_payload.frequency?.frequency_name
                                ? this.form.prescription_payload.frequency.frequency_name
                                : (this.activePresChart?.prescription_payload?.frequency_shorthand || '');
                        }
                        this.form.prescription_payload.route = this.form.prescription_payload.route ? this.form.prescription_payload.route : '';
                        this.form.prescription_payload.paper_prescription_number = this.form.prescription_payload.paper_prescription_number ? this.form.prescription_payload.paper_prescription_number : '';
                        this.form.prescription_payload.unusual_dose = this.form.prescription_payload.unusual_dose ? this.form.prescription_payload.unusual_dose : false;
                        this.form.prescription_payload.unusual_qty = this.form.prescription_payload.unusual_qty ? this.form.prescription_payload.unusual_qty : false;
                        this.form.prescription_payload.repeat_interval = this.form.prescription_payload.repeat_interval ? this.form.prescription_payload.repeat_interval : 0;
                        this.form.prescription_payload.privacy_statement = this.form.prescription_payload.privacy_statement ? this.form.prescription_payload.privacy_statement : true;
                        this.form.prescription_payload.private_prescription = this.form.prescription_payload.pbs_code ? false : true;
                        this.form.prescription_payload.emergency_supply = this.form.prescription_payload.emergency_supply ? this.form.prescription_payload.emergency_supply : false;
                        this.form.prescription_payload.ctg = this.form.prescription_payload.ctg ? this.form.prescription_payload.ctg : false;
                        this.form.prescription_payload.is_extemp = this.form.prescription_payload.is_extemp ? this.form.prescription_payload.is_extemp : false;
                        this.form.prescription_payload.script_ctg_annotation = this.form.prescription_payload.script_ctg_annotation ? this.form.prescription_payload.script_ctg_annotation : '';
                        this.form.prescription_payload.dispense_all_repeats = this.form.prescription_payload.dispense_all_repeats ? this.form.prescription_payload.dispense_all_repeats : false;
                        this.form.prescription_payload.substitution_not_permitted = this.form.prescription_payload.substitution_not_permitted ? true : false;
                        this.form.prescription_payload.consent_uuid = this.form.prescription_payload.consent_uuid ? this.form.prescription_payload.consent_uuid : (this.patient?.consent?.uuid || '');

                        if(this.pbs_type != ''){
                            this.form.prescription_payload.pbs_type = this.pbs_type;
                            this.pbs_type = '';
                        }

                        // this.form.prescription_payload.start_date =  new Date(this.form.prescription_payload.start_date).toLocaleDateString();
                        // this.form.prescription_payload.stop_date = this.form.prescription_payload.stop_date.length == 10 ? this.form.prescription_payload.stop_date : new Date(this.form.prescription_payload.start_date).toLocaleDateString();

                        // this.form.prescription_payload.times = [];
                        // for (let key in this.formTimes) {
                        //     console.log('this is a key', key);
                        //     if (this.formTimes[key]) {
                        //         this.form.prescription_payload.times.push(this.formTimes[key].split(':').join(''))
                        //     }
                        // }
                        this.form.chart_payload.chart_form.tags = [];
                        if (this.single_multi) {
                            this.form.chart_payload.chart_form.tags.push(this.single_multi);
                        }
                        if (this.now_or_next_pack) {
                            this.form.chart_payload.chart_form.tags.push(this.now_or_next_pack);
                        }
                        if (this.packed) {
                            this.form.chart_payload.chart_form.tags.push(this.packed);
                        }
                        if(this.expired){
                            this.form.prescription_payload.start_date = new Date().toLocaleString("en-au", { timeZone: "Australia/Sydney" }).slice(0,10);
                            this.form.prescription_payload.stop_date =  this.nextReviewDate.toLocaleString("en-au", { timeZone: "Australia/Sydney" }).slice(0,10);
                        }
                        if (this.selectedChart.chart_name == 'intermittent' || this.selectedChart.chart_name == 'non_prescription') {
                            console.log('this chart is a stat chart!')
                            // this.form.prescription_payload.frequency = 'daily';
                            this.form.prescription_payload.stop_date = this.form.prescription_payload.start_date;
                        }

                        // if (this.form.prescription_payload.frequency == 'QiD' || this.form.prescription_payload.frequency == 'TDS' ||
                        //     this.form.prescription_payload.frequency == 'BD') {
                        //     this.form.prescription_payload.frequency = 'daily';
                        // }
                        this.loading = true;
                        this.displaySuccessModal = true;
                        
                        this.lastCreateArgs = { sign, renew, generateapn, phoneOrder, noErx, isCeaseAndNewRetry };

                        let newPayload = { ...this.form.prescription_payload };
                        const doseTimesPayload = this.buildDoseTimesPayload();
                        newPayload.dose_times = doseTimesPayload.dose_times;
                        if (doseTimesPayload.stop_date !== undefined) {
                            newPayload.stop_date = doseTimesPayload.stop_date;
                        }
                        // noErx here is the caller's explicit opt out (force cease); a patient with
                        // no eRx chart is always a transitional conformance item regardless.
                        newPayload.no_erx = noErx || this.isTransitionalConformance;
                        newPayload.skip_cancel = renew && (this.expired || this.renewingCancelledScript || this.activePresChart?.chart_payload?.script_status === 'ceased' || this.chartReview);
                        // If force ceasing (noErx) or retrying from a force cease, ensure we don't send the old ID, otherwise backend tries to cancel it again and fails
                        if (noErx || isCeaseAndNewRetry) {
                            newPayload.old_prescription_id = '';
                            if (isCeaseAndNewRetry) {
                                this.form.prescription_payload.old_prescription_id = '';
                            }
                        }
                        if (this.selectedChart.chart_name == 'prn') {
                            // newPayload.dose_times = [];
                            console.log('this is a prn order therefore dose times is', newPayload.dose_times)
                        }
                        delete newPayload.times;
                        delete newPayload.consent;
                        newPayload.frequency = newPayload.period;
                        
                        let canProceedCreate = true;
                        if((this.selectedDrug?.tags?.includes('S8') || this.selectedDrug?.tags?.includes('s8') || this.draftDrug?.tags?.includes('S8') || this.draftDrug?.tags?.includes('s8') || this.form?.prescription_payload?.authority_prescription_number) && this.selectedChart.chart_name == 'regular'){
                            if(!newPayload.private_prescription){
                                let stopPayload = {
                                    prescribed_qty: this.form?.prescription_payload?.prescribed_quantity,
                                    repeats: parseInt(this.form?.prescription_payload?.num_repeats_authorised),
                                    dose: this.form?.prescription_payload?.dose?.toString(),
                                    frequency:  this.activePresChart?.prescription_payload ? this.activePresChart?.prescription_payload?.frequency : this.form?.prescription_payload?.frequency?.period,
                                    interval: this.form?.prescription_payload?.interval,
                                    // The rebuilt schedule, not the form field - on a renew that
                                    // still holds the previous prescription's dose times.
                                    "dose_times": newPayload.dose_times,
                                    start_date: this.form?.prescription_payload?.start_date,
                                    facility_id: this.patient?.physical_location?.location?.facility?.uuid,
                                };
                                
                                await axios.post(`/calculate-stop-date`, stopPayload, this.$store.state.header).then(res => {
                                    console.log('saved stop date', res.data);

                                    if(res.data.hard_limit_exceed !== undefined && res.data.hard_limit_exceed) {
                                        canProceedCreate = false
                                        this.displaySuccessModal = false;
                                        this.displayErrorModal = true;
                                        this.errorTitle = `Presscription Limit`;
                                        this.errorMessage = `Please note, the prescription intended has a calculated end date of (${res.data.date}). This prescription has a duration that extends beyond the legislated maximum allowable duration and end date (${res.data.hard_limit_date}). Try updating the start date or quantity.`;
                                    } else {
                                        this.calculated_stop_date = res.data;
                                    }
                                }).catch(err=>{
                                    console.log('this is the err', err.response);
                                    this.displayMessage = err.response;
                                })
                            } else {
                                newPayload.calculate_stop_date = false;
                            }
                        } else{
                            this.calculated_stop_date = null
                        }

                        if (!canProceedCreate) {
                            return;
                        }

                        // Protect against sending an empty string to the backend which triggers "Invalid prescription id" UUID parsing errors.
                        if (!newPayload.old_prescription_id) {
                            delete newPayload.old_prescription_id;
                        }

                        if (renew && !this.dashboardRenew && !this.renewingCancelledScript && !this.expired && !noErx && !isCeaseAndNewRetry) {
                            let prescriptionToCancel = this.editingPrescription ? this.form.chart_payload.prescription_id : this.activePresChart.chart_payload.prescription_id;
                            this.form.prescription_payload.old_prescription_id = prescriptionToCancel;
                            this.$store.dispatch('getRefreshToken');
                            let checkPromise = (this.chartReview || newPayload.is_paper) ? Promise.resolve() : axios.post('/prescription/check', newPayload, this.$store.state.header);
                            await checkPromise.then(async re1=>{
                                console.log('checked prescription', re1);
                                this.form.chart_payload.prescription_id = '';
                                await axios.post(this.endpoint, newPayload, this.$store.state.header).then(res => {
                                    console.log('this is the res', res);
                                    console.log('this is the payload variable', newPayload);
                                    this.form.chart_payload.prescription_id = res.data;
                                    this.form.chart_payload.chart_form.route = newPayload.route;
                                        this.form.chart_payload.chart_form.type = this.selectedChart.chart_name ? this.selectedChart.chart_name : this.selectedChart.name;
                                        if (this.selectedDrug.tags) {
                                            this.form.chart_payload.chart_form.tags = [];
                                            this.selectedDrug.tags.forEach(tag => {
                                                this.form.chart_payload.chart_form.tags.push(tag.toLowerCase())
                                            })
                                        }
                                    if(generateapn){
                                        axios.post('/apn/create', {prescription_id: res.data, prescriber: JSON.parse(localStorage.getItem('user_id'))}, this.$store.state.header)
                                            .then(response=>{
                                                // Do error handling here 
                                                console.log(response)
                                                this.form.prescription_payload.authority_prescription_number = response.data.authority_prescription_number;
                                                this.hasAuthCode = true;
                                                this.displaySuccessModal = false;
                                            })
                                            .catch(error => {
                                                this.displayPBSAlertModal = false
                                                this.loading = false
                                                this.error_message = error.response.data.message
                                                this.displayMessage2 = error.response.data?.errors ? Object.values(error.response.data?.errors).flat()[0] : error;
                                                this.displayMessage = 'Error: ' + this.error_message + '; '+ error;
                                                console.log('HITTING CREATE ERROR', this.error_message)

                                                this.displaySuccessModal = false;
                                                this.displayErrorModal = true;
                                                this.errorTitle = error.response.data.title ? error.response.data.title : "Form Error";
                                                this.errorMessage = error.response.data.message ? error.response.data.message : error.response.data;
                                            })
                                    }
                                    if (!isCeaseAndNewRetry) {
                                        this.$emit('addToReview', { prescription_id: this.form.prescription_payload.old_prescription_id, status: 'cancelled' });
                                    }
                                    console.log('this is the chart payload', this.form.chart_payload);
                                }).then(() => {
                                    console.log('the create chart endpoint is being processed now');
                                        axios.post('/chart', this.form.chart_payload, this.$store.state.header).then(res2 => {
                                            this.clearCustomMedForm();
                                            console.log('submitted chart create, this is res', res2);
                                            this.$store.dispatch('getRefreshToken');
                                            this.loading = false;
                                            this.displayMessage = 'Your prescription and chart have been successfully amended.';
                                            let tagArray = [];
                                            this.getFirstAdminRoundTime();
                                            if (this.selected_administration_options) {
                                                this.selected_administration_options.forEach(tag => {
                                                    tagArray.push(tag.value.toLowerCase())
                                                })
                                            }
                                            if (Object.keys(this.selected_packing).length != 0) {
                                                    tagArray.push(this.selected_packing.value.toLowerCase())
                                            }
                                            if(tagArray.length){
                                                axios.post(`/chart/${res2.data.uuid}/add-tags`,{tags: tagArray},this.$store.state.header).then(res3=>{
                                                    console.log('added tags to chart', res3.data);
                                                })
                                            }
                                            
                                            // UNCOMMENT WHEN REINTRODUCING IHI
                                            // if (sign) {
                                            //     this.preChartCheck();
                                            // }
                                            if (sign && !this.chartReview) {
                                                
                                                this.prescription_sign_payload.prescription_id = this.form.chart_payload.prescription_id;
                                                this.prescription_sign_payload.is_paper = this.form.prescription_payload.is_paper ? true : false;
                                                if(!this.displayPhoneOrderModal){
                                                    this.displayMessage2 = `Click the ${this.scheduledMedicine ? 'Sign' : 'Complete'} button to sign off on prescription.`;
                                                }
                                                
                                                this.signature = true;
                                            }
                                            if (this.chartReview && !isCeaseAndNewRetry) {
                                                this.displayMessage2 = 'Prescription has been added to the list of prescriptions that will be signed off at the end of the chart review.';
                                                this.$emit('addToReview', { prescription_id: this.form.chart_payload.prescription_id, status: 'continue', new: true });
                                            }
                                        })
                                }).catch(err => {
                                    this.loading = false;
                                    this.error_message = err.response.data.message ? err.response.data.message : err.response.data;
                                    this.displayMessage = this.error_message;
                                    const detailedError = err.response.data?.errors ? Object.values(err.response.data?.errors).flat()[0] : null;
                                    
                                    if (detailedError && detailedError !== this.error_message) {
                                        this.displayMessage2 = detailedError;
                                    } else {
                                        this.displayMessage2 = '';
                                    }
                                        console.log('HITTING CREATE ERROR', this.error_message);
                                        this.signature = false;

                                    const fullErrorString = (this.error_message || '') + ' ' + (detailedError || '');
                                    if (this.isFormValidationError(err)) {
                                        this.showFormError(err, detailedError);
                                    } else if (fullErrorString.toLowerCase().includes('ceased')) {
                                        this.dismissRequired = true;
                                        this.forceCreateRequired = true;
                                    } else {
                                        if (this.activePresChart) {
                                            this.forceCeaseRequired = true;
                                            this.forceCreateRequired = true;
                                        } else {
                                            this.showFormError(err, detailedError);
                                        }
                                    }
                                    })
                                console.log('this is the prescrption/chart form', this.form, this.patientId);
                            }).catch(err => {
                                this.loading = false;
                                this.error_message = err.response.data.message ? err.response.data.message : err.response.data;
                                this.displayMessage = this.error_message;
                                const detailedError = err.response.data?.errors ? Object.values(err.response.data?.errors).flat()[0] : null;
                                // Only show detailed error in displayMessage2 if it is different from the main message
                                if (detailedError && detailedError !== this.error_message) {
                                    this.displayMessage2 = detailedError;
                                } else {
                                    this.displayMessage2 = '';
                                }
                                console.log('HITTING CREATE ERROR', this.error_message);
                                this.signature = false;
                                const fullErrorString = (this.error_message || '') + ' ' + (detailedError || '');
                                if (this.isFormValidationError(err)) {
                                    this.showFormError(err, detailedError);
                                } else if (fullErrorString.toLowerCase().includes('ceased')) {
                                    this.dismissRequired = true;
                                    this.forceCreateRequired = true;
                                } else if (this.activePresChart) {
                                    this.forceCeaseRequired = true;
                                    this.forceCreateRequired = true;
                                }
                            })

                        } else {
                            this.$store.dispatch('getRefreshToken');
                            await axios.post(this.endpoint, newPayload, this.$store.state.header).then(res => {
                                console.log('this is the res', res);
                                console.log('this is the payload variable', newPayload);
                                this.form.chart_payload.prescription_id = res.data;
                                if(this.generateCode){
                                    axios.post('/apn/create', {prescription_id: res.data, prescriber: JSON.parse(localStorage.getItem('user_id'))}, this.$store.state.header)
                                    .then(response=>{
                                        this.hasAuthCode = true;
                                        this.form.prescription_payload.authority_prescription_number = response.data.authority_prescription_number;
                                    })
                                    .catch(error => {
                                        // Handle error
                                        this.displayPBSAlertModal = false
                                        this.loading = false
                                        this.error_message = error.response.data.message ? error.response.data.message : error.response.data;
                                        this.displayMessage2 = error.response.data.errors
                                        this.displayMessage = 'Error: ' + this.error_message
                                        console.log('HITTING CREATE ERROR', this.error_message)
                                    })
                                }

                                this.form.chart_payload.chart_form.route = newPayload.route;
                                this.form.chart_payload.chart_form.type = this.selectedChart.chart_name;
                                if (this.selectedDrug.tags) {
                                    this.form.chart_payload.chart_form.tags = [];
                                    this.selectedDrug.tags.forEach(tag => {
                                        this.form.chart_payload.chart_form.tags.push(tag.toLowerCase())
                                    })
                                }
                                console.log('this is the chart payload', this.form.chart_payload);
                            }).then(() => {
                                this.$store.dispatch('getRefreshToken');
                                console.log('the create chart endpoint is being processed now');
                                axios.post('/chart', this.form.chart_payload, this.$store.state.header).then(res2 => {
                                    
                                    
                                    console.log('submitted chart create, this is res', res2);
                                    this.$store.dispatch('getRefreshToken');
                                    this.loading = false;
                                    this.getFirstAdminRoundTime();
                                    this.displayMessage = 'Your prescription and chart have been successfully created.';
                                    let tags = []
                                    if(this.selected_administration_options.length){
                                        this.selected_administration_options.forEach(item=>{
                                            tags.push(item.value)
                                        })
                                    }
                                    if (Object.keys(this.selected_packing).length != 0) {
                                        tags.push(this.selected_packing.value.toLowerCase())
                                    }
                                    if(tags.length){
                                        axios.post(`/chart/${res2.data.uuid}/add-tags`,{tags: tags},this.$store.state.header).then(res3=>{
                                            console.log('added tags to chart', res3.data);
                                        })
                                    }
                                    if(this.generateCode){
                                        this.displaySuccessModal = false;
                                    }
                                    // UNCOMMENT WHEN REINTRODUCING IHI CHECKING
                                    // if (sign) {
                                    //     this.preChartCheck();
                                    // }
                                    if(!sign && !this.activePresChart && !this.hasAuthCode){
                                        this.clearForm();
                                        this.clearCustomMedForm();
                                    }
                                    if ((sign || this.signNow) && !this.chartReview) {

                                        this.prescription_sign_payload.prescription_id = this.form.chart_payload.prescription_id;
                                        this.prescription_sign_payload.is_paper = this.form.prescription_payload.is_paper ? true : false;
                                        if(!this.displayPhoneOrderModal){
                                            this.displayMessage2 = `Click the ${this.scheduledMedicine ? 'Sign' : 'Complete'} button to sign off on prescription.`;
                                        }
                                        this.signature = true;
                                    }
                                    // DISMISS EXPIRED PRESCRIPTION AFTER RX AND CHART RENEWAL
                                    if (this.activePresChart && this.activePresChart.chart_payload && this.activePresChart.chart_payload.prescription_id) {
                                        axios.post('/dismiss-expired-prescriptions', {prescription_ids: [this.activePresChart.chart_payload.prescription_id]}, this.$store.state.header).then(resD=>{
                                            console.log('dismissed all expired meds', resD);
                                            
                                        }).catch(err => {
                                            console.log('Error dismissing expired prescriptions:', err);
                                        })
                                    }
                                    if (this.chartReview) {
                                        this.displayMessage2 = 'Prescription has been added to the list of prescriptions that will be signed off at the end of the chart review.';
                                        this.$emit('addToReview', { prescription_id: this.form.chart_payload.prescription_id, status: 'edited' });
                                    }
                                    this.drugSearchFilter = 1
                                })
                            }).catch(err => {
                                this.loading = false;
                                this.error_message = err.response.data.message ? err.response.data.message : err.response.data;
                                this.displayMessage2 = err.response.data?.errors ? Object.values(err.response.data?.errors).flat()[0] : err;
                                this.displayMessage = 'Error: ' + this.error_message + ' '+ this.displayMessage2;
                                console.log('HITTING CREATE ERROR', this.error_message);
                                this.signature = false;

                                const fullErrorString = (this.error_message || '') + ' ' + (this.displayMessage2 || '');
                                if (fullErrorString.toLowerCase().includes('ceased')) {
                                    this.dismissRequired = true;
                                    this.forceCreateRequired = true;
                                } else {
                                    this.displaySuccessModal = false;
                                    this.displayErrorModal = true;
                                    this.errorTitle = err.response.data.title ? err.response.data.title : "Form Error";
                                    this.errorMessage = this.displayMessage;
                                }
                            })
                            console.log('this is the prescrption/chart form', this.form, this.patientId);
                            // this.clearForm();
                        }
                        
                        this.$emit('prescriptionPayload',  this.form.prescription_payload);
                        
                        // FUNCTION END
                        // FUNCTION END
                        // FUNCTION END

                    }
                    this.cancelAction = null;

                }

            }, 1000)
            timer = 1;
            this.displayMessage = '';

        },
        preChartCheck() {
            this.$store.dispatch('getRefreshToken');
            this.displayMessage = 'Validating IHI...';
            console.log('doing pre chart check')
            let ihiDetails = '';
            // CHECKING PATIENT IHI NUMBER AND PRESCRIBERS HPI-I NUMBER
            this.$store.dispatch('getRefreshToken');
            axios.post(`/person/${this.patientId}/ihi`, {}, this.$store.state.header).then(res => {
                ihiDetails = res.data;
                // if(res.data.conflicted){
                //     this.displayIHIConflictModal = true;
                // }
                let payload = {
                    type: 'ihi',
                    number: ihiDetails.number ? ihiDetails.number : '',
                    patient_id: this.patientId
                }
                axios.post(`/validate-ihi`, payload, this.$store.state.header).then(res => {
                    console.log('this is the response for validate IHI', res.data);
                    this.validIHI();
                }).catch(err => {
                    console.log('/validate-ihi failed with the following error:', err, err.response);
                    if (err.response && err.response.data && err.response.data.error && err.response.data.error.includes("duplicate")) {
                        console.log('Resolved and different IHI number returned', err.response.data.data);
                        payload = {
                            type: 'ihi',
                            number: err.response.data.data.ihi_number,
                            patient_id: this.patientId
                        }
                        axios.post('/validate-ihi', payload, this.$store.state.header).then(response => {
                            console.log("This is the response for the second validate IHI", response.data);
                            this.validIHI();
                        }).catch(err => {
                            this.invalidIHI(err);
                        })
                    }
                    this.invalidIHI(err);
                })
            }).catch(err => {
                console.log("This is the response for /ihi", err.response, err.response.data);
                if (err && err.response && err.response.data) {
                    this.displayMessage = err.response.data;
                    this.displayMessage2 = 'A draft chart has been created - please close this page and return to the resident profile to review.'
                }
            })
        },
        validIHI() {
            this.$store.dispatch('getRefreshToken');
            this.displayMessage = 'IHI validated. Your prescription and chart have been successfully created.';
            if (!this.chartReview) {
                this.signature = true;
            }
        },
        invalidIHI(err) {
            this.$store.dispatch('getRefreshToken');
            this.errorMessage = err.response.data.error;
            if (this.errorMessage.includes('failure')) {
                this.displayMessage = '';
            }
            this.errorTitle = "Form Error";
            this.displayErrorModal = true;
            if (!this.chartReview) {
                this.signature = true;
            }
        },
        insertNewTimeField() {
            this.$store.dispatch('getRefreshToken');
            //  if(this.selectedChart.inputs.includes('frequency') && this.form.prescription_payload.frequency && ( this.form.prescription_payload.frequency !='BD' && this.form.prescription_payload.frequency !='TDS' && this.form.prescription_payload.frequency !='QiD')){
            let numOfTimeInputs = 0;
            for (let key in this.formTimes) {
                console.log('this is a key', key);
                numOfTimeInputs++;
            }
            this.formTimes[`time${numOfTimeInputs + 1}`] = '';
            this.readHeightMeasurer();
            //  }

            // this.updateFrequencyBasedOnTimeFields();


        },
        getFrequencies() {
            this.$store.dispatch('getRefreshToken');
            axios.post('/prescription/frequencies', {facility_id: this.patient.physical_location.location.facility.uuid}, this.$store.state.header).then(res => {
                console.log('THESE ARE THE PRESCRIPTION FREQUENCIES', res.data);
                this.frequencyTypes = res.data;
                // this.frequencyTypes.push({
                //     frequency_name: "Variable",
                //     interval: 1,
                //     period: 'variable',
                //     times: ['0600', '0800', '1000', '1200', '1700', '1800', '2000', '2200'],
                //     days_of_week: ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA']
                // })
                // this.frequencyTypes.push({
                //     frequency_name: "Custom",
                //     interval: 1,
                //     period: 'weekly',
                //     times: ['0600', '0800', '1000', '1200', '1700', '1800', '2000', '2200'],
                //     days_of_week: ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA']
                // })
            })
        },
        updateForm(newData) {
            this.$store.dispatch('getRefreshToken');
            if (this.new) {
                this.form = newData;

                // Ensure consent_uuid is populated if the prescription already has a consent object
                if (this.form.prescription_payload && this.form.prescription_payload.consent && this.form.prescription_payload.consent !== 'new') {
                    let consentFromPayload = this.form.prescription_payload.consent;
                    this.form.prescription_payload.consent_uuid = consentFromPayload.uuid;
                    
                    if (this.patient?.prescribing_consent?.uuid === consentFromPayload.uuid) {
                        this.form.prescription_payload.consent = this.patient.prescribing_consent;
                    } else if (this.patient?.psychotropic_consent?.uuid === consentFromPayload.uuid) {
                        this.form.prescription_payload.consent = this.patient.psychotropic_consent;
                    }
                }
                
                // Extract selectedUse from existing notes if present
                if (this.form.prescription_payload && this.form.prescription_payload.notes) {
                    const notes = this.form.prescription_payload.notes;
                    const found = this.useOptions.find(option => notes.includes(option));
                    if (found) {
                        this.selectedUse = found;
                    }
                }

                this.form.prescription_payload.patient_id = this.patientId ? this.patientId : this.$route.params.id;
                this.form.prescription_payload.reason = this.form.prescription_payload.reason ? this.form.prescription_payload.reason : '';
                this.form.prescription_payload.drug_uuid = this.draftDrug.alias_id;

                console.log('THIS IS THE FORM', this.form, newData);
                this.start_date = this.form.prescription_payload.start_date;
                this.stop_date = this.form.prescription_payload.stop_date;

                this.formTimes = {};

                let chartTypes = this.$store.getters.getChartTypes;
                console.log('update form has been hit', this.form, this.draftDrug);
                chartTypes.forEach(chartType => {
                    if (chartType.chart_name == this.form.chart_payload.chart_form.type) {
                        this.selectedChart = chartType;
                    }
                })

                this.selectedDrug = this.draftDrug;
                this.selectedDrug.full_name = `(${this.selectedDrug.generic_name}) ${this.selectedDrug.name}`
                console.log('THIS ITHE NEW DATA', newData.chart_payload.chart_form.tags);
                if (newData.chart_payload.chart_form.tags?.length) {
                    if (newData.chart_payload.chart_form.tags.includes('packed')) {
                        console.log('this contains packed');
                        this.packed = 'packed';
                    }
                    if (newData.chart_payload.chart_form.tags.includes('non-packed')) {
                        console.log('this contains non-packed');
                        this.packed = 'non-packed';
                    }
                    if (newData.chart_payload.chart_form.tags.includes('single')) {
                        console.log('this contains single');
                        this.single_multi = 'single';
                    }
                    if (newData.chart_payload.chart_form.tags.includes('multi')) {
                        console.log('this contains multi');
                        this.single_multi = 'multi';
                    }
                    if (newData.chart_payload.chart_form.tags.includes('now')) {
                        console.log('this contains now');
                        this.now_or_next_pack = 'now';
                    }
                    if (newData.chart_payload.chart_form.tags.includes('next_pack')) {
                        console.log('this contains next_pack');
                        this.now_or_next_pack = 'next_pack';
                    }
                }

                let timesArray = this.form.prescription_payload.times || [];
                let numOfTimes = timesArray.length;
                let times = [];
                timesArray.forEach(time => {
                    // HARDEN: Only split if it's a string. In variable mode, times can be objects.
                    if (typeof time === 'string') {
                        time = time.split('');
                        time = `${time[0]}${time[1]}:${time[2]}${time[3]}`;
                        times.push(time);
                    }
                })

                let num = 1;
                setTimeout(() => {
                    console.log('this is the payload times', times)
                    while (numOfTimes > 0) {
                        console.log('numof times', num);
                        this.formTimes[`time${num}`] = times.shift();
                        if (num > 4) {
                            console.log('ITS GREATER THAN 4', num);
                        }
                        numOfTimes -= 1;
                        num += 1;
                    }
                }, 500)
            }
        },
        unique(array, propertyName) {
            return array.filter((e, i) => array.findIndex(a => a[propertyName] === e[propertyName]) === i);
        },
        renewChart(arg){
            console.log('triggerRenew - calling the child trigger renew', this.renewExpired);
            return arg
        },
        checkPrescription() {
             if (this.activePresChart && this.activePresChart.prescription_payload) {
                // Paper prescriptions are not submitted to NPDS — skip eRx status check entirely
                if (this.activePresChart.prescription_payload.is_paper) {
                    return;
                }
                // isTransitionalConformance reads patient.erx_chart, so it is false while the
                // patient is still being fetched - not because the patient has an eRx chart, but
                // because we don't know yet. PrescriptionRenewModal renders this component as soon
                // as the frequency list arrives and fills `patient` from a separate request, so
                // the mount-time call landed inside that window and sent a transitional item off
                // to eRx. "Not known yet" must not read as "has an eRx chart": bail, and the
                // patient watcher below re-runs this once the patient is actually loaded.
                if (!this.patient) {
                    this.erxCheckDeferred = true;
                    return;
                }
                this.erxCheckDeferred = false;
                // Transitional conformance items have no scid, so there is nothing on eRx to look
                // up - checking would query a null scid and stamp a bogus erx_status.
                if (this.isTransitionalConformance) {
                    return;
                }
                // Clone the payload to avoid modifying the original
                const payload = JSON.parse(JSON.stringify(this.activePresChart.prescription_payload));

                // Ensure prescription_id is present
                if (!payload.prescription_id) {
                    if (this.activePresChart.chart_payload && this.activePresChart.chart_payload.prescription_id) {
                        payload.prescription_id = String(this.activePresChart.chart_payload.prescription_id);
                    } else if (this.activePresChart.uuid) {
                         // Note: activePresChart.uuid might be the chart uuid or prescription uuid depending on context
                         // But for existing prescriptions usually chart_payload.prescription_id is the key
                         payload.prescription_id = String(this.activePresChart.uuid);
                    }
                }

                // Convert dose to string if it's a number
                // The backend CreatePrescriptionRequest expects dose to be a String
                if (typeof payload.dose === 'number') {
                    payload.dose = String(payload.dose);
                }

                // Ensure num_repeats_authorised is an integer (or null)
                // The backend CreatePrescriptionRequest expects num_repeats_authorised to be Option<String>
                if (payload.num_repeats_authorised !== null && payload.num_repeats_authorised !== undefined) {
                     payload.num_repeats_authorised = String(payload.num_repeats_authorised);
                }

                // Ensure max_daily_admin is a string if it's a number
                // The backend CreatePrescriptionRequest expects max_daily_admin to be Option<String>
                if (typeof payload.max_daily_admin === 'number') {
                    payload.max_daily_admin = String(payload.max_daily_admin);
                }

                // Ensure prescribed_quantity is a string
                if (typeof payload.prescribed_quantity === 'number') {
                    payload.prescribed_quantity = String(payload.prescribed_quantity);
                }

                // Ensure max_dose is a string
                if (typeof payload.max_dose === 'number') {
                    payload.max_dose = String(payload.max_dose);
                }

                // Ensure max_admin_dose is a string
                if (typeof payload.max_admin_dose === 'number') {
                    payload.max_admin_dose = String(payload.max_admin_dose);
                }

                // Ensure aslr_consent is a boolean (default to false if missing/null)
                // Kraken requires this field.
                if (payload.aslr_consent === null || payload.aslr_consent === undefined) {
                    payload.aslr_consent = false;
                }
                
                if (this.currentErxStatus && this.currentErxStatus !== 'Checking...' && this.currentErxStatus !== '') {
                    // Already has a final status, skip check
                    return;
                }

                if (this.currentErxStatus !== 'Checking...') {
                     this.$emit('erxStatusUpdate', 'Checking...');
                }

                // Delay the API call slightly to allow the parent to re-render if the status changed.
                // If the re-render destroys this component, this timeout will be cleared in beforeUnmount,
                // preventing a duplicate API call (orphaned request).
                this.apiTimeout = setTimeout(() => {
                    axios.post('/prescription/check', payload, this.$store.state.header)
                    .then(res => {
                        if (this.activePresChart) {
                            // User requirement: Default to Active if submitted to eRx (has scid) and not draft (signed).
                            // If check succeeds, it's valid/active.
                            // We check for scid. Draft check: checking signatures length > 0.
                            // User requirement: Default to Active if submitted to eRx (has scid) and not draft (signed).
                            // If check succeeds, it's valid/active.
                            // We check for scid from props or object. Draft check: checking signatures length > 0.
                            const hasScid = this.scid || this.activePresChart.scid || (this.activePresChart.chart_payload && this.activePresChart.chart_payload.scid);
                            const isSigned = this.activePresChart.signatures && this.activePresChart.signatures.length > 0;
                            
                            if (hasScid && isSigned) {
                                if (this.currentErxStatus !== 'Active') {
                                    this.$emit('erxStatusUpdate', 'Active');
                                }
                            } else {
                                // Invisible otherwise
                                if (this.currentErxStatus !== '') {
                                    this.$emit('erxStatusUpdate', '');
                                }
                            }
                        }
                    })
                    .catch(err => {
                        let msg = '';
                        if (err.response && err.response.data && err.response.data.errors && err.response.data.errors.message) {
                            // Extract from nested errors object
                            if (Array.isArray(err.response.data.errors.message)) {
                                msg = err.response.data.errors.message.join(' ');
                            } else {
                                msg = String(err.response.data.errors.message);
                            }
                        } else if (err.response && err.response.data && err.response.data.message) {
                            msg = err.response.data.message;
                        } else if (err.response && err.response.data) {
                            msg = err.response.data; // Sometimes it's just the string?
                        }
                        if (msg) {
                            // match for contains particular statuses: disabled, ceased, pending, expired, exhausted, cancelled, supplied
                            var statusName = 'Unknown';
                            switch (true) {
                                case msg?.toLowerCase()?.includes('disabled'):
                                    if (this.currentErxStatus !== 'disabled') {
                                        statusName = 'Disabled';
                                    }
                                    break;
                                case msg?.toLowerCase()?.includes('locked'):
                                    if (this.currentErxStatus !== 'locked') {
                                        const parts = msg?.split(',');
                                        const secondSplit = parts[1]?.split('.'); // split on full stop as the message is "Already Supplied, 2.  "
                                        var numberOfSupplies = secondSplit?.length > 1 ? secondSplit[0].trim() : 0;

                                        statusName = 'Locked, ' + numberOfSupplies;
                                    }
                                    break;
                                case msg?.toLowerCase()?.includes('ceased'):
                                    if (this.currentErxStatus !== 'ceased') {
                                        statusName = 'Ceased';
                                    }
                                    break;
                                case msg?.toLowerCase()?.includes('pending'):
                                    if (this.currentErxStatus !== 'pending') {
                                        statusName = 'Pending';
                                    }
                                    break;
                                case msg?.toLowerCase()?.includes('expired'):
                                    if (this.currentErxStatus !== 'expired') {
                                        statusName = 'Expired';
                                    }
                                    break;
                                case msg?.toLowerCase()?.includes('exhausted'):
                                    if (this.currentErxStatus !== 'exhausted') {
                                        statusName = 'Exhausted';
                                    }
                                    break;
                                case msg?.toLowerCase()?.includes('cancelled'):
                                    if (this.currentErxStatus !== 'cancelled') {
                                        statusName = 'Cancelled';
                                    }
                                    break;
                                case msg?.toLowerCase()?.includes('timed out'):
                                    if (this.currentErxStatus !== 'Timeout') {
                                        statusName = 'Network Timeout';
                                    }
                                    break;
                                case msg?.toLowerCase()?.includes('contact'):
                                    if (this.currentErxStatus !== 'rejected') {
                                        statusName = 'ERX Connection Error';
                                    }
                                    break;
                                case msg?.toLowerCase()?.includes('provided scid'):
                                    if (this.currentErxStatus !== 'DSPID Not Found') {
                                        statusName = 'DSPID Not Found';
                                    }
                                    break;
                                case msg?.toLowerCase()?.includes('supplied'):
                                    if (this.currentErxStatus !== 'supplied') {
                                        // This response message has something like "Already Supplied, " . $numberofsupplies
                                        // we need to extract the number of supplies and show that in the status for user clarity.
                                        const parts = msg?.split(',');
                                        const secondSplit = parts[1]?.split('.'); // split on full stop as the message is "Already Supplied, 2.  "
                                        numberOfSupplies = secondSplit?.length > 1 ? secondSplit[0].trim() : 0;

                                        statusName = 'Supplied ' + numberOfSupplies; // Append number of supplies if available
                                    }
                                    break;
                                default:
                                    // If no known status is found, you might want to set it to a default value or leave it unchanged
                                    break;
                            }
                            if (this.activePresChart) {
                                    this.$emit('erxStatusUpdate', statusName);
                            }
                            
                            // if (match && match[1]) {
                            //     if (this.activePresChart) {
                            //         if (this.currentErxStatus !== match[1]) {
                            //             this.$emit('erxStatusUpdate', match[1]);
                            //         }
                            //     }
                            // }
                        }
                    })
                }, 100);
            }
        }
        
    },
    beforeUnmount() {
        if (this.checkTimeout) {
            clearTimeout(this.checkTimeout);
        }
        if (this.apiTimeout) {
            clearTimeout(this.apiTimeout);
        }
    },
    computed: {
        isS8Prescription() {
            const tags = [this.selectedDrug?.tags, this.draftDrug?.tags]
                .flatMap(list => Array.isArray(list) ? list : []);
            return !!(this.scheduledMedicine || this.custom_s8 || tags.some(tag => String(tag).toUpperCase() === 'S8'));
        },
        // Mirrors kraken's S8SupplyRule so the prescriber sees it before submitting: an S8 is
        // limited to a single supply, and repeats need a PBS authority approval from Services
        // Australia. Only the cases nothing else flags - a private S8, which kraken rejects on
        // save, and a PBS S8 that is not on the authority path, which kraken refuses to sign. An
        // authority script waiting on its approval code is the normal path and already has its
        // own message ("Authority scripts require an approval code in order to sign").
        s8RepeatsWarning() {
            const payload = this.form.prescription_payload;
            if (!this.isS8Prescription || !(parseInt(payload.num_repeats_authorised) > 0)) {
                return '';
            }
            if (!payload.pbs_code) {
                return 'Schedule 8 medicines are limited to a single supply. Repeats can only be prescribed on a PBS prescription with an authority approval from Services Australia - set repeats to 0.';
            }
            // A code picked in this session wins over the type saved with the chart, even when blank.
            const pbsType = this.selected_pbs_code ? this.selected_pbs_code.restriction_flag : payload.pbs_type;
            if (pbsType != 'A' && !payload.authority_prescription_number) {
                return 'Schedule 8 medicines are limited to a single supply. Repeats need a PBS authority approval from Services Australia - generate an Authority Prescription Number, or set repeats to 0.';
            }
            return '';
        },
        // How long ago the INR being acknowledged was taken, in words. `latestInrReading` is
        // kraken's newest reading of that type with no date bound (Person::latestInrReading is an
        // ofMany(['id' => 'max'])), so a months-old INR is served as "latest" and the absolute
        // timestamp alone left the prescriber to do that arithmetic. Null when the timestamp
        // can't be read, in which case the template shows the absolute date on its own.
        latestInrTakenForHumans() {
            return diffForHumans(this.patient?.latest_inr_reading?.created_at);
        },
        // A patient with no eRx chart has not been transitioned into the digital prescription
        // system yet, so anything prescribed for them is a transitional conformance item that
        // is signed locally and never sent to eRx (and therefore does not require the
        // prescriber's ePrescribing setup). forceNoErx is set when the prescriber explicitly
        // opts out via the LegacyPrescriptionInterceptModal.
        isTransitionalConformance() {
            return !!(this.forceNoErx || (this.patient && !this.patient.erx_chart));
        },
        prescriptionSignPayload() {
            return {
                ...this.prescription_sign_payload,
                // Re-derived here rather than only at mount: the signing modal can be opened
                // from flows where the patient resolves after mount, and no_erx must be on the
                // payload or the backend treats the sign as an eRx submission.
                no_erx: !!(this.prescription_sign_payload.no_erx || this.isTransitionalConformance),
                // A prescriber signing their own script only ever requires their single
                // signature - there is never a witness signature for prescribing, regardless of
                // S8/scheduled status, so this must stay false to stop SignatureModal's
                // dual-signature (primary+witness) UI from being offered/forced. Mirrors the
                // same rule already applied to cancellations in buildCancelSignaturePayload().
                has_scheduled_items: false
            };
        },
        // The shared SignatureModal instance below is reused for sign/cancel/create - tag the
        // Signature record as 'cancellation' only while it's being used for the cancel flow, so
        // the backend can distinguish it from a normal prescription-signing signature.
        signatureType() {
            return this.endpoint === '/prescription/cancel' ? 'cancellation' : '';
        },
        allergyWarningMessage() {
            const lines = this.allergyWarningMatches.map((adr) => {
                const drugName = adr.custom || (adr.alias && adr.alias.name) || 'this drug';
                const parts = [`${drugName}`];
                if (adr.reaction_type) parts.push(`Reaction: ${adr.reaction_type}`);
                if (adr.severity) parts.push(`Severity: ${adr.severity}`);
                if (adr.status) parts.push(`Status: ${adr.status}`);
                return `• ${parts.join(' — ')}`;
            });
            return `This ${this.$resident ? this.$resident() : 'resident'} has a recorded allergy to the same generic as ${this.pendingAllergyDrugName}:\n${lines.join('\n')}\n\nDo you want to continue?`;
        },
        isWarfarinOrINR() {
            let isWarfarin = false;
            if (this.drugName && this.drugName.toLowerCase().includes('warfarin')) isWarfarin = true;
            if (this.draftDrug && this.draftDrug.name && this.draftDrug.name.toLowerCase().includes('warfarin')) isWarfarin = true;
            if (this.selectedDrug && ((this.selectedDrug.name && this.selectedDrug.name.toLowerCase().includes('warfarin')) || (this.selectedDrug.full_name && this.selectedDrug.full_name.toLowerCase().includes('warfarin')))) isWarfarin = true;
            
            let isINRScale = false;
            if (this.sliding && this.slidingScaleType && this.slidingScaleType.label == 'INR') isINRScale = true;

            return isWarfarin || isINRScale;
        },
        // Name-based check against a drug list, same approach as TallmanLettering.js - not a
        // clinical source of truth, just a simple safety net to prompt for a recorded weight.
        isWeightDependentDrugSelected() {
            if (this.drugName && isWeightDependentDrug(this.drugName)) return true;
            if (this.draftDrug && this.draftDrug.name && isWeightDependentDrug(this.draftDrug.name)) return true;
            if (this.selectedDrug && (isWeightDependentDrug(this.selectedDrug.name) || isWeightDependentDrug(this.selectedDrug.generic_name) || isWeightDependentDrug(this.selectedDrug.full_name))) return true;
            return false;
        },
        weightDependentDrugBlockMessage() {
            if (!WEIGHT_DOSING_HARD_BLOCK_ENABLED) return '';
            if (!this.isWeightDependentDrugSelected) return '';
            if (this.dosingWeight) return '';
            return 'This medication is dosed by patient weight and no weight is recorded for this resident. Please record a current weight before prescribing.';
        },
        slidingScaleValidationError() {
            if (!this.sliding || !this.form.prescription_payload.sliding_scale || !this.form.prescription_payload.sliding_scale.length) return '';
            // Defence in depth: addSlidingTable()/updateSlidingScaleType() already prevent an
            // INR scale from ending up with more than one band, but this is a hard submit-time
            // backstop in case any other path adds one (e.g. loading an old chart that already
            // has multiple INR bands from before this rule existed).
            if (this.isWarfarinOrINR && this.form.prescription_payload.sliding_scale.length > 1) {
                return 'INR sliding scales only support a single reading range. Please remove the extra row(s) - only one Min/Max/Dosage band is used for INR.';
            }
            const scales = this.form.prescription_payload.sliding_scale;
            let previousMax = null;
            for (let i = 0; i < scales.length; i++) {
                const band = scales[i];
                if ((band.min === '' || band.min === null || band.min === undefined) && (band.max === '' || band.max === null || band.max === undefined)) {
                    continue;
                }
                const hasMin = band.min !== '' && band.min !== null && band.min !== undefined;
                const hasMax = band.max !== '' && band.max !== null && band.max !== undefined;
                const min = hasMin ? parseFloat(band.min) : null;
                const max = hasMax ? parseFloat(band.max) : null;
                if (hasMin && isNaN(min)) return `Row ${i + 1}: Min value "${band.min}" is not a valid number.`;
                if (hasMax && isNaN(max)) return `Row ${i + 1}: Max value "${band.max}" is not a valid number.`;
                if (min !== null && max !== null && min >= max) return `Row ${i + 1}: Min (${band.min}) must be less than Max (${band.max}).`;
                if (previousMax !== null && min !== null && min < previousMax) {
                    return `Row ${i + 1}: Min (${band.min}) overlaps with the previous row's Max (${previousMax}). Sliding scale rows must be entered in ascending order with non-overlapping ranges.`;
                }
                if (max !== null) previousMax = max;
            }
            return '';
        },
        isInfusion() {
            if (!this.selectedDrug || !this.selectedDrug.name) return false;
            
            const name = this.selectedDrug.name?.toLowerCase() || '';
            const form = this.selectedDrug.form?.toLowerCase() || '';
            const fullName = this.selectedDrug.full_name?.toLowerCase() || '';
            
            const keywords = ['infusion', 'bag', 'injection', 'solution'];
            return keywords.some(keyword => name.includes(keyword) || form.includes(keyword) || fullName.includes(keyword));
        },
        infusionTemplateText() {
            return `\nAdditional Instructions:\nInfusion instructions: \nInfusion liquid: \nRate/time: \nMaximum hourly rate: \nDaily limits: \n`;
        },
        effectiveConsent() {
            // Prioritize:
            // 1. Consent already attached to this draft/prescription payload
            // 2. The consent selected in the dropdown (stored in payload)
            // 3. Fallback to prescribing_consent if viewing existing
            return this.form?.prescription_payload?.consent || this.patient?.prescribing_consent || this.patient?.consent || null;
        },
        availableConsents() {
            let options = [];
            options.push({ label: 'None', value: null });
            
            let addedUuids = [];
            
            if (this.patient?.prescribing_consent) {
                options.push({ label: 'Existing Prescribing Consent', value: this.patient.prescribing_consent });
                addedUuids.push(this.patient.prescribing_consent.uuid);
            }
            if (this.patient?.psychotropic_consent?.uuid) {
                if (!addedUuids.includes(this.patient.psychotropic_consent.uuid)) {
                    options.push({ label: 'Existing Psychotropic Consent', value: this.patient.psychotropic_consent });
                    addedUuids.push(this.patient.psychotropic_consent.uuid);
                }
            }
            
            if (this.form?.prescription_payload?.consent && this.form.prescription_payload.consent !== 'new' && this.form.prescription_payload.consent.uuid) {
                if (!addedUuids.includes(this.form.prescription_payload.consent.uuid)) {
                    options.push({ label: 'Currently Attached Consent', value: this.form.prescription_payload.consent });
                    addedUuids.push(this.form.prescription_payload.consent.uuid);
                }
            }

            options.push({ label: 'Add New Consent...', value: 'new' });
            return options;
        },
        frequencies() {
            let opts = this.frequencyOptions ? this.frequencyOptions : this.frequencyTypes;
            if(!opts) return [];
            return opts.map(f => {
                return {
                    ...f,
                    display_name: f.display_name || f.frequency_name
                }
            });
        },
        formattedDrugList() {
            let formattedDrugList = [...this.drugList];
            formattedDrugList.forEach(drug => {
                const genericName = drug.generic_name || '';
                const brandName = drug.name || '';
                
                drug.generic_name = genericName ? applyTallmanLettering(genericName) : '';
                drug.name = brandName ? brandName.charAt(0).toUpperCase() + brandName.slice(1) : '';
                drug.full_name = drug.generic_name ? `(${drug.generic_name}) \u2013 ${drug.name}` : drug.name;
            })
            return formattedDrugList;
        },
        formattedDoseUnits() {
            let doseUnits = [];
            this.doseTypes?.forEach(unit => {
                doseUnits.push(unit.dose_unit)
            });
            return doseUnits.sort();
        },
        displayTimes() {
            // Deliberately unfiltered. schedule_quantity is already rebuilt to exactly the
            // frequency's times by updateDoseSchedule(), and populated from the saved dose_times
            // when an existing chart is loaded, so filtering it against frequency.times was
            // redundant on every correct path and destructive on two:
            //   - editing a time (0800 -> 0700) made the entry stop matching the template, so the
            //     column the user was typing in was dropped mid-keystroke; with the index-keyed
            //     v-for Vue then patched the neighbouring entry into that same input and the rest
            //     of the keystrokes destroyed it too, emptying the grid.
            //   - a saved chart whose times differ from its frequency template rendered blank.
            return this.schedule_quantity;
        },
        ujjinDose() {
            if (this.targetInrMin !== 2.0 || this.targetInrMax !== 3.0) {
                return "Algorithm strictly calibrated for INR target of 2.0 to 3.0.";
            }
            if (this.hasMechanicalValve) {
                return "Patient excluded: mechanical valves require higher-intensity anticoagulation targets.";
            }
            if (!this.dosingWeight || !this.dosingAge || typeof this.dosingCreatinine !== 'number' || this.dosingCreatinine === null) {
                return null;
            }
            // The published algorithm takes serum creatinine in mg/dL, but the reading is
            // captured in µmol/L (the unit Australian pathology labs report, and what the
            // creatinine ReadingPanel stores). Without this conversion a normal AU reading of ~90
            // makes the creatinine term -36, the dose goes negative, and the Math.max(0, ...)
            // below silently reports 0.00 mg rather than surfacing an error.
            const creatinineMgPerDl = this.dosingCreatinine / MICROMOL_PER_L_TO_MG_PER_DL;
            let dose = 3 + (0.02 * this.dosingWeight) - (0.02 * this.dosingAge) - (0.4 * creatinineMgPerDl);
            return Math.max(0, dose).toFixed(2);
        },
        iwpcDose() {
            if (!this.dosingWeight || !this.dosingAge || !this.dosingHeight || !this.dosingRace) {
                return null;
            }
            
            let is_asian = this.dosingRace === 'Asian' ? 1 : 0;
            let is_black = this.dosingRace === 'Black' ? 1 : 0;
            let is_mixed = this.dosingRace === 'Mixed' ? 1 : 0;
            // Note: If White, all 3 biological flags correctly evaluate to 0

            let age_decades = this.dosingAge / 10.0;
            
            let sqrtWeekly = 4.0376 
                - (0.2546 * age_decades) 
                + (0.0118 * this.dosingHeight) 
                + (0.0134 * this.dosingWeight) 
                - (0.6752 * is_asian) 
                + (0.4060 * is_black) 
                + (0.0443 * is_mixed) 
                + (1.2799 * (this.hasEnzymeInducer ? 1 : 0)) 
                - (0.5695 * (this.hasAmiodarone ? 1 : 0));
                
            let weeklyDose = Math.pow(sqrtWeekly, 2);
            let dailyDose = weeklyDose / 7.0;
            
            return Math.max(0, dailyDose).toFixed(2);
        }
    },
    watch: {
        isWarfarinOrINR: {
            handler(newVal) {
                if (newVal) {
                    this.initializeDosingVariables();
                    // Auto-select INR configuration
                    if (this.slidingScaleTypes && this.slidingScaleTypes.length) {
                        const inrType = this.slidingScaleTypes.find(type => type.label === 'INR');
                        if (inrType) {
                            this.slidingScaleType = inrType;
                        }
                    }
                    // Auto-select sliding if not already selected
                    if (!this.sliding && !this.disableAll) {
                        this.sliding = true;
                        if (!this.form.prescription_payload.sliding_scale || !this.form.prescription_payload.sliding_scale.length) {
                            this.addSlidingTable();
                        }
                    }
                }
            },
            immediate: true
        },
        // Weight-dependent drugs other than Warfarin (e.g. Gentamicin) still need dosingWeight
        // pre-populated so the block message below can tell whether a weight is actually on file.
        isWeightDependentDrugSelected: {
            handler(newVal) {
                if (newVal) {
                    this.initializeDosingVariables();
                }
            },
            immediate: true
        },
        patient: {
            handler(newVal) {
                if (newVal && (this.isWarfarinOrINR || this.isWeightDependentDrugSelected)) {
                    this.initializeDosingVariables();
                }
                // The eRx status check bailed because the patient hadn't arrived yet. Now it has,
                // isTransitionalConformance can be trusted, so run the check it skipped - an eRx
                // script still gets its status, a transitional one still never reaches eRx.
                if (newVal && this.erxCheckDeferred) {
                    this.erxCheckDeferred = false;
                    this.checkPrescription();
                }
            },
            deep: true,
            immediate: true
        },
        isInfusion(newVal, oldVal) {
            if (newVal && !oldVal) {
                if (this.form && this.form.prescription_payload && typeof this.form.prescription_payload.notes === 'string') {
                    if (!this.form.prescription_payload.notes.includes('Additional Instructions:')) {
                         this.form.prescription_payload.notes += this.infusionTemplateText;
                    }
                }
            } else if (!newVal && oldVal) {
                if (this.form && this.form.prescription_payload && typeof this.form.prescription_payload.notes === 'string') {
                    // Remove the template only if it hasn't been modified
                    if (this.form.prescription_payload.notes.endsWith(this.infusionTemplateText)) {
                        this.form.prescription_payload.notes = this.form.prescription_payload.notes.replace(this.infusionTemplateText, '');
                    }
                }
            }
        },
        emptyDrugList() {
            console.log('EMPTYING DRUG LIST, BLUR');
            this.drugList = []
        },
        // WATCH MIGHT BE INEFFICIENT, MAY NEED A NEW SOLUTION, ALSO UNDEFINED COUNTS AS NEW DATA FOR SOME REASON SO HAD TO FILTER THAT OUT IN 972
        activePresChart(newData, oldData) {
            if (newData != oldData && newData != undefined) {
                // IMPORTANT: Detect variable mode PRIOR to updating the form.
                // This ensures that isVariableMode is true early enough to block 
                // unwanted default schedule generations.
                this.detectVariableMode(newData);
                this.updateForm(newData);

                const payload = newData.prescription_payload;
                if (payload) {
                    // Only the saved frequency decides this - see detectVariableMode().
                    const period = payload.frequency?.period || payload.frequency;
                    if (isVariableValue(period) || isVariableValue(payload.frequency_shorthand) || isVariableValue(payload.frequency)) {

                        // STALE OVERWRITE PROTECTION:
                        // If we are already in variable mode and have local data, we should be 
                        // EXTREMELY cautious about overwriting this.form.prescription_payload.times 
                        // with whatever came from the parent (activePresChart), as it might be stale.
                        const hasLocalData = this.form.prescription_payload.times && this.form.prescription_payload.times.length > 0;
                        
                        this.isVariableMode = true;
                        
                        // Sit the form on a real Variable option. findVariableFrequency falls back
                        // to the client side definition when the facility's list doesn't carry
                        // one - leaving this empty hides the schedule grid, whose v-if requires a
                        // frequency object, and submits an empty frequency_shorthand.
                        this.form.prescription_payload.frequency = findVariableFrequency(this.frequencyOptions);

                        // Reconstruct multi-week schedule ONLY if we don't have local data or it's a forced external update
                        // For the Calendar Builder, we rely on the local component state while editing.
                        if (!hasLocalData || newData.force_update) {
                            let maxWeekIndex = 0;
                            let allDosesFlat = [];
                            let allDosesWithDay = [];
                            if (payload.dose_times) {
                                payload.dose_times.forEach(dayEntry => {
                                    if (dayEntry.times) {
                                        dayEntry.times.forEach(dose => {
                                            let weekIdx = 0;
                                            if (dose.cellId) {
                                                const parts = dose.cellId.split('-');
                                                weekIdx = parts[0] === 'vcell' ? parseInt(parts[1]) : parseInt(parts[0]);
                                            } else if (dose.date) {
                                                const [dStr, mStr, yStr] = dose.date?.split('/')?.map(Number) || [0,0,0];
                                                const doseDate = new Date(yStr, mStr - 1, dStr);
                                                const baseSun = new Date();
                                                baseSun.setHours(0,0,0,0);
                                                baseSun.setDate(baseSun.getDate() - baseSun.getDay());
                                                const diffDays = Math.round((doseDate - baseSun) / (1000 * 60 * 60 * 24));
                                                weekIdx = Math.floor(diffDays / 7);
                                                if (weekIdx < 0) weekIdx = 0;
                                            }
                                            if (weekIdx > maxWeekIndex) maxWeekIndex = weekIdx;
                                            
                                            const doseWithWeek = { ...dose, week: weekIdx };
                                            
                                            // Deduplicate
                                            const exists = allDosesWithDay.some(d => 
                                                d.week === weekIdx && 
                                                d.day === dayEntry.day && 
                                                (d.times?.time === dose.time || d.time === dose.time)
                                            );

                                            if (!exists) {
                                                allDosesFlat.push(doseWithWeek);
                                                allDosesWithDay.push({ 
                                                    day: dayEntry.day, 
                                                    week: weekIdx, 
                                                    times: doseWithWeek 
                                                });
                                            }
                                        });
                                    }
                                });
                            }
                            
                            this.numWeeks = maxWeekIndex + 1;
                            this.schedule_quantity = this.unique(allDosesFlat, 'time');
                            // These are the chart's own saved times, which may differ from its
                            // frequency template - updateDoseSchedule must not overwrite them.
                            this.scheduleTimesCustomised = true;
                            this.form.prescription_payload.times = allDosesWithDay;
                            
                            this.readyToDisplaySchedule = false;
                            setTimeout(() => {
                                this.readyToDisplaySchedule = true;
                                this.$nextTick(() => {
                                    this.populateWeeklySchedule();
                                    this.updateInstructions();
                                });
                            }, 400);
                        }
                    } else if (!this.variableModeSetLocally) {
                        // Only the saved payload is non-variable, which is always true for a chart
                        // the prescriber is still building - convertToVariableDose() sets variable
                        // mode on local state and nothing writes it back into the payload. The
                        // prop is bound to the parent's list item, so any list refresh re-emitted
                        // a fresh object and cleared the calendar the prescriber had just built;
                        // the chart then submitted with the underlying template's period and saved
                        // as daily. Same stale-overwrite protection the variable branch applies.
                        this.isVariableMode = false;
                    }
                }
            }
        },
        checkHeight() {
            this.readHeightMeasurer();
        },
        renewExpired(newData, oldData){
            if(newData != oldData)
            return this.createChart(true, true);
        },
        // formTimes(newData, oldData){
        //     if(newData != oldData){
        //         console.log('form times have been updated');
        //         this.updateFrequencyBasedOnTimeFields();
        //     }
        // }
        // No watcher on form.prescription_payload.frequency. One used to drop out of variable
        // mode whenever the selected frequency wasn't the Variable option, but
        // convertToVariableDose() deliberately keeps the underlying template selected ("Every
        // Morning" stays picked while the calendar is open), so every programmatic reassignment
        // of the frequency silently collapsed a calendar the prescriber had built and the chart
        // saved as daily. A user can't trigger it either way - the frequency dropdown is disabled
        // while isVariableMode is true, and leaving the calendar goes through resetToTemplate().
    },
    mounted() {
        try {
        this.$store.dispatch('getRefreshToken');
        
        // IMPORTANT: Detect variable mode immediately on mount to prevent default schedule resets.
        this.detectVariableMode();

        // Initialize CTG from patient profile if available
        if (this.patient && this.patient.ctg) {
            this.form.prescription_payload.ctg = true;
        }

        if (!this.displayDropDown) {
            let frequency = {
                frequency_name: '',
                interval: this.activePresChart.prescription_payload.interval,
                period: this.activePresChart.prescription_payload.frequency,
                days_of_week: [],
                times: []
            }
            this.schedule_quantity = [];
            this.updateForm(this.activePresChart ? this.activePresChart : '');
            // IF WEEKLY SCHEDULE
            if (this.activePresChart.prescription_payload.dose_times && this.activePresChart.prescription_payload.dose_times.length
                && (this.activePresChart.prescription_payload.dose_times[0].day
                    || this.activePresChart.prescription_payload.dose_times[0].date)) {
                this.weekly_schedule.forEach(day => {
                    this.activePresChart.prescription_payload.dose_times.forEach(item => {
                        if (item.day == day.day) {
                            frequency.days_of_week.push(item.day);
                            day.times = item.times;
                            item.times.forEach(time => {
                                this.schedule_quantity.push(time);
                            })
                        }
                    })
                })
            } else {
                // IF DAILY SCHEDULE
                if (this.activePresChart.prescription_payload.dose_times && this.activePresChart.prescription_payload.dose_times.length && this.activePresChart.prescription_payload.dose_times[0].times) {
                    this.schedule_quantity = this.activePresChart.prescription_payload.dose_times[0].times;
                }
            }
            setTimeout(() => {
                let sched = this.unique(this.schedule_quantity, 'time');
                console.log('getting unique values now', sched)
                this.schedule_quantity = sched;
                // Hydrated from the chart's saved dose_times above (daily or weekly branch), so
                // updateDoseSchedule must not overwrite them with the frequency template's.
                this.scheduleTimesCustomised = this.schedule_quantity.length > 0;
                this.schedule_quantity.forEach(time => {
                    frequency.times.push(time.time);
                })
                console.log('this is the custom frequency created', frequency);
                // if(frequency.period == 'weekly'){
                //     this.populateWeeklySchedule()
                // }

            }, 300)

        } else {
            this.getFrequencies();
        }
        if (this.activeSelectedChart) {
            this.selectedChart = this.activeSelectedChart;
        }

        if (this.draftDrug && (!this.selectedDrug || (!this.selectedDrug.alias_id && !this.selectedDrug.drug_uuid))) {
            this.selectedDrug = this.draftDrug;
            if (this.selectedDrug.generic_name && this.selectedDrug.name) {
                this.selectedDrug.full_name = `(${this.selectedDrug.generic_name}) ${this.selectedDrug.name}`;
            }
        }

        // Silently fetch drugList if we have an existing selected CTPP pack or prescribed_pack_size_id
        if (this.selectedCTPP || (this.activePresChart && this.activePresChart.prescription_payload && (this.activePresChart.prescription_payload.pack_size || this.activePresChart.prescription_payload.prescribed_pack_size_id))) {
            let alias_id = this.selectedDrug.drug_uuid || this.selectedDrug.alias_id;
            if (alias_id && (!this.drugList || this.drugList.length === 0)) {
                this.getAMTMeds(false, true);
            }
        }

        console.log("this is the active prescription chart:" + JSON.stringify(this.activePresChart));
        if (this.activePresChart && this.activePresChart.prescription_payload && this.activePresChart.prescription_payload.start_date){
            this.scheduledMedicine = this.activePresChart.prescription_payload.scheduled; 
            this.form.prescription_payload.start_date = this.dashboardRenew ? new Date().toLocaleString("en-au", { timeZone: "Australia/Sydney" }).slice(0,10) : this.activePresChart.prescription_payload.start_date;
            this.form.prescription_payload.stop_date = this.dashboardRenew ? '' : this.activePresChart.prescription_payload.stop_date;
            
            this.start_date = this.dashboardRenew ? new Date().toLocaleString("en-au", { timeZone: "Australia/Sydney" }).slice(0,10) : this.activePresChart.prescription_payload.start_date;
            this.stop_date = this.dashboardRenew || this.expired ? '' : this.activePresChart.prescription_payload.stop_date;
            this.date_added = this.dashboardRenew ? new Date().toLocaleString("en-au", { timeZone: "Australia/Sydney" }).slice(0,10) : this.activePresChart.prescription_payload.created_date;
            this.form.prescription_payload.route = this.activePresChart.prescription_payload.route;
            this.form.prescription_payload.dose_times = this.activePresChart.prescription_payload.dose_times;
            this.form.prescription_payload.dose_unit = this.activePresChart.prescription_payload.dose_unit;
            this.form.prescription_payload.aslr_consent = this.activePresChart && this.activePresChart.prescription_payload.aslr_consent ? true : false;
            this.form.prescription_payload.ctg = this.activePresChart && this.activePresChart.prescription_payload.ctg ? true : false;
            this.form.prescription_payload.is_extemp = this.activePresChart && this.activePresChart.prescription_payload.is_extemp ? true : false;
            this.form.prescription_payload.privacy_statement = this.activePresChart ? this.activePresChart.prescription_payload.privacy_statement !== false : true;
            this.form.prescription_payload.paper_prescription_number = this.activePresChart.prescription_payload.paper_prescription_number ? this.activePresChart.prescription_payload.paper_prescription_number : this.activePresChart.prescription_payload.is_paper ? '1' : '';
            this.form.prescription_payload.is_paper = this.activePresChart.prescription_payload.is_paper ? true : false;
            this.form.prescription_payload.dose_unit = this.activePresChart.prescription_payload.dose_unit;
            this.form.prescription_payload.max_dose = this.activePresChart.prescription_payload.max_dose;
            this.form.prescription_payload.pbs_manufacturer_code = this.activePresChart.prescription_payload.pbs_manufacturer_code ? this.activePresChart.prescription_payload.pbs_manufacturer_code : '';
            this.form.prescription_payload.max_admin_dose = this.activePresChart.prescription_payload.max_admin_dose;
            this.form.prescription_payload.substitution_not_permitted = this.activePresChart.prescription_payload.substitution_not_permitted ? true : false;
            this.form.prescription_payload.max_times_per_day = this.activePresChart.prescription_payload.max_daily_admin;
            this.last_administration = this.activePresChart.prescription_payload.last_administration ? this.activePresChart.prescription_payload.last_administration : [];

            this.form.prescription_payload.interval = this.activePresChart.prescription_payload.interval != null ? parseInt(this.activePresChart.prescription_payload.interval) : null;
            this.form.prescription_payload.repeat_interval = this.activePresChart.prescription_payload.repeat_interval != null ? parseInt(this.activePresChart.prescription_payload.repeat_interval) : null;
            this.form.prescription_payload.num_repeats_authorised = this.activePresChart.prescription_payload.num_repeats_authorised != null ? parseInt(this.activePresChart.prescription_payload.num_repeats_authorised) : null;
            this.form.prescription_payload.prescribed_pack_size_id = this.activePresChart.prescription_payload.prescribed_pack_size_id ? this.activePresChart.prescription_payload.prescribed_pack_size_id : null;
            this.form.prescription_payload.prescribed_ctpp_id = this.activePresChart.prescription_payload.prescribed_ctpp_id ? this.activePresChart.prescription_payload.prescribed_ctpp_id : null;
            this.selectedCTPP = this.activePresChart.prescription_payload.pack_size ? this.activePresChart.prescription_payload.pack_size : null;
            this.form.prescription_payload.prescribed_quantity = this.activePresChart.prescription_payload.prescribed_quantity;
            this.form.prescription_payload.dose = this.activePresChart.prescription_payload.dose;
            this.form.prescription_payload.notes = this.activePresChart.prescription_payload.notes;
            
            // Populate consent and consent_uuid from existing prescription if available
            // Populate consent and consent_uuid from existing prescription if available
            if (this.activePresChart.prescription_payload.consent && this.activePresChart.prescription_payload.consent !== 'new') {
                let consentFromPayload = this.activePresChart.prescription_payload.consent;
                this.form.prescription_payload.consent_uuid = consentFromPayload.uuid;
                
                if (this.patient?.prescribing_consent?.uuid === consentFromPayload.uuid) {
                    this.form.prescription_payload.consent = this.patient.prescribing_consent;
                } else if (this.patient?.psychotropic_consent?.uuid === consentFromPayload.uuid) {
                    this.form.prescription_payload.consent = this.patient.psychotropic_consent;
                } else {
                    this.form.prescription_payload.consent = consentFromPayload;
                }
            }
            
            // Extract selectedUse from existing notes if present
            if (this.form.prescription_payload.notes) {
                const notes = this.form.prescription_payload.notes;
                const found = this.useOptions.find(option => notes.includes(option));
                if (found) {
                    this.selectedUse = found;
                }
            }
            this.form.prescription_payload.pbs_authority_code = this.activePresChart.prescription_payload.pbs_authority_code;

            // Check ERX status
            this.checkTimeout = setTimeout(() => {
                this.checkPrescription();
            }, 100);
            this.form.prescription_payload.authority_prescription_number = this.activePresChart.prescription_payload.authority_prescription_number ? this.activePresChart.prescription_payload.authority_prescription_number : '';
            this.form.prescription_payload.pbs_code = this.activePresChart.prescription_payload.pbs_code ? this.activePresChart.prescription_payload.pbs_code : '';
            this.form.prescription_payload.pbs_type = this.activePresChart.prescription_payload.pbs_type ?? '';
            this.doseTypes.push(this.form.prescription_payload.dose_unit);
            this.prescriptionType = this.activePresChart?.prescription_payload?.pbs_code ? 'pbs/rpbs' : 'private';
            
            if (this.activePresChart.prescription_payload.frequency_shorthand == 'Stat') {
                this.form.prescription_payload.frequency = this.statFrequency[0];
            }

            // Only the saved frequency decides this - see detectVariableMode().
            const period = this.activePresChart.prescription_payload.frequency?.period || this.activePresChart.prescription_payload.frequency;
            if (isVariableValue(period) || isVariableValue(this.activePresChart.prescription_payload.frequency_shorthand) || isVariableValue(this.activePresChart.prescription_payload.frequency)) {
                this.isVariableMode = true;

                // Sit the form on a real Variable option. findVariableFrequency falls back to the
                // client side definition when the facility's list doesn't carry one - the renewal
                // screens fetch /prescription/frequencies straight through, and an empty frequency
                // here hid the schedule grid (its v-if requires a frequency object) and submitted
                // an empty frequency_shorthand.
                this.form.prescription_payload.frequency = findVariableFrequency(this.frequencyOptions);

                // Reconstruct multi-week schedule
                let maxWeekIndex = 0;
                let allDosesFlat = [];
                let allDosesWithDay = [];
                if (this.activePresChart.prescription_payload?.dose_times) {
                    this.activePresChart.prescription_payload.dose_times.forEach(dayEntry => {
                        dayEntry.times?.forEach(dose => {
                            let weekIdx = 0;
                            if (dose.cellId) {
                                const parts = dose.cellId.split('-');
                                weekIdx = parts[0] === 'vcell' ? parseInt(parts[1]) : parseInt(parts[0]);
                            } else if (dose.date) {
                                const [dStr, mStr, yStr] = dose.date?.split('/')?.map(Number) || [0,0,0];
                                const doseDate = new Date(yStr, mStr - 1, dStr);
                                const baseSun = new Date();
                                baseSun.setHours(0,0,0,0);
                                baseSun.setDate(baseSun.getDate() - baseSun.getDay());
                                const diffDays = Math.round((doseDate - baseSun) / (1000 * 60 * 60 * 24));
                                weekIdx = Math.floor(diffDays / 7);
                                if (weekIdx < 0) weekIdx = 0;
                            }
                            if (weekIdx > maxWeekIndex) maxWeekIndex = weekIdx;
                            
                            const doseWithWeek = { ...dose, week: weekIdx };
                            allDosesFlat.push(doseWithWeek);
                            allDosesWithDay.push({ 
                                day: dayEntry.day, 
                                week: weekIdx, 
                                times: doseWithWeek 
                            });
                        });
                    });
                }
                
                this.numWeeks = maxWeekIndex + 1;
                this.schedule_quantity = this.unique(allDosesFlat, 'time');
                // These are the chart's own saved times, which may differ from its frequency
                // template - updateDoseSchedule must not overwrite them.
                this.scheduleTimesCustomised = true;
                this.form.prescription_payload.times = allDosesWithDay;
                
                this.readyToDisplaySchedule = false;
                setTimeout(() => {
                    this.readyToDisplaySchedule = true;
                    this.$nextTick(() => {
                        this.populateWeeklySchedule();
                        this.updateInstructions();
                    });
                }, 400);
                
            } else if (this.activePresChart.prescription_payload?.frequency_shorthand == 'Stat') {
                this.statDoseTime = this.activePresChart.prescription_payload.dose_times || [];
                this.form.prescription_payload.frequency_shorthand = this.statFrequency[0].frequency_name;
            }

            if (this.activePresChart.prescription_payload?.chart_tags && this.activePresChart.prescription_payload.chart_tags.length) {
                // radio button tags
                this.activePresChart.prescription_payload.chart_tags.forEach(tag=>{
                    this.administration_options.forEach(option=>{
                        if(tag?.name && option?.value?.toLowerCase() == tag.name.toLowerCase()){
                            this.selected_administration_options.push(option)
                        }
                    })
                })
                // dropdown packed/non-pack tag
                this.activePresChart.prescription_payload.chart_tags.forEach(tag=>{
                    this.packing_options.forEach(option=>{
                        if(tag?.name && option?.value?.toLowerCase() == tag.name.toLowerCase()){
                            this.selected_packing = {label: option.label, value: option.value}
                        }
                    })
                })
            }
            
            axios.post('/get-pbs', { alias_id: this.activePresChart.prescription_payload.drug_uuid }, this.$store.state.header).then(res => {
                console.log('THESE ARE THE PBS DETAILS');
                this.loading_pbs = false;
                this.pbs_codes = res.data;
                this.flattenPBSCodes();
            })

            if (this.activePresChart.prescription_payload.pbs_code) {
                this.pbsFilter = 'pbs';
            }

            // The saved chart's own dose times, which may differ from its frequency template.
            // Without this the updateDoseSchedule() below rebuilds the grid from the template, so
            // a chart saved at 1500 opens - and re-saves - as the template's 0800.
            const savedTimes = (this.activePresChart.prescription_payload.dose_times || []).flatMap(d => d.times || []);
            if (savedTimes.length) {
                this.schedule_quantity = this.unique(savedTimes.map(t => ({ ...t })), 'time');
                this.scheduleTimesCustomised = true;
            }
            if (!this.isVariableMode) {
                // this.form.prescription_payload.frequency = this.activePresChart.prescription_payload.frequency;
                console.log('this is the frequency options and shortname', this.frequencyOptions.length, this.activePresChart.prescription_payload, this.activePresChart.prescription_payload.frequency_shorthand);
                if (this.frequencyOptions.length && this.activePresChart.prescription_payload.frequency_shorthand) {
                    if (this.activePresChart.chart_payload.chart_form.type != 'stat') {
                        this.frequencyOptions.forEach(option => {
                            if (option?.frequency_name?.toLowerCase() == this.activePresChart.prescription_payload.frequency_shorthand?.toLowerCase()) {
                                this.form.prescription_payload.frequency = option;
                                this.form.prescription_payload.frequency_shorthand = this.activePresChart.prescription_payload.frequency_shorthand;
                                console.log('matched frequency name and shortname');
                                // Weekly charts keep their saved days and per-day quantities;
                                // updateDoseSchedule() would redraw them from the template.
                                const savedDoseTimes = this.activePresChart.prescription_payload.dose_times || [];
                                if (savedDoseTimes.length && savedDoseTimes[0].day) {
                                    this.hydrateWeeklyScheduleFromSaved(savedDoseTimes);
                                } else {
                                    this.updateDoseSchedule();
                                }
                            }
                        })
                        this.displayPRNSliding = true;
                        if (this.activePresChart.prescription_payload.sliding_scale && this.activePresChart.prescription_payload.sliding_scale.length) {
                            this.sliding = true;
                            this.form.prescription_payload.sliding_scale = this.activePresChart.prescription_payload.sliding_scale;
                            
                            // Initialize dropdown from the loaded sliding scale
                            let scaleName = this.form.prescription_payload.sliding_scale[0].name;
                            if (scaleName) {
                                let foundType = this.slidingScaleTypes.find(type => type.unit === scaleName || type.label === scaleName || type.label.toLowerCase() === scaleName.toLowerCase());
                                if (foundType) {
                                    this.slidingScaleType = foundType;
                                }
                            }
                        }
                    } else {
                        console.log('this is the else - stat frequency before');
                        this.form.prescription_payload.frequency = this.statFrequency[0];
                        this.readyToDisplaySchedule = true;
                        console.log('this is the else - stat frequency after', this.form.prescription_payload.frequency, this.statFrequency[0]);
                    }
                }
            }
        }

        if (this.activePresChart && this.activePresChart.chart_payload && this.activePresChart.chart_payload.chart_form && this.activePresChart.chart_payload.chart_form.indication) {
            this.form.prescription_payload.indication = this.activePresChart.chart_payload.chart_form.indication.text;
        }

        this.formTimes = {
            time1: '',
        }

        this.searchedDrugName = '';
        this.prescription_sign_payload.prescription_id = this.form.chart_payload.prescription_id
        this.prescription_sign_payload.is_paper = this.form.prescription_payload.is_paper ? true : false;
        if (this.isTransitionalConformance) {
            this.prescription_sign_payload.no_erx = true;
            this.form.prescription_payload.no_erx = true; // Inject to creation payload as well just in case backend expects it on the draft entity too
        }
        console.log('this is the active pres chart', this.displayDropDown);
        // console.log('this is the height', this.$refs['height-measurer' + this.parentIndex].clientHeight);
        console.log('IS IN THE REVIEW', this.reviewed);
        console.log('THIS IS THE FORM BEING MOUNTED', this.form)
        this.addedToReview = this.reviewed;
        this.getSunday();

        switch (JSON.parse(localStorage.getItem('currentLocation')).state) {
            case 'WA':
                this.authorisationReferenceNumberLabel = 'Authority Number';
                break;
            case 'TAS':
                this.authorisationReferenceNumberLabel = 'Authority Number';
                break;
            case 'NSW':
                this.authorisationReferenceNumberLabel = 'Authorisation Number';
                break;
            case 'NT':
                this.authorisationReferenceNumberLabel = 'Authorisation Number';
                break;
            case 'ACT':
                this.authorisationReferenceNumberLabel = 'Approval Number';
                break;
            case 'QLD':
                this.authorisationReferenceNumberLabel = 'Approval Number';
                break;
            case 'VIC':
                this.authorisationReferenceNumberLabel = 'Warrant Number';
                break;
            case 'SA':
                this.authorisationReferenceNumberLabel = 'Permit Number';
                break;
        }

        if(this.renewExpired){
            this.createChart(true, true);
        }

        // this.$parent.$on('triggerRenew', () => {
        //     console.log('Child received event from parent');
        // });

        this.algoliaDoseUnitSearch();
        } catch (err) {
            alert("PRESCRIPTION CHART MOUNT CRASH:\n" + err.stack);
            console.error(err);
        }
    },
}
</script>


<style lang="scss">
@import "../assets/css/main.scss";


.prescription-chart {
    .p-selectbutton .p-button {
        flex: none !important; 
        padding: 0 4px !important;
    }
}

.prescriber-options-container{
  display: flex;
  margin-top: 10px !important;
//   padding: 0 10px ;
}

.first-chart-row{
    margin-top: 10px;
}

.prescription-chart {
    .chart-row-item {
        border: none;
        flex-wrap: wrap;
        justify-items: flex-start;
        min-width: 697px;
        align-items: flex-end;
        input {
            border: 1px solid #BDC4C4;
            background-color: white;
            // width: 14em;
            // min-width: 140px;
            width: 160px;
        }

        .p-dropdown,
        .p-multiselect {
            margin-left: 10px;
            width: 160px;
            text-align: left;
        }
        p{
            font-size: 1em; 
            font-weight: 500;
        }
    }

    .toggle-switch {
        padding: 0px;
    }
}

.p-dropdown-label {
    padding: 5px;
}

.p-dropdown,
.p-multiselect {
    padding: 0px !important;
}

#reason-input-container {
    .p-inputtext {
        width: 25em;
    }
}

.ctpp-dropdown {
    background-color: white !important;
    .p-inputtext {
        background-color: white !important;
    }
}

.active-selected-chart {

    .p-dropdown-label,
    .p-dropdown-trigger {
        color: white !important;
        font-weight: bold;
    }
}

.dynamic-number-input {
    .p-inputnumber-input {
        min-width: 50px !important;
        width: 50px;
    }
}

.expansionFormat {
    .chart-form-select {
        background-color: transparent !important;
    }

    display: grid !important;
    grid-template-columns: 1fr 1fr;

    input {
        background-color: white !important;
    }
}

.toggle-switch-item {
    margin-top: 0 !important;
}

.schedule-table {
    // border: 1px solid grey;
    border-collapse: collapse;
    border-radius: 4px;
    padding: 0;

    th,
    td {
        text-align: center;
        font-size: 0.9em;
        border-right: 1px solid #BDC4C4;
    }

    input {
        min-width: 50px !important;
        width: 60px !important;
        margin: 0 6px !important;
    }

    th:nth-last-child(1) {
        border-right: none !important;
    }

    td:nth-last-child(1) {
        border-right: none !important;
    }

}

.schedule-input {
    .p-inputnumber-input {
        background-color: white;
    }
}

.blue-input {
    background-color: $strongblue !important;
    color: white !important;
    font-weight: bold !important;
    text-align: center;
}

.administration-select-buttons {
    display: flex;
    border: none !important;

    .p-button.p-component {
        margin-right: 8px !important;
        border: 1px solid #BDC4C4 !important;
        border-right: 1px solid #BDC4C4 !important;
        border-radius: 7px !important;
        padding: 6px !important;
        width: 25%;
        height: 38px !important;
    }
    .p-button.p-component:last-child{
        margin-right: 0 !important;
    }

}

.drug-image {
    padding-left: 15px;

    img {
        max-height: 100px;
        max-width: 120px;
        width: auto;
        height: auto;
    }
}

.p-buttonset {
    border: 1px solid #BDC4C4;
    border-radius: 6px;

    .p-button.p-component {
        border: none;
    }

    .p-highlight {
        background-color: #0870DC !important;
        font-weight: bold !important;
        border-radius: 5px !important;
    }
}

.p-togglebutton {
    border: 1px solid #BDC4C4 !important;
    border-right: 1px solid #BDC4C4 !important;
    border-radius: 7px !important;
    padding: 10px !important;
    width: fit-content;
    min-width: 190px !important;
    height: 38px !important;
}

.p-togglebutton.p-button.p-highlight {
    background-color: #0870DC !important;
    font-weight: bold !important;
}

.p-component.p-disabled{
    opacity: 1 !important;
}

#selectchart{
    width: 698px;
}

.sign-off-item {
    h4 {
        margin-bottom: 0;
        text-align: left;
    }
    button {
        width: 100%;
    }
}
.approval-container {
    display: flex;
    flex-direction: column;
    margin-left: 3em;
    p{
        font-size: 1em !important; 
        font-weight: 500 !important
    }
    h2 {
        margin-bottom: 0;
    }
}
.chart-approval {
    display: flex;
    justify-content: flex-end;
    margin-top: 1em;
    width: 707px;
}
.valid-prescription-notes {
    margin-top: 10px;
    background-color: white;
    padding: 10px;
    border-radius: 12px;
    h4 {
        margin-top: 0;
    }
}
.prescriber-options-container {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    // margin: 10px;
    justify-content: space-between;
    width: 697px;
}
.prescriber-options-item {
    border: 2px solid $strongblue;
    width: fit-content;
    margin: 0;
    p {
        width: fit-content !important;
        margin: 0;
        border-radius: 6px;
        padding: 5px 25px;
        font-weight: bold;
        background-color: white;
    }
}
.chart-form-select {
    background-color: white !important;
    border: none !important;
    width: 90%;
    min-width: 10em;
}
.toggle-switch {
    // padding: 5px 10px;
    display: flex;
    border-radius: 4px;
    align-items: center;
    align-self: center;
    margin: 5px;
}
.toggle-switch-item {
    font-weight: bold;
    width: 115px;
    margin: 0;
    padding: 5px;
    cursor: pointer;
}
.chart-form-container {
    h4 {
        color: white;
        font-size: 1.3em;
        margin: 0;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
        padding: 10px 25px;
        height: 43px;
    }
    border-radius: 12px;
    min-width: 707px;
}
.first-chart-row {
    height: 107px;
}
.chart-row {
    display: flex;
    width: 100%;
}
.first-chart-row-item {
    border-top: none !important;
    display: flex;
    align-items: center !important;
    input::placeholder {
        color: black !important;
        font-weight: normal !important;
    }
    input {
        width: 100%;
    }
}
.chart-row-item {
    border-right: 1px solid $bordergrey;
    border-top: 1px solid $bordergrey;
    display: flex;
    width: 100%;
    flex: 1;
    min-height: 60px;
    align-items: flex-end;
    // justify-content: center;
    input {
        min-width: 150px;
        background-color: white;
        margin: 0 10px;
    }
    input::placeholder {
        color: #101820;
        font-weight: 300;
    }
}
.chart-row-item:last-child {
    border-right: none !important;
}
.chart-form {
    background-color: white;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
}
.create-chart-container {
    margin-top: 4em;
}
.chart-form-approval-container {
    display: flex;
}
.charts-menu-container {
    display: flex;
    flex-wrap: wrap;
}
.charts-menu-item {
    color: white;
    width: fit-content;
    min-width: 255px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    margin: 10px;
    height: 50px;
    padding: 5px 35px;
    border-radius: 12px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.05);
    h4,
    p {
        margin: 0;
    }
    h4 {
        font-size: 0.9em;
    }


}

div.p-dropdown-items-wrapper:has(#selectchart_list) {
    max-height: 700px !important;
}

</style>
